import { StaticData } from "./types";

export const FLIGHT_STATIC_DATA_MOCK: StaticData = {
  airlineMap: {
    "API-test1-84": {
      airlineCode: "API-test1-84",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    VN: {
      airlineCode: "VN",
      airlineName: "Vietnam Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2019/05/08/1557290600699-764c7b7002f595ef5b5c0178a302cadb.png?tr=q-75",
    },
    "2L": {
      airlineCode: "2L",
      airlineName: "Helvetic Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IG: {
      airlineCode: "IG",
      airlineName: "Air Italy",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    V7: {
      airlineCode: "V7",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PN: {
      airlineCode: "PN",
      airlineName: "West Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    F7: {
      airlineCode: "F7",
      airlineName: "Darwin Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BX: {
      airlineCode: "BX",
      airlineName: "Air Busan",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    ZZ: {
      airlineCode: "ZZ",
      airlineName: "Supply Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    W5: {
      airlineCode: "W5",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    NK: {
      airlineCode: "NK",
      airlineName: "Spirit Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G17: {
      airlineCode: "G17",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TW: {
      airlineCode: "TW",
      airlineName: "T’way Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    LS: {
      airlineCode: "LS",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    FI: {
      airlineCode: "FI",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212532258-e6d038ac3c2ce53bf8c70b8d4a1b68ae.png?tr=q-75",
    },
    QR: {
      airlineCode: "QR",
      airlineName: "Qatar Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350567476-e63b42995391b256f2896458731525d5.png?tr=q-75",
    },
    JW: {
      airlineCode: "JW",
      airlineName: "Vanilla Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "8Q": {
      airlineCode: "8Q",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    QA: {
      airlineCode: "QA",
      airlineName: "Cimber A/S",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MZ: {
      airlineCode: "MZ",
      airlineName: "Merpati",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PK: {
      airlineCode: "PK",
      airlineName: "Pakistan International Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350533696-7321ef42e55ccdb02539f1534a99c33e.png?tr=q-75",
    },
    NH: {
      airlineCode: "NH",
      airlineName: "All Nippon Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350490730-382d5b8d8b7c9fe2b0429822661832a2.png?tr=q-75",
    },
    GF: {
      airlineCode: "GF",
      airlineName: "Gulf Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466062888128-2db04e38f8ce05bdbf7e36d1c8e096b8.png?tr=q-75",
    },
    "API-test-upsert": {
      airlineCode: "API-test-upsert",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    WE: {
      airlineCode: "WE",
      airlineName: "Thai Smile",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/11/10/1478754989375-3d79630f8eee7b1722ef3d56e161ff39.png?tr=q-75",
    },
    G9: {
      airlineCode: "G9",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "6E": {
      airlineCode: "6E",
      airlineName: "IndiGo",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PR: {
      airlineCode: "PR",
      airlineName: "Philippine Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350541035-6d1d48a8f2b8d8d4f90e254272e69fee.png?tr=q-75",
    },
    VA: {
      airlineCode: "VA",
      airlineName: "Virgin Australia Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/01/04/1451904376248-9a0e5f621cb707df51958b503a1729b0.png?tr=q-75",
    },
    CL: {
      airlineCode: "CL",
      airlineName: "Lufthansa CityLine",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    K7: {
      airlineCode: "K7",
      airlineName: "AIR KBZ",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G11: {
      airlineCode: "G11",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    ET: {
      airlineCode: "ET",
      airlineName: "Ethiopian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212488799-dfd839a251f134922449bb8d43ede771.png?tr=q-75",
    },
    CT: {
      airlineCode: "CT",
      airlineName: "Alitalia Cityliner",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    JO: {
      airlineCode: "JO",
      airlineName: "Jet Time A/S",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    CZ: {
      airlineCode: "CZ",
      airlineName: "China Southern Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349261477-e2cbf221721f41b83b5a65a6a3c2a866.png?tr=q-75",
    },
    SN: {
      airlineCode: "SN",
      airlineName: "Brussels Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    FD: {
      airlineCode: "FD",
      airlineName: "AirAsia ",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349732337-846058ee22c4a13a3480597eae37b329.png?tr=q-75",
    },
    VB: {
      airlineCode: "VB",
      airlineName: "VivaAerobus",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    ZA: {
      airlineCode: "ZA",
      airlineName: "Sky Angkor Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TVLK: {
      airlineCode: "TVLK",
      airlineName: "Traveloka Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    VJ: {
      airlineCode: "VJ",
      airlineName: "VietJet Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350670702-a9dba44d3e9fe096f83ffe00d56a99ec.png?tr=q-75",
    },
    "API-test-insert": {
      airlineCode: "API-test-insert",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AM: {
      airlineCode: "AM",
      airlineName: "Aeromexico",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MI: {
      airlineCode: "MI",
      airlineName: "Silk Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350419177-36ee4b5cfa8dd2f6880f57b442f5f1c0.png?tr=q-75",
    },
    EK: {
      airlineCode: "EK",
      airlineName: "Emirates",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349712954-072646ca207d5739f8199ef14e6a6464.png?tr=q-75",
    },
    S7: {
      airlineCode: "S7",
      airlineName: "S7 Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/12/05/1480928191942-1fb317cdc347a6b58262be63d1ea51b9.png?tr=q-75",
    },
    IJ: {
      airlineCode: "IJ",
      airlineName: "Spring Airlines Japan",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    F0: {
      airlineCode: "F0",
      airlineName: "FlyJaya",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2025/04/22/1745302871665-e2c36e0a1d5ec04dce01bae95034f6f7.png?tr=q-75",
    },
    KY: {
      airlineCode: "KY",
      airlineName: "Kunming Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    WN: {
      airlineCode: "WN",
      airlineName: "Southwest Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SJ: {
      airlineCode: "SJ",
      airlineName: "Sriwijaya Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350585706-c2c7def9f92885f1c73292e89aeafb8a.png?tr=q-75",
    },
    "API-test4-7": {
      airlineCode: "API-test4-7",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    GK: {
      airlineCode: "GK",
      airlineName: "Jetstar Japan",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KL: {
      airlineCode: "KL",
      airlineName: "KLM",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350304946-fec000116e207afbe22adbc30277b958.png?tr=q-75",
    },
    W6: {
      airlineCode: "W6",
      airlineName: "Wizz Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KD: {
      airlineCode: "KD",
      airlineName: "Kalstar Aviation",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349889378-bdc5a4408f2cc1a82faf15c4692be392.png?tr=q-75",
    },
    KQ: {
      airlineCode: "KQ",
      airlineName: "Kenya Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350311054-26c908083554d0bb63375d4313742bb5.png?tr=q-75",
    },
    "5J": {
      airlineCode: "5J",
      airlineName: "Cebu Pacific",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349128712-339bd249975f07a72e9c38b33efae65d.png?tr=q-75",
    },
    "API-test1-58": {
      airlineCode: "API-test1-58",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G7: {
      airlineCode: "G7",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IB: {
      airlineCode: "IB",
      airlineName: "Iberia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SV: {
      airlineCode: "SV",
      airlineName: "Saudi Arabian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/02/18/1455792481383-2156667c9fc9ca9a12659b284fa7cb82.png?tr=q-75",
    },
    IT: {
      airlineCode: "IT",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "8L": {
      airlineCode: "8L",
      airlineName: "Lucky Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    B7: {
      airlineCode: "B7",
      airlineName: "Uni Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    YT: {
      airlineCode: "YT",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    HO: {
      airlineCode: "HO",
      airlineName: "Juneyao Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838495199-0f1a98a02d34689525de8a888c30bc8e.png?tr=q-75",
    },
    QZ: {
      airlineCode: "QZ",
      airlineName: "AirAsia Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2018/09/24/1537789908901-c6e710a9db65aaf3ba5c0703d0352706.png?tr=q-75",
    },
    EH: {
      airlineCode: "EH",
      airlineName: "Ana Wings",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KR: {
      airlineCode: "KR",
      airlineName: "Cambodia Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IP: {
      airlineCode: "IP",
      airlineName: "Pelita  Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/08/22/1724324733146-8338e73a41c7061000909dd5442610a2.png?tr=q-75",
    },
    YS: {
      airlineCode: "YS",
      airlineName: "Regional",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MU: {
      airlineCode: "MU",
      airlineName: "China Eastern Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350449957-0a65e1d165c5a93e1d31080ebea2d0f3.png?tr=q-75",
    },
    ZG: {
      airlineCode: "ZG",
      airlineName: "ZIPAIR",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "3K": {
      airlineCode: "3K",
      airlineName: "Jetstar Asia Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/06/09/1623228389933-4623ead980100ac9924a67364d325d8d.png?tr=q-75",
    },
    JT: {
      airlineCode: "JT",
      airlineName: "Lion Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349861201-09ec8f298222a73d66e8e96aa3b918f0.png?tr=q-75",
    },
    KE: {
      airlineCode: "KE",
      airlineName: "Korean Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350298291-662d425ad7771e0ce8639643236d504a.png?tr=q-75",
    },
    UL: {
      airlineCode: "UL",
      airlineName: "SriLankan Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350657339-c5cd4da59bdaadde97a9005f2983df83.png?tr=q-75",
    },
    RI: {
      airlineCode: "RI",
      airlineName: "Tigerair Mandala",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TG: {
      airlineCode: "TG",
      airlineName: "Thai Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350630820-bbd9a0bd09a8ad9bdd8f02709cbddd32.png?tr=q-75",
    },
    Z9: {
      airlineCode: "Z9",
      airlineName: "MY Airline",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "API-test1-4": {
      airlineCode: "API-test1-4",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KS: {
      airlineCode: "KS",
      airlineName: "FlyJaya",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2025/06/16/1750038832777-486f721b55ab9b1cca18f5ebd1f99369.png?tr=q-75",
    },
    SJx: {
      airlineCode: "SJx",
      airlineName: "Sriwijaya Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    XW: {
      airlineCode: "XW",
      airlineName: "Nok Scoot Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2018/10/30/1540902099998-f38bc5dd0d324bc54ce2472171a8a4c9.png?tr=q-75",
    },
    BS: {
      airlineCode: "BS",
      airlineName: "US-Bangla",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AC: {
      airlineCode: "AC",
      airlineName: "Air Canada",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/02/18/1455792445950-a037533665894a6b769a7a0db5bf6b5b.png?tr=q-75",
    },
    OZ: {
      airlineCode: "OZ",
      airlineName: "Asiana Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350520772-dddfedaf401fb4f0b91303dbce757332.png?tr=q-75",
    },
    A3: {
      airlineCode: "A3",
      airlineName: "Aegean Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    QF: {
      airlineCode: "QF",
      airlineName: "Qantas",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350553121-8f13ff00d5cfc13a88d161950e639752.png?tr=q-75",
    },
    NX: {
      airlineCode: "NX",
      airlineName: "Air Macau",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350504235-a68ec9afb3c16b3a190e382a78103fb8.png?tr=q-75",
    },
    BT: {
      airlineCode: "BT",
      airlineName: "Air Baltic",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "API-test4-97": {
      airlineCode: "API-test4-97",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AirAsia: {
      airlineCode: "AirAsia",
      airlineName: "AirAsia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349174390-23151020ad74cd0811255b320fcea754.png?tr=q-75",
    },
    JQ: {
      airlineCode: "JQ",
      airlineName: "Jetstar",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349850619-974acdfa8d5d889d507515772ad20519.png?tr=q-75",
    },
    WK: {
      airlineCode: "WK",
      airlineName: "Edelweiss Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IL: {
      airlineCode: "IL",
      airlineName: "Trigana Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/12/27/1482845148999-c4273ca0398aa949d7c6d23cee5ecb5a.png?tr=q-75",
    },
    HU: {
      airlineCode: "HU",
      airlineName: "Hainan Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838504156-f50a5415ad126175f2a81dc7b035bdaf.png?tr=q-75",
    },
    H9: {
      airlineCode: "H9",
      airlineName: "Himalaya Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BI: {
      airlineCode: "BI",
      airlineName: "Royal Brunei Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349207893-bf233b5a36557c771998ceb952980a00.png?tr=q-75",
    },
    TZ: {
      airlineCode: "TZ",
      airlineName: "Scoot",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350650431-61e6f6fe6727076f738748c9cfc8a5a1.png?tr=q-75",
    },
    MK: {
      airlineCode: "MK",
      airlineName: "Air Mauritius",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212679713-6cf2a60f750475bffa87e23eff8ababc.png?tr=q-75",
    },
    NZ: {
      airlineCode: "NZ",
      airlineName: "Air New Zealand",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/02/18/1455792452754-aa4e588bf606e8311e4510703f499b84.png?tr=q-75",
    },
    G1: {
      airlineCode: "G1",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    Z2: {
      airlineCode: "Z2",
      airlineName: "AirAsia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2018/09/24/1537789922627-bc1de3040c7ecde85a3deae29138cb20.png?tr=q-75",
    },
    PC: {
      airlineCode: "PC",
      airlineName: "Pegasus Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AB: {
      airlineCode: "AB",
      airlineName: "Air Berlin",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/05/16/1463384761453-d92185941202733401b53fef6136715f.png?tr=q-75",
    },
    "3U": {
      airlineCode: "3U",
      airlineName: "Sichuan Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450348463370-30d20812194fa653b512cfbacff6875b.png?tr=q-75",
    },
    "0B": {
      airlineCode: "0B",
      airlineName: "BBN Airlines Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/12/26/1735195600720-3cec6e3d10c00cb25c263ee56f562449.png?tr=q-75",
    },
    QH: {
      airlineCode: "QH",
      airlineName: "Bamboo Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2020/01/21/1579594982929-47e5c2008476fcf5d509616a74c71e88.png?tr=q-75",
    },
    FR: {
      airlineCode: "FR",
      airlineName: "Ryanair",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SI: {
      airlineCode: "SI",
      airlineName: "Susi Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2020/03/05/1583384534966-590eddaf98e351e5e13a3d4fcefb83e1.png?tr=q-75",
    },
    VU: {
      airlineCode: "VU",
      airlineName: "Vietravel Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/02/25/1614223651972-77f6a538e2b6723ae868909456e546dc.png?tr=q-75",
    },
    FY: {
      airlineCode: "FY",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349744161-20cb32ac2cf14426079d199981323e30.png?tr=q-75",
    },
    HA: {
      airlineCode: "HA",
      airlineName: "Hawaiian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    OS: {
      airlineCode: "OS",
      airlineName: "Austrian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466063345938-57f6929c3f6fba856c914c98a8c2788f.png?tr=q-75",
    },
    KI: {
      airlineCode: "KI",
      airlineName: "SKS Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    LX: {
      airlineCode: "LX",
      airlineName: "Swiss International Air Lines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350324733-42132d4ad6ede9f42f9b0b8cac2ee7c2.png?tr=q-75",
    },
    WX: {
      airlineCode: "WX",
      airlineName: "CityJet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    VZ: {
      airlineCode: "VZ",
      airlineName: "Thai VietJet Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/09/09/1473421526447-72c2a0e771360c4aee417bc874914f4e.png?tr=q-75",
    },
    "0V": {
      airlineCode: "0V",
      airlineName: "Vietnam Air Services Company",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    JU: {
      airlineCode: "JU",
      airlineName: "Air Serbia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    VX: {
      airlineCode: "VX",
      airlineName: "Virgin America",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "7G": {
      airlineCode: "7G",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    UA: {
      airlineCode: "UA",
      airlineName: "United Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212809472-461429ef97e01775401cfb5e54b58c54.png?tr=q-75",
    },
    JL: {
      airlineCode: "JL",
      airlineName: "JapanAirlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349813952-78c3d4dc0889e1ec3abb288700f55db6.png?tr=q-75",
    },
    RA: {
      airlineCode: "RA",
      airlineName: "Nepal Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466063383894-8e6599cb7fe28bea6888e9ffc14ee06f.png?tr=q-75",
    },
    KC: {
      airlineCode: "KC",
      airlineName: "Air Astana",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212614189-503460adf1b13a9ca7e18f4a51cff44d.png?tr=q-75",
    },
    GX: {
      airlineCode: "GX",
      airlineName: "GX Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    HD: {
      airlineCode: "HD",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G12: {
      airlineCode: "G12",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    CX: {
      airlineCode: "CX",
      airlineName: "Cathay Pacific",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/11/17/1479375081019-abaa527e23bc56424390edf666c9055e.png?tr=q-75",
    },
    "API-test5-78": {
      airlineCode: "API-test5-78",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AY: {
      airlineCode: "AY",
      airlineName: "Finnair",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/05/16/1463384807854-5e09e7d6fb464fe17e2125f89998463b.png?tr=q-75",
    },
    QG: {
      airlineCode: "QG",
      airlineName: "Citilink",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350561012-6584b693edd67d75cfc25ecff41c5704.png?tr=q-75",
    },
    "3A": {
      airlineCode: "3A",
      airlineName: "Chu Kong Passenger Transport",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "6J": {
      airlineCode: "6J",
      airlineName: "Solaseed Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G19: {
      airlineCode: "G19",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G18: {
      airlineCode: "G18",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    ID: {
      airlineCode: "ID",
      airlineName: "Batik Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349791362-98a47a65885f8cf389b32113f69da413.png?tr=q-75",
    },
    EI: {
      airlineCode: "EI",
      airlineName: "Aer Lingus",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AK: {
      airlineCode: "AK",
      airlineName: "AirAsia  ",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/20/1466418524477-74783a39da2dd0391ca3e5afba4edf10.png?tr=q-75",
    },
    G13: {
      airlineCode: "G13",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    CA: {
      airlineCode: "CA",
      airlineName: "Air China",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349223955-21921640c1361b15fbe1fa8bc361b583.png?tr=q-75",
    },
    XN: {
      airlineCode: "XN",
      airlineName: "Xpress Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350696872-9e712c3bdc8e94e56df29958ebbd4a5e.png?tr=q-75",
    },
    UU: {
      airlineCode: "UU",
      airlineName: "Air Austral",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466063500612-e32a44c9c63aa7101dd9c717406b567a.png?tr=q-75",
    },
    QD: {
      airlineCode: "QD",
      airlineName: "JC International Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G20: {
      airlineCode: "G20",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MV: {
      airlineCode: "MV",
      airlineName: "Aviastar Mandiri",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350476940-9bc83b384c13a35386c4fe65d277ecee.png?tr=q-75",
    },
    LO: {
      airlineCode: "LO",
      airlineName: "Lot Polish Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    ZH: {
      airlineCode: "ZH",
      airlineName: "Shenzhen Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350702726-99b61e06121e2d0445df38918701d0c9.png?tr=q-75",
    },
    RQ: {
      airlineCode: "RQ",
      airlineName: "Kam Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G10: {
      airlineCode: "G10",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AS: {
      airlineCode: "AS",
      airlineName: "Alaska Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    LH: {
      airlineCode: "LH",
      airlineName: "Lufthansa",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/11/17/1479375113352-2bba90a19e55790d062cbff867ee5457.png?tr=q-75",
    },
    H1: {
      airlineCode: "H1",
      airlineName: "Hanh Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BG: {
      airlineCode: "BG",
      airlineName: "Biman Bangladesh Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838474518-373d4e461442327a7612ec1a496417f8.png?tr=q-75",
    },
    TP: {
      airlineCode: "TP",
      airlineName: "TAP Air Portugal",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466063457120-118c5762672923197487e3a72496e7a8.png?tr=q-75",
    },
    U2: {
      airlineCode: "U2",
      airlineName: "easyJet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AE: {
      airlineCode: "AE",
      airlineName: "Mandarin Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    RJ: {
      airlineCode: "RJ",
      airlineName: "Royal Jordanian",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838553483-5547d7cd6aeb55303ffa12482a8c50d9.png?tr=q-75",
    },
    MASWINGS: {
      airlineCode: "MASWINGS",
      airlineName: "MASwings",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    FW: {
      airlineCode: "FW",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MS: {
      airlineCode: "MS",
      airlineName: "EgyptAir",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350440116-f6b96e9763fa410fb01b773becf7511c.png?tr=q-75",
    },
    OM: {
      airlineCode: "OM",
      airlineName: "MIAT Mongolian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    QV: {
      airlineCode: "QV",
      airlineName: "Lao Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212747713-2110f3b9f5eb556fa6d3b8d935df92a1.png?tr=q-75",
    },
    DB: {
      airlineCode: "DB",
      airlineName: "Brit Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "9C": {
      airlineCode: "9C",
      airlineName: "Spring Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/10/11/1633939439024-0c5ba7ea92ef8bf603ff1a52bf617889.png?tr=q-75",
    },
    SK: {
      airlineCode: "SK",
      airlineName: "Scandinavian Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/16/1466063425211-b78f09bb76c205ff1350ec057b29b014.png?tr=q-75",
    },
    FZ: {
      airlineCode: "FZ",
      airlineName: "flydubai",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PX: {
      airlineCode: "PX",
      airlineName: "Air Niugini",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350546972-06e91e77e7bc52674be4648a8cc97b41.png?tr=q-75",
    },
    NS: {
      airlineCode: "NS",
      airlineName: "Hebei Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SY: {
      airlineCode: "SY",
      airlineName: "Sun Country Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350624842-08eb51931d641b2040395dfc515b63ac.png?tr=q-75",
    },
    LY: {
      airlineCode: "LY",
      airlineName: "El Al Israel Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G15: {
      airlineCode: "G15",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    JD: {
      airlineCode: "JD",
      airlineName: "Beijing Capital Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PS: {
      airlineCode: "PS",
      airlineName: "Ukraine International Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/06/1465212717591-3fa063afb9e692f9779da5085946eb6f.png?tr=q-75",
    },
    "8B": {
      airlineCode: "8B",
      airlineName: "TransNusa",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2022/05/05/1651724468295-f091f5107dc312a071797ad89ff87410.png?tr=q-75",
    },
    AQ: {
      airlineCode: "AQ",
      airlineName: "9 Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IN: {
      airlineCode: "IN",
      airlineName: "NAM Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/10/21/1729498740641-e1a9ef752aa4467adb8a37af5f982865.jpeg?tr=q-75",
    },
    KA: {
      airlineCode: "KA",
      airlineName: "Dragon Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/04/1459765805039-dc44f0f7b15562c79a8d5984d36a6aa0.png?tr=q-75",
    },
    ZL: {
      airlineCode: "ZL",
      airlineName: "Regional Express",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BE: {
      airlineCode: "BE",
      airlineName: "Flybe",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MH: {
      airlineCode: "MH",
      airlineName: "Malaysia Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350412847-3992f7771a86e8e878338cd31c390786.png?tr=q-75",
    },
    AN: {
      airlineCode: "AN",
      airlineName: "Airlinair",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G2: {
      airlineCode: "G2",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TDM: {
      airlineCode: "TDM",
      airlineName: "Ariph Satyanagara",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    FJ: {
      airlineCode: "FJ",
      airlineName: "Fiji Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G8: {
      airlineCode: "G8",
      airlineName: "Go Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    Y6: {
      airlineCode: "Y6",
      airlineName: "Batavia Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MF: {
      airlineCode: "MF",
      airlineName: "Xiamen Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350405567-f0c572c8fecaa46b3a4127b8cb148cbf.png?tr=q-75",
    },
    HY: {
      airlineCode: "HY",
      airlineName: "Uzbekistan Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/12/05/1480928160942-cfd4ffe484e57fdfe8c391eeca10d5d5.png?tr=q-75",
    },
    "8M": {
      airlineCode: "8M",
      airlineName: "Myanmar Airways International",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838449365-b0de71b97fe3ed21c471acc11236a0a6.png?tr=q-75",
    },
    IW: {
      airlineCode: "IW",
      airlineName: "Wings Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349805026-5fecb4ceb5f79e38f2a5ae50f33b813e.png?tr=q-75",
    },
    HB: {
      airlineCode: "HB",
      airlineName: "Greater Bay Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    XJ: {
      airlineCode: "XJ",
      airlineName: "Thai Air Asia X",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/11/17/1479375169405-b2b815d5e0a55ab8a7e13db00e95c5d5.png?tr=q-75",
    },
    DE: {
      airlineCode: "DE",
      airlineName: "Condor Flugdienst",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    EB: {
      airlineCode: "EB",
      airlineName: "Wamos Air by Etihad Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/01/03/1704273927324-43027161201e0492242fa99038cb1d2e.png?tr=q-75",
    },
    TK: {
      airlineCode: "TK",
      airlineName: "Turkish Airlines ",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2022/03/14/1647231749449-15d7a44f3de2b691194308bf19547993.png?tr=q-75",
    },
    F9: {
      airlineCode: "F9",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    D8: {
      airlineCode: "D8",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    CI: {
      airlineCode: "CI",
      airlineName: "China Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349231542-0b361dab47374da6c45371b20afad93a.png?tr=q-75",
    },
    SU: {
      airlineCode: "SU",
      airlineName: "Aeroflot",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/05/16/1463384887997-c081bbf122faf71b0dc814b0a71d8753.png?tr=q-75",
    },
    OC: {
      airlineCode: "OC",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "9W": {
      airlineCode: "9W",
      airlineName: "Jet Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349149299-919a89fcec8e74b6a71b1b4951062fc7.png?tr=q-75",
    },
    G3: {
      airlineCode: "G3",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BR: {
      airlineCode: "BR",
      airlineName: "EVA Air ",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349217449-19bbf8095eb9b4c02df65d2b12f386d1.png?tr=q-75",
    },
    NQ: {
      airlineCode: "NQ",
      airlineName: "Air Japan",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    EY: {
      airlineCode: "EY",
      airlineName: "Etihad",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/01/03/1704273936866-9ccd1c6fd216fd72532d6da4069846d9.png?tr=q-75",
    },
    "2P": {
      airlineCode: "2P",
      airlineName: "PAL Express",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SL: {
      airlineCode: "SL",
      airlineName: "Thai Lion Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350592719-5aba7dc0f79bd63655904bb1dc803667.png?tr=q-75",
    },
    VF: {
      airlineCode: "VF",
      airlineName: "AnadoluJet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/10/03/1727931444162-d870203e769d926f89c340b803ebf573.png?tr=q-75",
    },
    DL: {
      airlineCode: "DL",
      airlineName: "Delta Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/05/16/1463384872781-ad470214b84af19f41c44356912577bd.png?tr=q-75",
    },
    G5: {
      airlineCode: "G5",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "API-test3-16": {
      airlineCode: "API-test3-16",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "API-test2-10": {
      airlineCode: "API-test2-10",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AF: {
      airlineCode: "AF",
      airlineName: "Air France",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349156379-5f7049fd67d0aa0b5574111ccdfab515.png?tr=q-75",
    },
    "API-test-update-partial": {
      airlineCode: "API-test-update-partial",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "8G": {
      airlineCode: "8G",
      airlineName: "Aero Dili",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2023/03/09/1678346040585-3f98acaea614ffb03f70c4ecebbf7233.png?tr=q-75",
    },
    G16: {
      airlineCode: "G16",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    K6: {
      airlineCode: "K6",
      airlineName: "Cambodia Angkor Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838515095-70b30306916f5e599afc3a6cde3677a9.png?tr=q-75",
    },
    SQ: {
      airlineCode: "SQ",
      airlineName: "Singapore Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350610403-aefa15ce3b8e59de9882926d198eb27f.png?tr=q-75",
    },
    NM: {
      airlineCode: "NM",
      airlineName: "NAM Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350497772-d343e9b6823d18054324b818b999c394.png?tr=q-75",
    },
    "7Y": {
      airlineCode: "7Y",
      airlineName: "Mann Yadanarpon Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "7C": {
      airlineCode: "7C",
      airlineName: "Jeju Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IU: {
      airlineCode: "IU",
      airlineName: "Super Air Jet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/05/12/1620813570103-6da835947eed70d76bac1c3a4cfa0376.png?tr=q-75",
    },
    EN: {
      airlineCode: "EN",
      airlineName: "Air Dolomiti",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    FM: {
      airlineCode: "FM",
      airlineName: "Shanghai Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459852942838-30ddd7ce655befa589a708eaf0d1e960.png?tr=q-75",
    },
    OK: {
      airlineCode: "OK",
      airlineName: "Czech Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    D7: {
      airlineCode: "D7",
      airlineName: "AirAsia X",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349272817-6407183d8850c6404cdf10dbc6ac9d41.png?tr=q-75",
    },
    ZE: {
      airlineCode: "ZE",
      airlineName: "Eastar Jet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2025/06/25/1750837970094-02b9fb966fdfb832964eba1fbe47488e.png?tr=q-75",
    },
    "API-test5-39": {
      airlineCode: "API-test5-39",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KU: {
      airlineCode: "KU",
      airlineName: "Kuwait Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838536719-8af79b72d0a34d9e99733aea4d4ae641.png?tr=q-75",
    },
    DD: {
      airlineCode: "DD",
      airlineName: "Nok Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349281186-d418f2d6c05f431cd133d407048a8338.png?tr=q-75",
    },
    HV: {
      airlineCode: "HV",
      airlineName: "Transavia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    LJ: {
      airlineCode: "LJ",
      airlineName: "Jin Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    PG: {
      airlineCode: "PG",
      airlineName: "Bangkok Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350527267-fb9dabea524c338d0f9a227f9e342a6e.png?tr=q-75",
    },
    AI: {
      airlineCode: "AI",
      airlineName: "Air India",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838465467-462c3a1448f444a055372263a4f5c3dd.png?tr=q-75",
    },
    OD: {
      airlineCode: "OD",
      airlineName: "Batik Air (Malaysia)",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350512703-60138ebec377378b954cc890225b5434.png?tr=q-75",
    },
    TT: {
      airlineCode: "TT",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    U4: {
      airlineCode: "U4",
      airlineName: "Buddha Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BD: {
      airlineCode: "BD",
      airlineName: "Cambodia Bayon Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/09/05/1473036342582-358bcf388d381d6c204b2a6954b09943.png?tr=q-75",
    },
    UX: {
      airlineCode: "UX",
      airlineName: "Air Europa",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G4: {
      airlineCode: "G4",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AA: {
      airlineCode: "AA",
      airlineName: "American Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/02/18/1455792439238-52adf5c9af6ac2b209d6bc236a76c2b2.png?tr=q-75",
    },
    EU: {
      airlineCode: "EU",
      airlineName: "Chengdu Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TR: {
      airlineCode: "TR",
      airlineName: "Scoot",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/06/10/1623330133815-3b9ce476d90b1b13d998732a2e157321.png?tr=q-75",
    },
    JX: {
      airlineCode: "JX",
      airlineName: "Starlux",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    T6: {
      airlineCode: "T6",
      airlineName: "Airswift",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2021/09/06/1630921360913-a8a44bf311ef685489fb184330d2d8f3.png?tr=q-75",
    },
    UB: {
      airlineCode: "UB",
      airlineName: "Myanmar National Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/12/05/1480928130821-3fb9960aeffb9877f8eb3fd9ef0fa874.png?tr=q-75",
    },
    LQ: {
      airlineCode: "LQ",
      airlineName: "Himalaya Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    "7B": {
      airlineCode: "7B",
      airlineName: "BBN Airlines Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2024/08/27/1724729439078-ec15eb455d2ddd3555bf765b0c33e6c4.png?tr=q-75",
    },
    MY: {
      airlineCode: "MY",
      airlineName: "MASWINGS",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    HX: {
      airlineCode: "HX",
      airlineName: "Hong Kong Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349784627-6cf9e8259125d74d6be5f7e79ddba070.png?tr=q-75",
    },
    DY: {
      airlineCode: "DY",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    YR: {
      airlineCode: "YR",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BL: {
      airlineCode: "BL",
      airlineName: "Pacific",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/06/09/1465469291738-73a9634edfa450f7964ba00090a54096.png?tr=q-75",
    },
    "API-test2-53": {
      airlineCode: "API-test2-53",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    GA: {
      airlineCode: "GA",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349771401-f7437a87e83b08f17055dc44d3ecb70e.png?tr=q-75",
    },
    VY: {
      airlineCode: "VY",
      airlineName: "Vueling",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2019/10/04/1570179696390-9da98c6df914e66a28d72f16b1b59c4a.png?tr=q-75",
    },
    G14: {
      airlineCode: "G14",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    KN: {
      airlineCode: "KN",
      airlineName: "China United Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    OL: {
      airlineCode: "OL",
      airlineName: "Samoa Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    HG: {
      airlineCode: "HG",
      airlineName: "Niki",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    NMx: {
      airlineCode: "NMx",
      airlineName: "NAM Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    DG: {
      airlineCode: "DG",
      airlineName: "Cebgo",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/08/01/1470041117326-797d733274615993b8b5e7f35706b779.png?tr=q-75",
    },
    "9B": {
      airlineCode: "9B",
      airlineName: "Accesrail And Partner Railways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BA: {
      airlineCode: "BA",
      airlineName: "British Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450349191484-6109380434e0b70438d8fe6c76c4db0d.png?tr=q-75",
    },
    UK: {
      airlineCode: "UK",
      airlineName: "Vistara",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    BC: {
      airlineCode: "BC",
      airlineName: "Skymark Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    WY: {
      airlineCode: "WY",
      airlineName: "Oman Air",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350689752-0aedb6cce73942916f9ea7eebd271743.png?tr=q-75",
    },
    NI: {
      airlineCode: "NI",
      airlineName: "Portugalia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    G6: {
      airlineCode: "G6",
      airlineName: "Firefly",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    AZ: {
      airlineCode: "AZ",
      airlineName: "Alitalia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/05/16/1463384825463-682756abea6ec4854d36b44668cd013f.png?tr=q-75",
    },
    UO: {
      airlineCode: "UO",
      airlineName: "HK Express",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2016/04/05/1459838571674-bbc3843bff3a599e06557064b4646a35.png?tr=q-75",
    },
    B6: {
      airlineCode: "B6",
      airlineName: "JetBlue Airways",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MJ: {
      airlineCode: "MJ",
      airlineName: "Mihin Lanka",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350431300-98c41738648f7b0b18b89a2f6bcf6979.png?tr=q-75",
    },
    WS: {
      airlineCode: "WS",
      airlineName: "WestJet",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    SC: {
      airlineCode: "SC",
      airlineName: "Shandong Airlines",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    TL: {
      airlineCode: "TL",
      airlineName: "Airnorth",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    EW: {
      airlineCode: "EW",
      airlineName: "Eurowings",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    IX: {
      airlineCode: "IX",
      airlineName: "Garuda Indonesia",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    VS: {
      airlineCode: "VS",
      airlineName: "Virgin Atlantic",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
    MM: {
      airlineCode: "MM",
      airlineName: "Peach Airline",
      logoUrl:
        "https://ik.imagekit.io/tvlkdev/image/imageResource/2015/12/17/1450350710653-f522e35b03adb20da95195584a72713d.png?tr=q-75",
    },
  },
  airportMap: {
    FLR: {
      airportCode: "FLR",
      city: "Florence",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Florence Airport",
    },
    MEB: {
      airportCode: "MEB",
      city: "Melbourne",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Essendon Fields Airport",
    },
    NME: {
      airportCode: "NME",
      city: "Nightmute",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nightmute Airport",
    },
    BLL: {
      airportCode: "BLL",
      city: "Billund",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Billund Airport",
    },
    VDM: {
      airportCode: "VDM",
      city: "Viedma",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Gobernador Castello",
    },
    PEK: {
      airportCode: "PEK",
      city: "Beijing",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Capital Intl",
    },
    VNO: {
      airportCode: "VNO",
      city: "Vilnius",
      countryId: "LT",
      countryCode: "440",
      internationalAirportName: "Vilnius Intl Airport",
    },
    LYS: {
      airportCode: "LYS",
      city: "Lyon",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Saint Exupery",
    },
    THS: {
      airportCode: "THS",
      city: "Sukhothai",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Sukhothai Airport",
    },
    NBC: {
      airportCode: "NBC",
      city: "Naberezhnye Chelny",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Naberezhnye Chelny Begishevo Airport",
    },
    SKK: {
      airportCode: "SKK",
      city: "Shaktoolik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Shaktoolik Airport",
    },
    TBH: {
      airportCode: "TBH",
      city: "Romblon",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Tugdan Airport",
    },
    FKQ: {
      airportCode: "FKQ",
      city: "Fak Fak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Torea",
    },
    YKU: {
      airportCode: "YKU",
      city: "Chisasibi",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Chisasibi Airport",
    },
    ZUH: {
      airportCode: "ZUH",
      city: "Zhuhai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhuhai Jinwan Airport",
    },
    GOA: {
      airportCode: "GOA",
      city: "Genoa",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Genoa Cristoforo Colombo",
    },
    TFU: {
      airportCode: "TFU",
      city: "Chengdu",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Chengdu Tianfu International Airport",
    },
    DEK: {
      airportCode: "DEK",
      city: "Yahukimo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dekai",
    },
    UCB: {
      airportCode: "UCB",
      city: "Ulanqab",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ulanqab Jining Airport",
    },
    CEC: {
      airportCode: "CEC",
      city: "Crescent City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Del Norte County Regional Airport",
    },
    LKA: {
      airportCode: "LKA",
      city: "Larantuka",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Gewayantana",
    },
    SLC: {
      airportCode: "SLC",
      city: "Salt Lake City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Salt Lake City Intl",
    },
    LZS: {
      airportCode: "LZS",
      city: "Linz",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Linz Central Station",
    },
    LIG: {
      airportCode: "LIG",
      city: "Limoges",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Limoges Bellegarde Airport",
    },
    KKX: {
      airportCode: "KKX",
      city: "Kikai",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kikai Airport",
    },
    KFS: {
      airportCode: "KFS",
      city: "Kastamonu",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Kastamonu Airport",
    },
    YVQ: {
      airportCode: "YVQ",
      city: "Norman Wells",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Norman Wells Airport",
    },
    SSG: {
      airportCode: "SSG",
      city: "Malabo",
      countryId: "GQ",
      countryCode: "226",
      internationalAirportName: "Malabo International Airport",
    },
    BXY: {
      airportCode: "BXY",
      city: "Baykonur",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Baikonur Krayniy Airport",
    },
    RGL: {
      airportCode: "RGL",
      city: "Rio Gallegos",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Rio Gallegos",
    },
    UBU: {
      airportCode: "UBU",
      city: "Kalumburu",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Kalumburu Airport",
    },
    PIP: {
      airportCode: "PIP",
      city: "Pilot Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Pilot Point Airport",
    },
    WSN: {
      airportCode: "WSN",
      city: "South Naknek",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "South Naknek Airport",
    },
    SHJ: {
      airportCode: "SHJ",
      city: "Sharjah",
      countryId: "AE",
      countryCode: "784",
      internationalAirportName: "Sharjah Intl",
    },
    CQW: {
      airportCode: "CQW",
      city: "Wulong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Chongqing Xiannvshan Airport",
    },
    MAM: {
      airportCode: "MAM",
      city: "Matamoros",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "General Servando Canales Intl",
    },
    HGN: {
      airportCode: "HGN",
      city: "Mae Hong Son",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Mae Hong Son",
    },
    MXP: {
      airportCode: "MXP",
      city: "Milan",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Malpensa Airport",
    },
    MWA: {
      airportCode: "MWA",
      city: "Marion",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Williamson County Regional Airport",
    },
    BGY: {
      airportCode: "BGY",
      city: "Milan",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Bergamo Orio Al Serio",
    },
    NJC: {
      airportCode: "NJC",
      city: "Nizhnevartovsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Nizhnevartovsk Airport",
    },
    ILG: {
      airportCode: "ILG",
      city: "Wilmington",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Wilmington Philadelphia Airport",
    },
    KIE: {
      airportCode: "KIE",
      city: "Kieta",
      countryId: "PG",
      countryCode: "643",
      internationalAirportName: "Aropa Airport",
    },
    HAU: {
      airportCode: "HAU",
      city: "Haugesund",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Haugesund Karmoy Airport",
    },
    BRS: {
      airportCode: "BRS",
      city: "Bristol",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Bristol Airport",
    },
    YNO: {
      airportCode: "YNO",
      city: "North Spirit Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "North Spirit Lake Airport",
    },
    YGR: {
      airportCode: "YGR",
      city: "Iles De La Madeleine",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Iles-de-la-Madeleine Airport",
    },
    DRG: {
      airportCode: "DRG",
      city: "Deering",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Deering Airport",
    },
    YEI: {
      airportCode: "YEI",
      city: "Yenisehir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Yenisehir Airport",
    },
    ZSJ: {
      airportCode: "ZSJ",
      city: "Sandy Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sandy Lake Airport",
    },
    NTX: {
      airportCode: "NTX",
      city: "Natuna",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Ranai",
    },
    MYI: {
      airportCode: "MYI",
      city: "Murray Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Murray Island Airport",
    },
    BRK: {
      airportCode: "BRK",
      city: "Bourke",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Bourke Airport",
    },
    RZE: {
      airportCode: "RZE",
      city: "Rzeszow",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Rzeszow Jasionka Airport",
    },
    SLE: {
      airportCode: "SLE",
      city: "Salem",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Salem - Willamette Valley Airport",
    },
    SJI: {
      airportCode: "SJI",
      city: "San Jose",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "San Jose Airport",
    },
    IPL: {
      airportCode: "IPL",
      city: "Imperial",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Imperial County Airport",
    },
    DBO: {
      airportCode: "DBO",
      city: "Dubbo",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Dubbo City Regional Airport",
    },
    BKW: {
      airportCode: "BKW",
      city: "Beckley",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Raleigh County Memorial Airport",
    },
    EIN: {
      airportCode: "EIN",
      city: "Eindhoven",
      countryId: "NL",
      countryCode: "528",
      internationalAirportName: "Eindhoven Airport",
    },
    CLP: {
      airportCode: "CLP",
      city: "Clarks Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Clarks Point Airport",
    },
    KSF: {
      airportCode: "KSF",
      city: "Kassel",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Kassel Calden Airport",
    },
    YFB: {
      airportCode: "YFB",
      city: "Iqaluit",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Iqaluit Airport",
    },
    TRK: {
      airportCode: "TRK",
      city: "Tarakan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Juwata",
    },
    YTW: {
      airportCode: "YTW",
      city: "Yutian",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yutian Wanfang Airport",
    },
    SVC: {
      airportCode: "SVC",
      city: "Silver City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Grant County Airport",
    },
    KRO: {
      airportCode: "KRO",
      city: "Kurgan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kurgan Airport",
    },
    AKY: {
      airportCode: "AKY",
      city: "Sittwe",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Sittwe",
    },
    KVK: {
      airportCode: "KVK",
      city: "Kirovsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kirovsk Apatity Khibiny Airport",
    },
    TIM: {
      airportCode: "TIM",
      city: "Timika",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mozes Kilangin",
    },
    BTK: {
      airportCode: "BTK",
      city: "Buntok Barito",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sanggu",
    },
    BTJ: {
      airportCode: "BTJ",
      city: "Banda Aceh",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Iskandarmuda",
    },
    CEE: {
      airportCode: "CEE",
      city: "Cherepovets",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Cherepovets Airport",
    },
    ARN: {
      airportCode: "ARN",
      city: "Stockholm",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Arlanda",
    },
    AKP: {
      airportCode: "AKP",
      city: "Anaktuvuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Anaktuvuk Pass Airport",
    },
    EPR: {
      airportCode: "EPR",
      city: "Esperance",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Esperance Airport",
    },
    KUG: {
      airportCode: "KUG",
      city: "Kubin Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Kubin Airport",
    },
    YXH: {
      airportCode: "YXH",
      city: "Medicine Hat",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Medicine Hat Regional Airport",
    },
    OLA: {
      airportCode: "OLA",
      city: "Orland",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Brekstad Orland Airport",
    },
    YIH: {
      airportCode: "YIH",
      city: "Yichang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yichang Sanxia Airport",
    },
    SLK: {
      airportCode: "SLK",
      city: "Saranac Lake",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Adirondack Regional Airport",
    },
    OKL: {
      airportCode: "OKL",
      city: "Gunung Bintang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Oksibil",
    },
    YPL: {
      airportCode: "YPL",
      city: "Pickle Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Pickle Lake Airport",
    },
    KKH: {
      airportCode: "KKH",
      city: "Kongiganak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kongiganak Airport",
    },
    MKK: {
      airportCode: "MKK",
      city: "Hoolehua",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Molokai Airport",
    },
    CXP: {
      airportCode: "CXP",
      city: "Cilacap",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tunggul Wulung ",
    },
    AGN: {
      airportCode: "AGN",
      city: "Angoon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Angoon Seaplane Base",
    },
    TNK: {
      airportCode: "TNK",
      city: "Tununak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tununak Airport",
    },
    BHS: {
      airportCode: "BHS",
      city: "Bathurst",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Bathurst Airport",
    },
    OLH: {
      airportCode: "OLH",
      city: "Old Harbor",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Old Harbor Airport",
    },
    YHP: {
      airportCode: "YHP",
      city: "Poplar Hill",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Poplar Hill Airport",
    },
    MCT: {
      airportCode: "MCT",
      city: "Muscat",
      countryId: "OM",
      countryCode: "512",
      internationalAirportName: "Seeb International Airport",
    },
    YTL: {
      airportCode: "YTL",
      city: "Big Trout",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Big Trout Lake Airport",
    },
    BVG: {
      airportCode: "BVG",
      city: "Berlevag",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Berlevag Airport",
    },
    FNI: {
      airportCode: "FNI",
      city: "Nimes",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Nimes Grande Provence Mediterranee Airport",
    },
    IZO: {
      airportCode: "IZO",
      city: "Izumo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Izumo Airport",
    },
    CJS: {
      airportCode: "CJS",
      city: "Ciudad Juarez",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Abraham Gonzalez Intl",
    },
    YVR: {
      airportCode: "YVR",
      city: "Vancouver",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Vancouver Intl",
    },
    SZG: {
      airportCode: "SZG",
      city: "Salzburg",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Salzburg Airport",
    },
    DUD: {
      airportCode: "DUD",
      city: "Dunedin",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Dunedin Airport",
    },
    MLN: {
      airportCode: "MLN",
      city: "Malinau",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Robert Atty Bessing",
    },
    WMO: {
      airportCode: "WMO",
      city: "White Mountain",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "White Mountain Airport",
    },
    CZX: {
      airportCode: "CZX",
      city: "Changzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Changzhou Benniu",
    },
    ANC: {
      airportCode: "ANC",
      city: "Anchorage",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ted Stevens Anchorage Intl",
    },
    EGS: {
      airportCode: "EGS",
      city: "Egilsstadir",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Egilsstadir Airport",
    },
    GIG: {
      airportCode: "GIG",
      city: "Rio De Janeiro",
      countryId: "BR",
      countryCode: "076",
      internationalAirportName: "Galeao Antonio Carlos Jobim",
    },
    JBK: {
      airportCode: "JBK",
      city: "Qitai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jiangbulake Airport",
    },
    ATY: {
      airportCode: "ATY",
      city: "Watertown",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Watertown Regional Airport",
    },
    KVG: {
      airportCode: "KVG",
      city: "Kavieng ",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Kavieng Airport",
    },
    UKB: {
      airportCode: "UKB",
      city: "Kobe",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kobe Airport",
    },
    SVO: {
      airportCode: "SVO",
      city: "Moscow",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Sheremetyevo International Airport",
    },
    TNJ: {
      airportCode: "TNJ",
      city: "Tanjung Pinang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Raja Haji Fisabilillah",
    },
    ZNE: {
      airportCode: "ZNE",
      city: "Newman",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Newman Airport",
    },
    SZB: {
      airportCode: "SZB",
      city: "Kuala Lumpur / Subang",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sultan Abdul Aziz Shah Intl",
    },
    STN: {
      airportCode: "STN",
      city: "London",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "London Stansted Airport",
    },
    LSW: {
      airportCode: "LSW",
      city: "Lhokseumawe",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Malikussaleh Airport",
    },
    MPH: {
      airportCode: "MPH",
      city: "Caticlan - Boracay",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Godofredo P",
    },
    MQN: {
      airportCode: "MQN",
      city: "Mo i Rana",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Mo i Rana Airport",
    },
    BTT: {
      airportCode: "BTT",
      city: "Bettles",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Bettles Airport",
    },
    LHE: {
      airportCode: "LHE",
      city: "Lahore",
      countryId: "PK",
      countryCode: "586",
      internationalAirportName: "Allama Iqbal Intl",
    },
    KZB: {
      airportCode: "KZB",
      city: "Zachar Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Zachar Bay Seaplane Base",
    },
    GCN: {
      airportCode: "GCN",
      city: "Grand Canyon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Grand Canyon National Park Airport",
    },
    PPG: {
      airportCode: "PPG",
      city: "Pago Pago",
      countryId: "AS",
      countryCode: "016",
      internationalAirportName: "Pago Pago International Airport",
    },
    ENI: {
      airportCode: "ENI",
      city: "El Nido - Palawan",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "El Nido Airport",
    },
    MKY: {
      airportCode: "MKY",
      city: "Mackay",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mackay",
    },
    SCN: {
      airportCode: "SCN",
      city: "Saarbruecken",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Saarbrucken Airport",
    },
    PTY: {
      airportCode: "PTY",
      city: "Panama City",
      countryId: "PA",
      countryCode: "591",
      internationalAirportName: "Tocumen International Airport",
    },
    OOK: {
      airportCode: "OOK",
      city: "Toksook Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Toksook Bay Airport",
    },
    BPX: {
      airportCode: "BPX",
      city: "Bangda",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Qamdo Bamda Airport",
    },
    TXL: {
      airportCode: "TXL",
      city: "Berlin",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Tegel Airport",
    },
    ALF: {
      airportCode: "ALF",
      city: "Alta",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Alta Airport",
    },
    RVN: {
      airportCode: "RVN",
      city: "Rovaniemi",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Rovaniemi Airport",
    },
    TRF: {
      airportCode: "TRF",
      city: "Sandefjord",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Torp",
    },
    SFN: {
      airportCode: "SFN",
      city: "Santa Fe",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Sauce Viejo",
    },
    KEJ: {
      airportCode: "KEJ",
      city: "Kemerovo",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kemerovo International Airport",
    },
    JHB: {
      airportCode: "JHB",
      city: "Johor Bahru",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Senai International Airport",
    },
    BDD: {
      airportCode: "BDD",
      city: "Badu Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Badu Island Airport",
    },
    IKA: {
      airportCode: "IKA",
      city: "Tehran",
      countryId: "IR",
      countryCode: "364",
      internationalAirportName: "Imam Khomeini",
    },
    LGP: {
      airportCode: "LGP",
      city: "Legazpi",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Legazpi Intl",
    },
    CKX: {
      airportCode: "CKX",
      city: "Chicken",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chicken Airport",
    },
    HEL: {
      airportCode: "HEL",
      city: "Helsinki",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Helsinki Vantaa",
    },
    MMK: {
      airportCode: "MMK",
      city: "Murmansk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Murmansk Airport",
    },
    EUN: {
      airportCode: "EUN",
      city: "Laayoune",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "El Aaiun Hassan I Airport",
    },
    CMA: {
      airportCode: "CMA",
      city: "Cunnamulla",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Cunnamulla Airport",
    },
    SKG: {
      airportCode: "SKG",
      city: "Thessaloniki",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Makedonia",
    },
    WAW: {
      airportCode: "WAW",
      city: "Warsaw",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Warsaw Chopin",
    },
    CMN: {
      airportCode: "CMN",
      city: "Casablanca",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Mohammed V Intl",
    },
    NLF: {
      airportCode: "NLF",
      city: "Darnley Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Darnley Island Airport",
    },
    ZTI: {
      airportCode: "ZTI",
      city: "Humen",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Humen Port",
    },
    OTP: {
      airportCode: "OTP",
      city: "Bucharest",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Bucharest Henri Coandă International Airport",
    },
    TDX: {
      airportCode: "TDX",
      city: "Trat",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Trat Airport",
    },
    BRR: {
      airportCode: "BRR",
      city: "Barra",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Barra Airport",
    },
    WUZ: {
      airportCode: "WUZ",
      city: "Wuzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wuzhou Xijiang Airport",
    },
    ZHA: {
      airportCode: "ZHA",
      city: "Zhanjiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhanjiang Airport",
    },
    PFT: {
      airportCode: "PFT",
      city: "Pazhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Pazhou Port",
    },
    SDP: {
      airportCode: "SDP",
      city: "Sand Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Sand Point Airport",
    },
    KDL: {
      airportCode: "KDL",
      city: "Kardla",
      countryId: "EE",
      countryCode: "233",
      internationalAirportName: "Kardla Airport",
    },
    YTH: {
      airportCode: "YTH",
      city: "Thompson",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Thompson Airport",
    },
    GBE: {
      airportCode: "GBE",
      city: "Gaberone",
      countryId: "BW",
      countryCode: "072",
      internationalAirportName: "Sir Seretse Khama International Airport",
    },
    JIB: {
      airportCode: "JIB",
      city: "Ambouli",
      countryId: "DJ",
      countryCode: "262",
      internationalAirportName: "Djibouti Ambouli Int'l Airport",
    },
    ZFL: {
      airportCode: "ZFL",
      city: "Zhaosu",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tianma Airport",
    },
    ODY: {
      airportCode: "ODY",
      city: "Muang Xai",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Oudomsay Airport",
    },
    CIH: {
      airportCode: "CIH",
      city: "Changzhi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Changzhi Wangcun Airport",
    },
    ASF: {
      airportCode: "ASF",
      city: "Astrakhan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Astrakhan Narimanovo Airport",
    },
    RHD: {
      airportCode: "RHD",
      city: "Termas de Río Hondo",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Termas de Río Hondo International Airport",
    },
    NOJ: {
      airportCode: "NOJ",
      city: "Nojabrxsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Noyabrsk Airport",
    },
    HND: {
      airportCode: "HND",
      city: "Tokyo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Haneda Intl",
    },
    MDC: {
      airportCode: "MDC",
      city: "Manado",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sam Ratulangi",
    },
    AET: {
      airportCode: "AET",
      city: "Allakaket",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Allakaket Airport",
    },
    KCH: {
      airportCode: "KCH",
      city: "Kuching",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Kuching Intl",
    },
    JNB: {
      airportCode: "JNB",
      city: "Johannesburg",
      countryId: "ZA",
      countryCode: "710",
      internationalAirportName: "Johannesburg Intl",
    },
    KJI: {
      airportCode: "KJI",
      city: "Buerjin",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Burqin Kanas Airport",
    },
    LKN: {
      airportCode: "LKN",
      city: "Leknes",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Leknes Airport",
    },
    BER: {
      airportCode: "BER",
      city: "Berlin",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Berlin Brandenburg Airport",
    },
    MJU: {
      airportCode: "MJU",
      city: "Mamuju",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tampa Padang",
    },
    UIH: {
      airportCode: "UIH",
      city: "Quy Nhon",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Quy Nhon",
    },
    ICN: {
      airportCode: "ICN",
      city: "Seoul",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Incheon Intl",
    },
    IRK: {
      airportCode: "IRK",
      city: "Kirksville",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kirksville Regional Airport",
    },
    YAA: {
      airportCode: "YAA",
      city: "Anahim Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Anahim Lake Airport",
    },
    TTE: {
      airportCode: "TTE",
      city: "Ternate",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Babullah",
    },
    TAL: {
      airportCode: "TAL",
      city: "Tanana",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tanana Ralph M Calhoun Memorial Airport",
    },
    LED: {
      airportCode: "LED",
      city: "St Petersburg",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Pulkovo",
    },
    KZS: {
      airportCode: "KZS",
      city: "Kastellorizo",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kastellorizo Megisti Airport",
    },
    PPS: {
      airportCode: "PPS",
      city: "Puerto Princesa - Palawan",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Puerto Princesa",
    },
    MKW: {
      airportCode: "MKW",
      city: "Manokwari",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Rendani",
    },
    BAV: {
      airportCode: "BAV",
      city: "Baotou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baotou Airport",
    },
    CKY: {
      airportCode: "CKY",
      city: "Conakry",
      countryId: "GN",
      countryCode: "324",
      internationalAirportName: "Conakry Ahmed Sekou Toure Intl Airport",
    },
    SZH: {
      airportCode: "SZH",
      city: "Shuozhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shuozhou Zirun Airport",
    },
    ILY: {
      airportCode: "ILY",
      city: "Islay",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Islay Airport",
    },
    KIT: {
      airportCode: "KIT",
      city: "Kithira",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kithira Alexander Aristotle Onassis Airport",
    },
    WUA: {
      airportCode: "WUA",
      city: "Wu Hai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wuhai Airport",
    },
    YKL: {
      airportCode: "YKL",
      city: "Schefferville",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Schefferville Airport",
    },
    OXB: {
      airportCode: "OXB",
      city: "Bissau",
      countryId: "GW",
      countryCode: "624",
      internationalAirportName: "Osvaldo Vieira International Airport",
    },
    UBJ: {
      airportCode: "UBJ",
      city: "Yamaguchi",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Yamaguchi Ube",
    },
    MQL: {
      airportCode: "MQL",
      city: "Mildura",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mildura Airport",
    },
    UKK: {
      airportCode: "UKK",
      city: "Ust Kamenogorsk",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Ust Kamenogorsk Airport",
    },
    ILA: {
      airportCode: "ILA",
      city: "Ilaga",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Ilaga",
    },
    KCZ: {
      airportCode: "KCZ",
      city: "Kochi",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kochi Airport",
    },
    AGH: {
      airportCode: "AGH",
      city: "Angelholm/Helsingborg",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Angelholm Helsingborg Airport",
    },
    MOU: {
      airportCode: "MOU",
      city: "Mountain Village",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Mountain Village Airport",
    },
    HSL: {
      airportCode: "HSL",
      city: "Huslia",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Huslia Airport",
    },
    MYA: {
      airportCode: "MYA",
      city: "Moruya",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Moruya Airport",
    },
    YRT: {
      airportCode: "YRT",
      city: "Rankin Inlet",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Rankin Inlet Airport",
    },
    BUI: {
      airportCode: "BUI",
      city: "Bokondini",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Bokondini",
    },
    BHI: {
      airportCode: "BHI",
      city: "Bahia Blanca",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Comandante Espora",
    },
    YPM: {
      airportCode: "YPM",
      city: "Pikangikum",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Pikangikum Airport",
    },
    BSO: {
      airportCode: "BSO",
      city: "Basco",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Basco ",
    },
    CRV: {
      airportCode: "CRV",
      city: "Crotone",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Crotone-Sant Anna Airport",
    },
    TUO: {
      airportCode: "TUO",
      city: "Taupo",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Taupo Airport",
    },
    GZP: {
      airportCode: "GZP",
      city: "Antalya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Gazipasa Airport",
    },
    ACX: {
      airportCode: "ACX",
      city: "Xingyi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xingyi Wangfenglin Airport",
    },
    KBV: {
      airportCode: "KBV",
      city: "Krabi",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Krabi International Airport",
    },
    UOL: {
      airportCode: "UOL",
      city: "Buol",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pogogul",
    },
    SKU: {
      airportCode: "SKU",
      city: "Skiros",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Skyros Airport",
    },
    NRT: {
      airportCode: "NRT",
      city: "Tokyo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Narita Intl",
    },
    ORV: {
      airportCode: "ORV",
      city: "Noorvik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Noorvik Robert Curtis Memorial Airport",
    },
    AJI: {
      airportCode: "AJI",
      city: "Agrı",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Agrı Airport",
    },
    YXL: {
      airportCode: "YXL",
      city: "Sioux Lookout",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sioux Lookout Airport",
    },
    PML: {
      airportCode: "PML",
      city: "Port Moller",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Moller Airport",
    },
    NUX: {
      airportCode: "NUX",
      city: "Novyj Urengoj",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Novy Urengoy Airport",
    },
    TNE: {
      airportCode: "TNE",
      city: "Tanegashima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "New Tanegashima Airport",
    },
    ARM: {
      airportCode: "ARM",
      city: "Armidale",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Armidale",
    },
    RQA: {
      airportCode: "RQA",
      city: "Ruogiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ruoqiang Loulan Airport",
    },
    RGK: {
      airportCode: "RGK",
      city: "Gorno-Altaysk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Gorno-Altaysk Airport",
    },
    EDR: {
      airportCode: "EDR",
      city: "Edward River",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Pormpuraaw Edward River Airport",
    },
    PEN: {
      airportCode: "PEN",
      city: "Penang",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Penang Intl",
    },
    SMA: {
      airportCode: "SMA",
      city: "Santa Maria (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Santa Maria Airport (PT)",
    },
    MNA: {
      airportCode: "MNA",
      city: "Talaud",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Melongguane",
    },
    BQT: {
      airportCode: "BQT",
      city: "Brest",
      countryId: "BY",
      countryCode: "112",
      internationalAirportName: "Brest Airport",
    },
    NTG: {
      airportCode: "NTG",
      city: "Nantong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Nantong Xingdong Airport",
    },
    NUI: {
      airportCode: "NUI",
      city: "Nuiqsut",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nuiqsut Airport",
    },
    TQR: {
      airportCode: "TQR",
      city: "San Domino Island",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "San Domino Island Heliport",
    },
    EWE: {
      airportCode: "EWE",
      city: "Asmat",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Ewer",
    },
    HKG: {
      airportCode: "HKG",
      city: "Hong Kong",
      countryId: "HK",
      countryCode: "344",
      internationalAirportName: "Hong Kong International Airport",
    },
    ROT: {
      airportCode: "ROT",
      city: "Rotorua",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Rotorua Regional Airport",
    },
    KAZ: {
      airportCode: "KAZ",
      city: "Tobelo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kuabang Kao",
    },
    ZTB: {
      airportCode: "ZTB",
      city: "Tete-A-La Baleine",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Tete-a-la Baleine Airport",
    },
    GME: {
      airportCode: "GME",
      city: "Gomel",
      countryId: "BY",
      countryCode: "112",
      internationalAirportName: "Gomel Airport",
    },
    SDL: {
      airportCode: "SDL",
      city: "Sundsvall",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Sundsvall-Timra Airport",
    },
    CSY: {
      airportCode: "CSY",
      city: "Cheboksary",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Cheboksary International Airport",
    },
    TLS: {
      airportCode: "TLS",
      city: "Toulouse",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Blagnac",
    },
    SRP: {
      airportCode: "SRP",
      city: "Stord",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Stord Sorstokken Airport",
    },
    JKL: {
      airportCode: "JKL",
      city: "Kalymnos",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kalymnos Island National Airport",
    },
    FLZ: {
      airportCode: "FLZ",
      city: "Sibolga",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dr. Ferdinand Lumban Tobing",
    },
    FDE: {
      airportCode: "FDE",
      city: "Forde",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Forde Bringeland Airport",
    },
    CEB: {
      airportCode: "CEB",
      city: "Cebu",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Mactan Cebu Intl",
    },
    MLY: {
      airportCode: "MLY",
      city: "Manley Hot Springs",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Manley Hot Springs Airport",
    },
    LCY: {
      airportCode: "LCY",
      city: "London",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "London City Airport",
    },
    ROI: {
      airportCode: "ROI",
      city: "Roi Et",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Roi Et Airport",
    },
    ZHY: {
      airportCode: "ZHY",
      city: "Zhongwei",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhongwei Xiangshan Airport",
    },
    TBG: {
      airportCode: "TBG",
      city: "Tabubil",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Tabubil Airport",
    },
    KUN: {
      airportCode: "KUN",
      city: "Kaunas",
      countryId: "LT",
      countryCode: "440",
      internationalAirportName: "Kaunas Airport",
    },
    IEG: {
      airportCode: "IEG",
      city: "Zielona Gora",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Zielona Gora Babimost Airport",
    },
    TMC: {
      airportCode: "TMC",
      city: "Waikabubak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tambolaka Airport",
    },
    GUW: {
      airportCode: "GUW",
      city: "Atyrau",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Atyrau Airport",
    },
    TGM: {
      airportCode: "TGM",
      city: "Targu-Mures",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Targu Mures Transilvania Airport",
    },
    AAP: {
      airportCode: "AAP",
      city: "Samarinda",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "APT Pranotos",
    },
    NTE: {
      airportCode: "NTE",
      city: "Nantes",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Nantes Atlantique",
    },
    YQC: {
      airportCode: "YQC",
      city: "Quaqtaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Quaqtaq Airport",
    },
    PKE: {
      airportCode: "PKE",
      city: "Parkes",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Parkes Airport",
    },
    BDB: {
      airportCode: "BDB",
      city: "Bundaberg",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Bundaberg Airport",
    },
    YZF: {
      airportCode: "YZF",
      city: "Yellowknife",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Yellowknife Airport",
    },
    YAZ: {
      airportCode: "YAZ",
      city: "Tofino",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Tofino Long Beach Airport",
    },
    YGP: {
      airportCode: "YGP",
      city: "Gaspe",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Michel-Pouliot Gaspe Airport",
    },
    BWN: {
      airportCode: "BWN",
      city: "Bandar Seri Begawan",
      countryId: "BN",
      countryCode: "096",
      internationalAirportName: "Brunei Intl",
    },
    EAA: {
      airportCode: "EAA",
      city: "Eagle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Eagle Airport",
    },
    IVC: {
      airportCode: "IVC",
      city: "Invercargill",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Invercargill Airport",
    },
    KLO: {
      airportCode: "KLO",
      city: "Kalibo - Boracay",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Kalibo",
    },
    LZN: {
      airportCode: "LZN",
      city: "Nangan",
      countryId: "TW",
      countryCode: "158",
      internationalAirportName: "Matsu Nangan Airport",
    },
    ROS: {
      airportCode: "ROS",
      city: "Rosario",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Rosario",
    },
    ISG: {
      airportCode: "ISG",
      city: "Ishigaki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Ishigaki",
    },
    BNN: {
      airportCode: "BNN",
      city: "Bronnoysund",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Bronnoysund Airport",
    },
    CKZ: {
      airportCode: "CKZ",
      city: "Canakkale",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Canakkale Airport",
    },
    OOM: {
      airportCode: "OOM",
      city: "Cooma",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Snowy Mountains Airport",
    },
    AKL: {
      airportCode: "AKL",
      city: "Auckland",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Auckland Intl Airport",
    },
    YGL: {
      airportCode: "YGL",
      city: "La Grande",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "La Grande Riviere Airport",
    },
    LGK: {
      airportCode: "LGK",
      city: "Langkawi",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Langkawi Intl",
    },
    TLL: {
      airportCode: "TLL",
      city: "Tallinn",
      countryId: "EE",
      countryCode: "233",
      internationalAirportName: "Tallinn Airport",
    },
    DRP: {
      airportCode: "DRP",
      city: "Legazpi",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Legazpi Intl",
    },
    JUJ: {
      airportCode: "JUJ",
      city: "Jujuy",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Jujuy",
    },
    LEB: {
      airportCode: "LEB",
      city: "Lebanon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lebanon Municipal Airport",
    },
    ENF: {
      airportCode: "ENF",
      city: "Enontekio",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Enontekio Airport",
    },
    NAP: {
      airportCode: "NAP",
      city: "Naples",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Capodichino",
    },
    TPS: {
      airportCode: "TPS",
      city: "Trapani",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Trapani-Birgi Airport",
    },
    PMK: {
      airportCode: "PMK",
      city: "Palm Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Palm Island Airport",
    },
    PMF: {
      airportCode: "PMF",
      city: "Parma",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Parma Airport",
    },
    SBW: {
      airportCode: "SBW",
      city: "Sibu",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sibu",
    },
    KTE: {
      airportCode: "KTE",
      city: "Kerteh",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Kerteh",
    },
    YZS: {
      airportCode: "YZS",
      city: "Coral Harbour",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Coral Harbour Airport",
    },
    YLC: {
      airportCode: "YLC",
      city: "Kimmirut/Lake Harbour",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kimmirut Airport",
    },
    TAC: {
      airportCode: "TAC",
      city: "Tacloban",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Daniel Z Romualdez",
    },
    OSY: {
      airportCode: "OSY",
      city: "Namsos",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Namsos Airport",
    },
    DUM: {
      airportCode: "DUM",
      city: "Dumai",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pinang Kampai",
    },
    NUP: {
      airportCode: "NUP",
      city: "Nunapitchuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nunapitchuk Airport",
    },
    GKE: {
      airportCode: "GKE",
      city: "Geilenkirchen",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "NATO Air Base Geilenkirchen",
    },
    RUH: {
      airportCode: "RUH",
      city: "Riyadh",
      countryId: "SA",
      countryCode: "682",
      internationalAirportName: "King Khaled Intl",
    },
    JSJ: {
      airportCode: "JSJ",
      city: "Jiansanjiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jiansanjiang Airport",
    },
    PHS: {
      airportCode: "PHS",
      city: "Phitsanulok",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Phitsanulok Airport",
    },
    BZR: {
      airportCode: "BZR",
      city: "Beziers",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Beziers Cap d'Agde Airport",
    },
    HFT: {
      airportCode: "HFT",
      city: "Hammerfest",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Hammerfest Airport",
    },
    MLK: {
      airportCode: "MLK",
      city: "Melak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Melalan",
    },
    LGW: {
      airportCode: "LGW",
      city: "London",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Gatwick",
    },
    FYU: {
      airportCode: "FYU",
      city: "Fort Yukon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Fort Yukon Airport",
    },
    OSR: {
      airportCode: "OSR",
      city: "Ostrava",
      countryId: "CZ",
      countryCode: "203",
      internationalAirportName: "Ostrava Leos Janacek Airport",
    },
    REG: {
      airportCode: "REG",
      city: "Reggio Calabria",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Reggio Calabria Airport",
    },
    KAW: {
      airportCode: "KAW",
      city: "Kawthaung",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Kawthaung",
    },
    CWB: {
      airportCode: "CWB",
      city: "Curitiba",
      countryId: "BR",
      countryCode: "076",
      internationalAirportName: "Afonso Pena International Airport",
    },
    CFS: {
      airportCode: "CFS",
      city: "Coff's Harbour",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Coffs Harbour",
    },
    UTS: {
      airportCode: "UTS",
      city: "Ust-Tsilma",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Ust-Tsilma Airport",
    },
    BNA: {
      airportCode: "BNA",
      city: "Nashville",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nashville International Airport",
    },
    HRK: {
      airportCode: "HRK",
      city: "Kharkiv",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Kharkiv Intl Airport",
    },
    BAH: {
      airportCode: "BAH",
      city: "Bahrain",
      countryId: "BH",
      countryCode: "048",
      internationalAirportName: "Bahrain International Airport",
    },
    OGG: {
      airportCode: "OGG",
      city: "Kahului Hawaii",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kahului",
    },
    KOI: {
      airportCode: "KOI",
      city: "Kirkwall",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Kirkwall Airport",
    },
    PEG: {
      airportCode: "PEG",
      city: "Perugia",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Perugia San Francesco d'Assisi Airport",
    },
    LMA: {
      airportCode: "LMA",
      city: "Lake Minchumina",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lake Minchumina Airport",
    },
    YXJ: {
      airportCode: "YXJ",
      city: "Fort St. John",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fort St. John Airport",
    },
    WIN: {
      airportCode: "WIN",
      city: "Winton",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Winton Airport",
    },
    WBB: {
      airportCode: "WBB",
      city: "Stebbins",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Stebbins Airport",
    },
    KWP: {
      airportCode: "KWP",
      city: "West Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "West Point Village Seaplane Base",
    },
    ABX: {
      airportCode: "ABX",
      city: "Albury",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Albury",
    },
    SNK: {
      airportCode: "SNK",
      city: "Puncak Jaya",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sinak",
    },
    TKE: {
      airportCode: "TKE",
      city: "Tenakee Springs",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tenakee Seaplane Base",
    },
    THQ: {
      airportCode: "THQ",
      city: "Tianshui",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tianshui Maijishan Airport",
    },
    TVF: {
      airportCode: "TVF",
      city: "Thief River Falls",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Thief River Falls Regional Airport",
    },
    VAW: {
      airportCode: "VAW",
      city: "Vardoe",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Vardoe Svartnes Airport",
    },
    ZAG: {
      airportCode: "ZAG",
      city: "Zagreb",
      countryId: "HR",
      countryCode: "191",
      internationalAirportName: "Zagreb Franjo Tuđman Airport",
    },
    POZ: {
      airportCode: "POZ",
      city: "Poznan",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Poznan Lawica Airport",
    },
    WGP: {
      airportCode: "WGP",
      city: "Waingapu",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Umbu Mehang Kunda/Mau Hau",
    },
    ELI: {
      airportCode: "ELI",
      city: "Elim",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Elim Airport",
    },
    BIU: {
      airportCode: "BIU",
      city: "Bildudalur",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Bildudalur Airport",
    },
    RLK: {
      airportCode: "RLK",
      city: "Bayannur",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Bayannur Tianjitai Airport",
    },
    CAL: {
      airportCode: "CAL",
      city: "Campbeltown",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Campbeltown Airport",
    },
    MSR: {
      airportCode: "MSR",
      city: "Mus",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Mus Airport",
    },
    YBK: {
      airportCode: "YBK",
      city: "Baker Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Baker Lake Airport",
    },
    BHY: {
      airportCode: "BHY",
      city: "Beihai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Beihai Airport",
    },
    ANR: {
      airportCode: "ANR",
      city: "Antwerp",
      countryId: "BE",
      countryCode: "056",
      internationalAirportName: "Antwerp International Airport",
    },
    ZBF: {
      airportCode: "ZBF",
      city: "Bathurst",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Bathurst Regional Airport",
    },
    CIA: {
      airportCode: "CIA",
      city: "Rome",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Rome Ciampino Airport",
    },
    MDL: {
      airportCode: "MDL",
      city: "Mandalay",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Mandalay Intl Airport",
    },
    ECN: {
      airportCode: "ECN",
      city: "Tymvou",
      countryId: "CY",
      countryCode: "196",
      internationalAirportName: "Ercan Int'l Airport",
    },
    WUT: {
      airportCode: "WUT",
      city: "Xinzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xinzhou Wutaishan Airport",
    },
    KZI: {
      airportCode: "KZI",
      city: "Kozani",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kozani Filippos Airport",
    },
    AKK: {
      airportCode: "AKK",
      city: "Akhiok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Akhiok Airport",
    },
    YEK: {
      airportCode: "YEK",
      city: "Arviat",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Arviat Airport",
    },
    KEW: {
      airportCode: "KEW",
      city: "Keewaywin",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Keewaywin Airport",
    },
    JCK: {
      airportCode: "JCK",
      city: "Julia Creek",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Julia Creek Airport",
    },
    KZN: {
      airportCode: "KZN",
      city: "Kazan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kazan International Airport ",
    },
    NGO: {
      airportCode: "NGO",
      city: "Nagoya",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Chubu Centrair Intl",
    },
    DVO: {
      airportCode: "DVO",
      city: "Davao",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Davao ",
    },
    YRL: {
      airportCode: "YRL",
      city: "Red Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Red Lake Airport",
    },
    BEJ: {
      airportCode: "BEJ",
      city: "Berau",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kalimarau",
    },
    TEX: {
      airportCode: "TEX",
      city: "Telluride",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Telluride Regional Airport",
    },
    KGI: {
      airportCode: "KGI",
      city: "Kalgoorlie",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Kalgoorlie Airport",
    },
    ISB: {
      airportCode: "ISB",
      city: "Islamabad",
      countryId: "PK",
      countryCode: "586",
      internationalAirportName: "Benazir Bhutto International Airport",
    },
    PUS: {
      airportCode: "PUS",
      city: "Busan",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Gimhae Intl",
    },
    EWR: {
      airportCode: "EWR",
      city: "New York",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Newark Liberty Intl",
    },
    NUE: {
      airportCode: "NUE",
      city: "Nuremberg",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Nuremberg",
    },
    LZG: {
      airportCode: "LZG",
      city: "Langzhong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Langzhong Gucheng Airport",
    },
    XIL: {
      airportCode: "XIL",
      city: "Xilinhot",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xilinhot Airport",
    },
    WTK: {
      airportCode: "WTK",
      city: "Noatak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Noatak Airport",
    },
    HMV: {
      airportCode: "HMV",
      city: "Hemavan",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Hemavan Tarnaby Airport",
    },
    TWC: {
      airportCode: "TWC",
      city: "Tumushuke",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tumxuk Tangwangcheng Airport",
    },
    OMS: {
      airportCode: "OMS",
      city: "Omsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Omsk Tsentralny Airport",
    },
    LNS: {
      airportCode: "LNS",
      city: "Lancaster",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lancaster Airport",
    },
    YGJ: {
      airportCode: "YGJ",
      city: "Miho",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Miho Yonago Airport",
    },
    SEA: {
      airportCode: "SEA",
      city: "Seattle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Seattle Tacoma Intl",
    },
    YOW: {
      airportCode: "YOW",
      city: "Ottawa",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Ottawa Macdonald Cartier Intl",
    },
    WSK: {
      airportCode: "WSK",
      city: "Wushan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Chongqing Wushan Airport",
    },
    XMY: {
      airportCode: "XMY",
      city: "Yam Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Yam Island Airport",
    },
    RLG: {
      airportCode: "RLG",
      city: "Rostock-Laage",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Rostock-Laage Airport",
    },
    BMU: {
      airportCode: "BMU",
      city: "Bima",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Muhammad Salahuddin",
    },
    SGD: {
      airportCode: "SGD",
      city: "Sonderborg",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Sonderborg Airport",
    },
    DEL: {
      airportCode: "DEL",
      city: "New Delhi",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Indira Gandhi Int'l",
    },
    PHO: {
      airportCode: "PHO",
      city: "Point Hope",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Point Hope Airport",
    },
    YGW: {
      airportCode: "YGW",
      city: "Kuujjuarapik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kuujjuarapik Airport",
    },
    ZFN: {
      airportCode: "ZFN",
      city: "Tulita/Fort Norman",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Tulita Airport",
    },
    YEV: {
      airportCode: "YEV",
      city: "Inuvik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Inuvik Mike Zubko Airport",
    },
    RSA: {
      airportCode: "RSA",
      city: "Santa Rosa",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Santa Rosa",
    },
    SXP: {
      airportCode: "SXP",
      city: "Sheldon Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Sheldon Point Airport",
    },
    TSR: {
      airportCode: "TSR",
      city: "Timisoara",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Timisoara Traian Vuia International Airport",
    },
    WWT: {
      airportCode: "WWT",
      city: "Newtok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Newtok Airport",
    },
    ASP: {
      airportCode: "ASP",
      city: "Alice Springs",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Alice Springs",
    },
    ZEL: {
      airportCode: "ZEL",
      city: "Bella Bella",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Bella Bella Campbell Island Airport",
    },
    ALC: {
      airportCode: "ALC",
      city: "Alicante",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Alicante-Elche",
    },
    IAD: {
      airportCode: "IAD",
      city: "Washington",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Washington Dulles Intl",
    },
    MSQ: {
      airportCode: "MSQ",
      city: "Minsk",
      countryId: "BY",
      countryCode: "112",
      internationalAirportName: "Minsk National Airport",
    },
    YWH: {
      airportCode: "YWH",
      city: "Victoria",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Victoria Inner Harbour Seaplane Base",
    },
    FTE: {
      airportCode: "FTE",
      city: "El Calafate",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "El Calafate",
    },
    ZWL: {
      airportCode: "ZWL",
      city: "Wollaston Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Wollaston Lake Airport",
    },
    NNM: {
      airportCode: "NNM",
      city: "Naryan-Mar",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Naryan-Mar Airport",
    },
    YDA: {
      airportCode: "YDA",
      city: "Dawson City",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Dawson City Airport",
    },
    ROK: {
      airportCode: "ROK",
      city: "Rockhampton",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Rockhampton Airport",
    },
    VTE: {
      airportCode: "VTE",
      city: "Vientiane",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Wattay Intl Airport",
    },
    DLC: {
      airportCode: "DLC",
      city: "Dalian",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhoushuizi Airport",
    },
    OHS: {
      airportCode: "OHS",
      city: "Sohar",
      countryId: "OM",
      countryCode: "512",
      internationalAirportName: "Sohar International Airport",
    },
    REP: {
      airportCode: "REP",
      city: "Siem Reap",
      countryId: "KH",
      countryCode: "116",
      internationalAirportName: "Siem Reap",
    },
    SCU: {
      airportCode: "SCU",
      city: "Santiago",
      countryId: "CU",
      countryCode: "192",
      internationalAirportName: "Santiago de Cuba Antonio Maceo Intl Airport",
    },
    GIS: {
      airportCode: "GIS",
      city: "Gisborne",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Gisborne Airport",
    },
    YCS: {
      airportCode: "YCS",
      city: "Chesterfield Inlet",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Chesterfield Inlet Airport",
    },
    AER: {
      airportCode: "AER",
      city: "Sochi",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Sochi International Airport",
    },
    HAD: {
      airportCode: "HAD",
      city: "Halmstad",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Halmstad Airport",
    },
    LGZ: {
      airportCode: "LGZ",
      city: "Shannan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shannan Longzi Airport",
    },
    HYL: {
      airportCode: "HYL",
      city: "Hollis",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hollis Clark Bay Seaplane Base",
    },
    YHI: {
      airportCode: "YHI",
      city: "Ulukhaktok",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Ulukhaktok Airport",
    },
    VII: {
      airportCode: "VII",
      city: "Vinh",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Vinh",
    },
    ESD: {
      airportCode: "ESD",
      city: "Eastsound",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Orcas Island Airport",
    },
    TBS: {
      airportCode: "TBS",
      city: "Tbilisi",
      countryId: "GE",
      countryCode: "268",
      internationalAirportName: "Tbilisi International Airport",
    },
    YFA: {
      airportCode: "YFA",
      city: "Fort Albany",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fort Albany Airport",
    },
    KXA: {
      airportCode: "KXA",
      city: "Kasaan",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kasaan Seaplane Base",
    },
    FKJ: {
      airportCode: "FKJ",
      city: "Fukui",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Fukui Airport",
    },
    PSU: {
      airportCode: "PSU",
      city: "Putussibau",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pangsuma",
    },
    KET: {
      airportCode: "KET",
      city: "Kengtung",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Kengtung",
    },
    SUG: {
      airportCode: "SUG",
      city: "Surigao City",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Surigao Airport",
    },
    NSK: {
      airportCode: "NSK",
      city: "Noril'sk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Norilsk Alykel Airport",
    },
    FYN: {
      airportCode: "FYN",
      city: "Fuyun",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Fuyun Koktokay Airport",
    },
    CGY: {
      airportCode: "CGY",
      city: "Cagayan de Oro",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Laguindingan Intl",
    },
    DJJ: {
      airportCode: "DJJ",
      city: "Jayapura",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sentani",
    },
    BEY: {
      airportCode: "BEY",
      city: "Beirut",
      countryId: "LB",
      countryCode: "422",
      internationalAirportName: "Rafic Hariri Intl",
    },
    KUO: {
      airportCode: "KUO",
      city: "Kuopio",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kuopio Airport",
    },
    STG: {
      airportCode: "STG",
      city: "Saint George Island",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "St George Island Airport",
    },
    AYT: {
      airportCode: "AYT",
      city: "Antalya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Antalya Airport",
    },
    LHG: {
      airportCode: "LHG",
      city: "Lightning Ridge",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Lightning Ridge Airport",
    },
    TGG: {
      airportCode: "TGG",
      city: "Kuala Terengganu",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sultan Mahmud",
    },
    LJG: {
      airportCode: "LJG",
      city: "Lijiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Lijiang Airport",
    },
    CNX: {
      airportCode: "CNX",
      city: "Chiang Mai",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Chiang Mai Intl",
    },
    GTO: {
      airportCode: "GTO",
      city: "Gorontalo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Jalaluddin",
    },
    HSC: {
      airportCode: "HSC",
      city: "Shaoguan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shaoguan Danxia Airport",
    },
    SNO: {
      airportCode: "SNO",
      city: "Sakon Nakhon",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Sakon Nakhon Airport",
    },
    SNP: {
      airportCode: "SNP",
      city: "Saint Paul Island",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Saint Paul Island Airport",
    },
    SCL: {
      airportCode: "SCL",
      city: "Santiago",
      countryId: "CL",
      countryCode: "152",
      internationalAirportName: "Arturo Merino Benitez Intl",
    },
    LAP: {
      airportCode: "LAP",
      city: "La Paz",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "General Manuel Marquez De Leon Intl",
    },
    HCQ: {
      airportCode: "HCQ",
      city: "Halls Creek",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Halls Creek Airport",
    },
    VAN: {
      airportCode: "VAN",
      city: "Van",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Van Ferit Melen Airport",
    },
    KNY: {
      airportCode: "KNY",
      city: "Kenyam",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kenyam",
    },
    HUO: {
      airportCode: "HUO",
      city: "Huolinguole",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Holingol Huolinhe Airport",
    },
    KWB: {
      airportCode: "KWB",
      city: "Karimunjawa",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dewadaru Airport",
    },
    RKD: {
      airportCode: "RKD",
      city: "Rockland",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Knox County Regional Airport",
    },
    HIR: {
      airportCode: "HIR",
      city: "Honiara",
      countryId: "SB",
      countryCode: "090",
      internationalAirportName: "Honiara Int'l",
    },
    KKC: {
      airportCode: "KKC",
      city: "Khon Kaen",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Khon Kaen Airport",
    },
    BUD: {
      airportCode: "BUD",
      city: "Budapest",
      countryId: "HU",
      countryCode: "348",
      internationalAirportName: "Ferihegy Int'l",
    },
    CVU: {
      airportCode: "CVU",
      city: "Corvo Island (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Corvo Island Airport",
    },
    ASW: {
      airportCode: "ASW",
      city: "Aswan",
      countryId: "EG",
      countryCode: "818",
      internationalAirportName: "Aswan International Airport",
    },
    CUF: {
      airportCode: "CUF",
      city: "Cuneo",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Cuneo Levaldigi Airport",
    },
    KOT: {
      airportCode: "KOT",
      city: "Kotlik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kotlik Airport",
    },
    TAG: {
      airportCode: "TAG",
      city: "Tagbilaran",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Tagbilaran",
    },
    TUG: {
      airportCode: "TUG",
      city: "Tuguegarao",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Tuguegarao Airport",
    },
    PIK: {
      airportCode: "PIK",
      city: "Glasgow",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Glasgow Prestwick Airport",
    },
    DEB: {
      airportCode: "DEB",
      city: "Debrecen",
      countryId: "HU",
      countryCode: "348",
      internationalAirportName: "Debrecen International Airport",
    },
    PDV: {
      airportCode: "PDV",
      city: "Plovdiv",
      countryId: "BG",
      countryCode: "100",
      internationalAirportName: "Plovdiv Krumovo Airport",
    },
    HOR: {
      airportCode: "HOR",
      city: "Horta (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Horta Airport",
    },
    AMQ: {
      airportCode: "AMQ",
      city: "Ambon",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pattimura",
    },
    TRM: {
      airportCode: "TRM",
      city: "Thermal",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Thermal Jacqueline Cochran Regional Airport",
    },
    YIO: {
      airportCode: "YIO",
      city: "Pond Inlet",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Pond Inlet Airport",
    },
    VRY: {
      airportCode: "VRY",
      city: "Vaeroy",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Vaeroy Heliport",
    },
    ATL: {
      airportCode: "ATL",
      city: "Atlanta",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hartsfield Jackson Atlanta Intl",
    },
    LCX: {
      airportCode: "LCX",
      city: "Longyan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Longyan Guanzhishan Airport",
    },
    YNT: {
      airportCode: "YNT",
      city: "Yantai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yantai Penglai Int'l Airport",
    },
    LKI: {
      airportCode: "LKI",
      city: "Sinabang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Lasikin Airport",
    },
    LNV: {
      airportCode: "LNV",
      city: "Lihir Island",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Lihir Island Airport",
    },
    LHR: {
      airportCode: "LHR",
      city: "London",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Heathrow",
    },
    FLL: {
      airportCode: "FLL",
      city: "Fort Lauderdale",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Fort Lauderdale Hollywood Intl",
    },
    OKD: {
      airportCode: "OKD",
      city: "Sapporo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Okadama Airport",
    },
    ERF: {
      airportCode: "ERF",
      city: "Erfurt",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Erfurt Weimar Airport",
    },
    HOT: {
      airportCode: "HOT",
      city: "Hot Springs",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hot Springs Memorial Field Airport",
    },
    GLV: {
      airportCode: "GLV",
      city: "Golovin",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Golovin Airport",
    },
    USM: {
      airportCode: "USM",
      city: "Ko Samui",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Samui",
    },
    WBQ: {
      airportCode: "WBQ",
      city: "Beaver",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Beaver Airport",
    },
    YSK: {
      airportCode: "YSK",
      city: "Sanikiluaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sanikiluaq Airport",
    },
    YIF: {
      airportCode: "YIF",
      city: "Pakuashipi",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Saint Augustin Pakuashipi Airport",
    },
    GLN: {
      airportCode: "GLN",
      city: "Goulimime",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Guelmim Airport",
    },
    FIH: {
      airportCode: "FIH",
      city: "Kinshasa",
      countryId: "CD",
      countryCode: "180",
      internationalAirportName: "Ndjili Intl",
    },
    KOP: {
      airportCode: "KOP",
      city: "Nakhon Phanom",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Nakhon Phanom Airport",
    },
    CNS: {
      airportCode: "CNS",
      city: "Cairns",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Cairns Intl",
    },
    AIA: {
      airportCode: "AIA",
      city: "Alliance",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Alliance Municipal Airport",
    },
    MJF: {
      airportCode: "MJF",
      city: "Mosjoen",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Mosjoen Kjaerstad Airport",
    },
    GET: {
      airportCode: "GET",
      city: "Geraldton",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Geraldton Airport",
    },
    IWJ: {
      airportCode: "IWJ",
      city: "Masuda",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Iwami Airport",
    },
    HRB: {
      airportCode: "HRB",
      city: "Harbin",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Taiping Airport",
    },
    BVE: {
      airportCode: "BVE",
      city: "Brive-La-Gaillarde",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Brive Souillac Vallee de la Dordogne Airport",
    },
    SYD: {
      airportCode: "SYD",
      city: "Sydney",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Sydney Intl",
    },
    VUS: {
      airportCode: "VUS",
      city: "Velikij Ustyug",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Veliky Ustyug Airport",
    },
    SHI: {
      airportCode: "SHI",
      city: "Shimojishima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Shimojishima Airport",
    },
    OMR: {
      airportCode: "OMR",
      city: "Oradea",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Oradea International Airport",
    },
    BHD: {
      airportCode: "BHD",
      city: "Belfast",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "George Best Belfast City",
    },
    SDN: {
      airportCode: "SDN",
      city: "Sandane",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Sandane Airport",
    },
    BKI: {
      airportCode: "BKI",
      city: "Kota Kinabalu",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Kota Kinabalu Intl",
    },
    NRN: {
      airportCode: "NRN",
      city: "Dusseldorf",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Dusseldorf Weeze Airport",
    },
    GOQ: {
      airportCode: "GOQ",
      city: "Golmud",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Golmud Airport",
    },
    KRN: {
      airportCode: "KRN",
      city: "Kiruna",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Kiruna Airport",
    },
    EBB: {
      airportCode: "EBB",
      city: "Entebbe",
      countryId: "UG",
      countryCode: "800",
      internationalAirportName: "Entebbe Intl",
    },
    HOM: {
      airportCode: "HOM",
      city: "Homer",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Homer Airport",
    },
    GDL: {
      airportCode: "GDL",
      city: "Guadalajara",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Don Miguel Hidalgo Y Costilla Intl",
    },
    BBU: {
      airportCode: "BBU",
      city: "Bucharest",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Bucharest Baneasa Aurel Vlaicu Intl Airport",
    },
    BFI: {
      airportCode: "BFI",
      city: "Seattle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "King County International Airport",
    },
    HKD: {
      airportCode: "HKD",
      city: "Hakodate",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Hakodate Airport",
    },
    TNC: {
      airportCode: "TNC",
      city: "Tin City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tin City AFS",
    },
    KGC: {
      airportCode: "KGC",
      city: "Kingscote",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Kingscote Airport",
    },
    NOU: {
      airportCode: "NOU",
      city: "Noumea",
      countryId: "NC",
      countryCode: "540",
      internationalAirportName: "La Tontouta International Airport",
    },
    GIC: {
      airportCode: "GIC",
      city: "Boigu Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Boigu Island Airport",
    },
    ORY: {
      airportCode: "ORY",
      city: "Paris",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Orly",
    },
    SXK: {
      airportCode: "SXK",
      city: "Saumlaki",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Saumlaki",
    },
    DRB: {
      airportCode: "DRB",
      city: "Derby",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Derby Airport",
    },
    AUG: {
      airportCode: "AUG",
      city: "Augusta",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Augusta State Airport",
    },
    CNC: {
      airportCode: "CNC",
      city: "Coconut Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Coconut Island Airport",
    },
    IBR: {
      airportCode: "IBR",
      city: "Ibaraki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Ibaraki Airport",
    },
    YNZ: {
      airportCode: "YNZ",
      city: "Yancheng",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yancheng Nanyang Int'l Airport",
    },
    WEH: {
      airportCode: "WEH",
      city: "Weihai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Weihai Airport",
    },
    EMK: {
      airportCode: "EMK",
      city: "Emmonak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Emmonak Airport",
    },
    LEE: {
      airportCode: "LEE",
      city: "United States",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Leesburg International Airport",
    },
    TKN: {
      airportCode: "TKN",
      city: "Tokunoshima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tokunoshima Airport",
    },
    DUT: {
      airportCode: "DUT",
      city: "Dutch Harbor",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Driftwood Bay AFS",
    },
    CLD: {
      airportCode: "CLD",
      city: "Carlsbad",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "McClellan-Palomar Airport",
    },
    ZUM: {
      airportCode: "ZUM",
      city: "Churchill Falls",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Churchill Falls Airport",
    },
    UGI: {
      airportCode: "UGI",
      city: "Uganik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Sn Juan Uganik Seaplane Base",
    },
    LUW: {
      airportCode: "LUW",
      city: "Luwuk",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Syukuran Aminuddin Amir/Bubung",
    },
    KBC: {
      airportCode: "KBC",
      city: "Birch Creek",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Birch Creek Airport",
    },
    SJZ: {
      airportCode: "SJZ",
      city: "Sao Jorge Island",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Sao Jorge Airport",
    },
    HNH: {
      airportCode: "HNH",
      city: "Hoonah",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hoonah Airport",
    },
    NNG: {
      airportCode: "NNG",
      city: "Nanning",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wuxu Airport",
    },
    LPI: {
      airportCode: "LPI",
      city: "Linkoeping",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Linkoping City Airport",
    },
    HNL: {
      airportCode: "HNL",
      city: "Honolulu Hawaii",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Honolulu Intl",
    },
    SUA: {
      airportCode: "SUA",
      city: "Stuart",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Witham Field",
    },
    PPV: {
      airportCode: "PPV",
      city: "Port Protection",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Protection Seaplane Base",
    },
    SUB: {
      airportCode: "SUB",
      city: "Surabaya",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Juanda",
    },
    YPA: {
      airportCode: "YPA",
      city: "Prince Albert",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Prince Albert Airport",
    },
    RMI: {
      airportCode: "RMI",
      city: "Rimini",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Rimini Federico Fellini International Airport",
    },
    NLD: {
      airportCode: "NLD",
      city: "Nuevo Laredo",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Quetzalcoatl Intl",
    },
    SMG: {
      airportCode: "SMG",
      city: "Simeulue",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Lasikin Airport",
    },
    AOE: {
      airportCode: "AOE",
      city: "Eskissehir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Anadolu Airport",
    },
    CCJ: {
      airportCode: "CCJ",
      city: "Karipur",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Calicut International Airport",
    },
    CJM: {
      airportCode: "CJM",
      city: "Chumphon",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Chumphon",
    },
    VCL: {
      airportCode: "VCL",
      city: "Chu Lai",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Chu Lai Airport",
    },
    SUR: {
      airportCode: "SUR",
      city: "Summer Beaver",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Summer Beaver Airport",
    },
    WWK: {
      airportCode: "WWK",
      city: "Wewak",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Wewak Airport",
    },
    UAQ: {
      airportCode: "UAQ",
      city: "San Julian",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "San Juan",
    },
    PXC: {
      airportCode: "PXC",
      city: "Puruk Cahu",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dirung Lingkin",
    },
    YMN: {
      airportCode: "YMN",
      city: "Makkovik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Makkovik Airport",
    },
    ZAM: {
      airportCode: "ZAM",
      city: "Zamboanga",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Zamboanga Intl",
    },
    BNK: {
      airportCode: "BNK",
      city: "Ballina Byron Bay",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Ballina Byron Gateway",
    },
    EDO: {
      airportCode: "EDO",
      city: "Balıkesir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Balıkesir Koca Seyit Airport",
    },
    KWE: {
      airportCode: "KWE",
      city: "Guiyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Longdongbao",
    },
    TKU: {
      airportCode: "TKU",
      city: "Turku",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Turku Airport",
    },
    KGF: {
      airportCode: "KGF",
      city: "Karaganda",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Sary-Arka Airport",
    },
    KGT: {
      airportCode: "KGT",
      city: "Kangding",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Kangding Airport",
    },
    ANX: {
      airportCode: "ANX",
      city: "Andenes",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Andoya Airport",
    },
    GDV: {
      airportCode: "GDV",
      city: "Glendive",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Dawson Community Airport",
    },
    GEV: {
      airportCode: "GEV",
      city: "Gallivare",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Gallivare Lapland Airport",
    },
    POM: {
      airportCode: "POM",
      city: "Port Moresby",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Jacksons International Airport",
    },
    SZF: {
      airportCode: "SZF",
      city: "Samsun",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Samsun-Carsamba Airport",
    },
    XGR: {
      airportCode: "XGR",
      city: "Kangiqsualujjuaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kangiqsualujjuaq Georges River Airport",
    },
    SYY: {
      airportCode: "SYY",
      city: "Stornoway, Outer Stat Hebrides",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Stornoway Airport",
    },
    SJW: {
      airportCode: "SJW",
      city: "Shijiazhuang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shijiazhuang Zhengding Int'l Airport",
    },
    MLG: {
      airportCode: "MLG",
      city: "Malang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Abdul Rachman Saleh",
    },
    KWI: {
      airportCode: "KWI",
      city: "Kuwait",
      countryId: "KW",
      countryCode: "414",
      internationalAirportName: "Kuwait International Airport",
    },
    SGQ: {
      airportCode: "SGQ",
      city: "Sangatta",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tanjung Bara",
    },
    LWO: {
      airportCode: "LWO",
      city: "Lviv",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Lviv Danylo Halytskyi International Airport ",
    },
    GNS: {
      airportCode: "GNS",
      city: "Gunung Sitoli",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Binaka",
    },
    MTU: {
      airportCode: "MTU",
      city: "Muara Teweh",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Beringin Airport",
    },
    SAW: {
      airportCode: "SAW",
      city: "Istanbul",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Sabiha Gokcen",
    },
    ZIA: {
      airportCode: "ZIA",
      city: "Zhukovsky",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Moscow Zhukovsky international Airport",
    },
    PRH: {
      airportCode: "PRH",
      city: "Phrae",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Phrae",
    },
    CTN: {
      airportCode: "CTN",
      city: "Cooktown",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Cooktown Airport",
    },
    PBO: {
      airportCode: "PBO",
      city: "Paraburdoo",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Paraburdoo Airport",
    },
    LUN: {
      airportCode: "LUN",
      city: "Lusaka",
      countryId: "ZM",
      countryCode: "894",
      internationalAirportName: "Lusaka Intl",
    },
    KZR: {
      airportCode: "KZR",
      city: "Kütahya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Zafer Airport",
    },
    DDR: {
      airportCode: "DDR",
      city: "Xigaze/Rikaze",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xigaze Dingri Airport",
    },
    SVA: {
      airportCode: "SVA",
      city: "Savoonga",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Savoonga Airport",
    },
    KWK: {
      airportCode: "KWK",
      city: "Kwigillingok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kwigillingok Airport",
    },
    SVS: {
      airportCode: "SVS",
      city: "Stevens Village",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Stevens Village Airport",
    },
    ZQN: {
      airportCode: "ZQN",
      city: "Queenstown",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Queenstown",
    },
    NNT: {
      airportCode: "NNT",
      city: "Nan",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Nan Airport",
    },
    MAQ: {
      airportCode: "MAQ",
      city: "Mae Sot",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Mae Sot Airport",
    },
    HLP: {
      airportCode: "HLP",
      city: "Jakarta",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Halim Perdanakusuma Int'l",
    },
    RGT: {
      airportCode: "RGT",
      city: "Rengat",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Japura Airport",
    },
    USH: {
      airportCode: "USH",
      city: "Ushuaia",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Ushuaia Malvinas Argentinas",
    },
    OBU: {
      airportCode: "OBU",
      city: "Kobuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kobuk Wien Airport",
    },
    ABA: {
      airportCode: "ABA",
      city: "Abakan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Abakan Airport",
    },
    SKT: {
      airportCode: "SKT",
      city: "Sialkot",
      countryId: "PK",
      countryCode: "586",
      internationalAirportName: "Sialkot Airport",
    },
    HDY: {
      airportCode: "HDY",
      city: "Hat Yai",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Hat Yai Intl",
    },
    NAG: {
      airportCode: "NAG",
      city: "Maharashtra",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Dr. Babasaheb Ambedkar International Airport",
    },
    KRS: {
      airportCode: "KRS",
      city: "Kristiansand",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Kjevik",
    },
    VAI: {
      airportCode: "VAI",
      city: "Vanimo",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Vanimo Airport",
    },
    TSV: {
      airportCode: "TSV",
      city: "Townsville",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Townsville Airport",
    },
    MAN: {
      airportCode: "MAN",
      city: "Manchester",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Manchester Airport",
    },
    ROB: {
      airportCode: "ROB",
      city: "Monrovia",
      countryId: "LR",
      countryCode: "430",
      internationalAirportName: "Roberts International Airport",
    },
    FRA: {
      airportCode: "FRA",
      city: "Frankfurt",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Frankfurt Main",
    },
    BRU: {
      airportCode: "BRU",
      city: "Brussels",
      countryId: "BE",
      countryCode: "056",
      internationalAirportName: "Brussels Natl",
    },
    OZC: {
      airportCode: "OZC",
      city: "Ozamiz",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Labo",
    },
    RGN: {
      airportCode: "RGN",
      city: "Yangon",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Yangon Intl",
    },
    NAW: {
      airportCode: "NAW",
      city: "Narathiwat",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Narathiwat Airport",
    },
    SFO: {
      airportCode: "SFO",
      city: "San Francisco",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "San Francisco Intl",
    },
    PZI: {
      airportCode: "PZI",
      city: "Pan Zhi Hua",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Panzhihua Bao'angong Airport",
    },
    PDS: {
      airportCode: "PDS",
      city: "Piedras Negras",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Piedras Negras International Airport",
    },
    YMT: {
      airportCode: "YMT",
      city: "Chibougamau",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Chibougamau Chapais Airport",
    },
    MNL: {
      airportCode: "MNL",
      city: "Manila",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Ninoy Aquino Intl",
    },
    RES: {
      airportCode: "RES",
      city: "Resistencia",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Resistencia",
    },
    OZZ: {
      airportCode: "OZZ",
      city: "Ouarzazate",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Ouarzazate Airport",
    },
    MEQ: {
      airportCode: "MEQ",
      city: "Meulaboh",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Cut Nyak Dhien",
    },
    YKO: {
      airportCode: "YKO",
      city: "Yuksekova",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Hakkari Yuksekova Airport",
    },
    DCM: {
      airportCode: "DCM",
      city: "Castres",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Castres Mazamet Airport",
    },
    DME: {
      airportCode: "DME",
      city: "Moscow",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Moscow Domododevo Airport",
    },
    PXM: {
      airportCode: "PXM",
      city: "Puerto Escondido",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Puerto Escondido Intl",
    },
    LSA: {
      airportCode: "LSA",
      city: "Losuia",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Losuia Airport",
    },
    LWK: {
      airportCode: "LWK",
      city: "Shetland Islands",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Lerwick Tingwall Airport",
    },
    EMA: {
      airportCode: "EMA",
      city: "Leicestershire",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "East Midlands Airport",
    },
    CDG: {
      airportCode: "CDG",
      city: "Paris",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Charles De Gaulle",
    },
    BIK: {
      airportCode: "BIK",
      city: "Biak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Frans Kaisiepo",
    },
    FIE: {
      airportCode: "FIE",
      city: "Fair Isle",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Fair Isle Airport",
    },
    BLD: {
      airportCode: "BLD",
      city: "Boulder City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Boulder City Municipal Airport",
    },
    JIK: {
      airportCode: "JIK",
      city: "Ikaria Island",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Ikaria Island National Airport",
    },
    MTM: {
      airportCode: "MTM",
      city: "Metlakatla",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Metlakatla Seaplane Base",
    },
    SHH: {
      airportCode: "SHH",
      city: "Shishmaref",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Shishmaref Airport",
    },
    HUY: {
      airportCode: "HUY",
      city: "Humberside",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Humberside Airport",
    },
    CRD: {
      airportCode: "CRD",
      city: "Comodoro Rivadavia",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Comodoro Rivadavia",
    },
    VPN: {
      airportCode: "VPN",
      city: "Vopnafjordur",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Vopnafjordur Airport",
    },
    CSA: {
      airportCode: "CSA",
      city: "Colonsay Island",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Colonsay Airport",
    },
    SYM: {
      airportCode: "SYM",
      city: "Pu'er",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Pu'er Simao Airport",
    },
    BRC: {
      airportCode: "BRC",
      city: "San Carlos De Bariloch",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "San Carlos De Bariloche",
    },
    YFJ: {
      airportCode: "YFJ",
      city: "Snare Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Wekweeti Airport",
    },
    GRY: {
      airportCode: "GRY",
      city: "Grimsey",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Grimsey Airport",
    },
    NSW: {
      airportCode: "NSW",
      city: "Cijulang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Cijulang Nusawiru",
    },
    KUK: {
      airportCode: "KUK",
      city: "Kasigluk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kasigluk Airport",
    },
    LAB: {
      airportCode: "LAB",
      city: "Lablab",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Lab Lab Airport",
    },
    LST: {
      airportCode: "LST",
      city: "Launceston",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Launceston Airport",
    },
    FBM: {
      airportCode: "FBM",
      city: "Lubumbashi",
      countryId: "CD",
      countryCode: "180",
      internationalAirportName: "Lubumbashi Intl",
    },
    YYQ: {
      airportCode: "YYQ",
      city: "Churchill",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Churchill Airport",
    },
    ZMZ: {
      airportCode: "ZMZ",
      city: "Bangkok",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "AAA airport",
    },
    WTL: {
      airportCode: "WTL",
      city: "Tuntutuliak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tuntutuliak Airport",
    },
    MUE: {
      airportCode: "MUE",
      city: "Kamuela",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Waimea-Kohala Airport",
    },
    GUP: {
      airportCode: "GUP",
      city: "Gallup",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Gallup Senator Clark Municipal Airport",
    },
    WBM: {
      airportCode: "WBM",
      city: "Wapenamanda",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Wapenamanda Airport",
    },
    GMP: {
      airportCode: "GMP",
      city: "Seoul",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Gimpo",
    },
    BGG: {
      airportCode: "BGG",
      city: "Bingol",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Bingol Airport",
    },
    DNK: {
      airportCode: "DNK",
      city: "Dnipropetrovsk",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Dnipropetrovsk Intl",
    },
    UNG: {
      airportCode: "UNG",
      city: "Kiunga",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Kiunga Airport",
    },
    UGS: {
      airportCode: "UGS",
      city: "Ugashik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ugashik Airport",
    },
    TRZ: {
      airportCode: "TRZ",
      city: "Tiruchirappalli (Trichy)",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Tiruchirappalli Int'l",
    },
    EYK: {
      airportCode: "EYK",
      city: "Beloyarsky",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Beloyarsky Airport",
    },
    TMW: {
      airportCode: "TMW",
      city: "Tamworth",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Tamworth Airport",
    },
    GRW: {
      airportCode: "GRW",
      city: "Graciosa Island (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Graciosa Airport",
    },
    UPN: {
      airportCode: "UPN",
      city: "Uruapan",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Licenciado Y Gen Ignacio Lopez Rayon",
    },
    REL: {
      airportCode: "REL",
      city: "Trelew",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Almirante Zar",
    },
    YYC: {
      airportCode: "YYC",
      city: "Calgary",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Calgary Intl",
    },
    KOZ: {
      airportCode: "KOZ",
      city: "Ouzinkie",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ouzinkie Airport",
    },
    CRK: {
      airportCode: "CRK",
      city: "Clark - Pampanga",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Diosdado Macapagal Int'l",
    },
    CPC: {
      airportCode: "CPC",
      city: "San Martin Des Andes",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Aviador C Campos",
    },
    MJZ: {
      airportCode: "MJZ",
      city: "Mirnyj",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Mirny Airport",
    },
    IXE: {
      airportCode: "IXE",
      city: "Bajpe",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Mangaluru International Airport",
    },
    CXR: {
      airportCode: "CXR",
      city: "Nha Trang",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Cam Ranh",
    },
    PIX: {
      airportCode: "PIX",
      city: "Pico Island (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Pico Airport",
    },
    WGE: {
      airportCode: "WGE",
      city: "Walgett",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Walgett Airport",
    },
    RMP: {
      airportCode: "RMP",
      city: "Rampart",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Rampart Airport",
    },
    FUO: {
      airportCode: "FUO",
      city: "Fuoshan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Foshan Shadi Airport",
    },
    OIR: {
      airportCode: "OIR",
      city: "Okushiri",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Okushiri Airport",
    },
    YZG: {
      airportCode: "YZG",
      city: "Salluit",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Salluit Airport",
    },
    ZMT: {
      airportCode: "ZMT",
      city: "Masset",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Masset Airport",
    },
    TPE: {
      airportCode: "TPE",
      city: "Taipei",
      countryId: "TW",
      countryCode: "158",
      internationalAirportName: "Taoyuan Intl",
    },
    LUP: {
      airportCode: "LUP",
      city: "Kalaupapa",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kalaupapa Airport",
    },
    NWI: {
      airportCode: "NWI",
      city: "Norwich",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Norwich Int'l",
    },
    BOG: {
      airportCode: "BOG",
      city: "Bogota",
      countryId: "CO",
      countryCode: "170",
      internationalAirportName: "El Dorado Intl",
    },
    YBX: {
      airportCode: "YBX",
      city: "Blanc Sablon",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Lourdes-de-Blanc Sablon Airport",
    },
    RDN: {
      airportCode: "RDN",
      city: "Redang Island",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Redang Airport",
    },
    MXN: {
      airportCode: "MXN",
      city: "Morlaix",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Morlaix Ploujean Airport",
    },
    ONG: {
      airportCode: "ONG",
      city: "Mornington",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mornington Island Airport",
    },
    NKI: {
      airportCode: "NKI",
      city: "Naukiti",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Naukati Bay Seaplane Base",
    },
    BEG: {
      airportCode: "BEG",
      city: "Belgrade",
      countryId: "RS",
      countryCode: "688",
      internationalAirportName: "Belgrade Airport",
    },
    LAK: {
      airportCode: "LAK",
      city: "Aklavik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Aklavik Freddie Carmichael Airport",
    },
    KPX: {
      airportCode: "KPX",
      city: "Seruyan Hilir",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kuala Pembuang",
    },
    SGY: {
      airportCode: "SGY",
      city: "Skagway",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Skagway Municipal Airport",
    },
    OUD: {
      airportCode: "OUD",
      city: "Oujda",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Oujda Angads Airport",
    },
    XNT: {
      airportCode: "XNT",
      city: "Xingtai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xingtai Dalian Airport",
    },
    CYF: {
      airportCode: "CYF",
      city: "Chefornak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chefornak Airport",
    },
    UUD: {
      airportCode: "UUD",
      city: "Ulan-Ude",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Baikal International Airport",
    },
    KWN: {
      airportCode: "KWN",
      city: "Quinhagak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Quinhagak Airport",
    },
    GLT: {
      airportCode: "GLT",
      city: "Gladstone",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Gladstone Airport",
    },
    URC: {
      airportCode: "URC",
      city: "Urumqi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Diwopu",
    },
    KSM: {
      airportCode: "KSM",
      city: "Saint Mary's",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Saint Mary's Airport",
    },
    NAY: {
      airportCode: "NAY",
      city: "Beijing",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Beijing Nanyuan Airport",
    },
    SHA: {
      airportCode: "SHA",
      city: "Shanghai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Hongqiao International Airport",
    },
    YVO: {
      airportCode: "YVO",
      city: "Val D'Or",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Val-d'Or Airport",
    },
    BOO: {
      airportCode: "BOO",
      city: "Bodo",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Bodo Airport",
    },
    OIT: {
      airportCode: "OIT",
      city: "Oita",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Oita",
    },
    WKJ: {
      airportCode: "WKJ",
      city: "Wakkanai",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Wakkanai Airport",
    },
    KWM: {
      airportCode: "KWM",
      city: "Kowanyama",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Kowanyama Airport",
    },
    WUS: {
      airportCode: "WUS",
      city: "Wuyishan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wuyishan Airport",
    },
    AXJ: {
      airportCode: "AXJ",
      city: "Amakusa",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Amakusa Airfield",
    },
    OBN: {
      airportCode: "OBN",
      city: "Oban",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "North Connel Oban Airport",
    },
    GOX: {
      airportCode: "GOX",
      city: "Goa",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Goa Manohar International Airport",
    },
    AXF: {
      airportCode: "AXF",
      city: "Alxa Left Banner",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Alxa Left Banner Airport",
    },
    BHX: {
      airportCode: "BHX",
      city: "Birmingham",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Birmingham",
    },
    MVD: {
      airportCode: "MVD",
      city: "Montevideo",
      countryId: "UY",
      countryCode: "858",
      internationalAirportName: "Carrasco International Airport",
    },
    DLI: {
      airportCode: "DLI",
      city: "Da Lat",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Dalat Airport",
    },
    CGK: {
      airportCode: "CGK",
      city: "Jakarta",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Soekarno Hatta Intl Airport",
    },
    YNL: {
      airportCode: "YNL",
      city: "Points North Landing",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Points North Landing Airport",
    },
    GXH: {
      airportCode: "GXH",
      city: "Xiahe",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Gannan Xiahe Airport",
    },
    YHS: {
      airportCode: "YHS",
      city: "Sechelt",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sechelt Airport",
    },
    YQG: {
      airportCode: "YQG",
      city: "Windsor",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Windsor International Airport",
    },
    HNA: {
      airportCode: "HNA",
      city: "Hanamaki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Hanamaki",
    },
    SJD: {
      airportCode: "SJD",
      city: "San Jose Del Cabo",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Los Cabos International Airport",
    },
    PKC: {
      airportCode: "PKC",
      city: "Petropavlovsk-Kamchatsky",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Petropavlovsk-Kamchatsky Airport",
    },
    SCW: {
      airportCode: "SCW",
      city: "Syktyvkar",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Syktyvkar Airport",
    },
    ALA: {
      airportCode: "ALA",
      city: "Almaty",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Almaty International Airport",
    },
    YNC: {
      airportCode: "YNC",
      city: "Wemindji",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Wemindji Airport",
    },
    KCG: {
      airportCode: "KCG",
      city: "Chignik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chignik Fisheries Airport",
    },
    YHY: {
      airportCode: "YHY",
      city: "Hay River",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Hay River Merlyn Carter Airport",
    },
    NAL: {
      airportCode: "NAL",
      city: "Nalchik",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Nalchik Airport",
    },
    PWQ: {
      airportCode: "PWQ",
      city: "Pavlodar",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Pavlodar International Airport",
    },
    YSG: {
      airportCode: "YSG",
      city: "Lutselke/Snowdrift",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Lutselke Airport",
    },
    DRW: {
      airportCode: "DRW",
      city: "Darwin",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Darwin Intl",
    },
    YEG: {
      airportCode: "YEG",
      city: "Edmonton",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Edmonton Intl",
    },
    BNE: {
      airportCode: "BNE",
      city: "Brisbane",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Brisbane Intl",
    },
    PIZ: {
      airportCode: "PIZ",
      city: "Point Lay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Point Lay Dew Station Airport",
    },
    TYO: {
      airportCode: "TYO",
      city: "Tokyo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tokyo City",
    },
    ILI: {
      airportCode: "ILI",
      city: "Iliamna",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Iliamna Airport",
    },
    IST: {
      airportCode: "IST",
      city: "Istanbul",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "New Istanbul Airport",
    },
    MCY: {
      airportCode: "MCY",
      city: "Maroochydore",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Maroochydore Sunshine Coast",
    },
    KLK: {
      airportCode: "KLK",
      city: "Kuala Kurun",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kuala Kurun Airport",
    },
    JED: {
      airportCode: "JED",
      city: "Jeddah",
      countryId: "SA",
      countryCode: "682",
      internationalAirportName: "King Abdulaziz Intl",
    },
    LYG: {
      airportCode: "LYG",
      city: "Lianyungang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Lianyungang Airport",
    },
    YOC: {
      airportCode: "YOC",
      city: "Old Crow",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Old Crow Airport",
    },
    KYZ: {
      airportCode: "KYZ",
      city: "Kyzyl",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kyzyl Airport",
    },
    OER: {
      airportCode: "OER",
      city: "Ornskoldsvik",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Ornskoldsvik Airport",
    },
    KVA: {
      airportCode: "KVA",
      city: "Kavala",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kavala Megas Alexandros Airport",
    },
    PBH: {
      airportCode: "PBH",
      city: "Paro",
      countryId: "BT",
      countryCode: "064",
      internationalAirportName: "Paro International Airport",
    },
    IAR: {
      airportCode: "IAR",
      city: "Yaroslavl",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Yaroslavl Tunoshna Airport",
    },
    NOP: {
      airportCode: "NOP",
      city: "Sinop",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Sinop Airport",
    },
    AKX: {
      airportCode: "AKX",
      city: "Aktobe",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Aktobe International Airport",
    },
    YZT: {
      airportCode: "YZT",
      city: "Port Hardy",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Port Hardy Airport",
    },
    HKN: {
      airportCode: "HKN",
      city: "Hoskins",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Hoskins Airport",
    },
    KTG: {
      airportCode: "KTG",
      city: "Ketapang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Rahadi Usman",
    },
    VCS: {
      airportCode: "VCS",
      city: "Con Dao",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Co Ong Airport",
    },
    KMG: {
      airportCode: "KMG",
      city: "Kunming",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Kunming Changshui Intl Airport",
    },
    AMM: {
      airportCode: "AMM",
      city: "Amman",
      countryId: "JO",
      countryCode: "400",
      internationalAirportName: "Amman Queen Alia International Airport",
    },
    CAN: {
      airportCode: "CAN",
      city: "Guangzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baiyun Intl",
    },
    KXB: {
      airportCode: "KXB",
      city: "Kolaka",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sangia Nibandera",
    },
    MAG: {
      airportCode: "MAG",
      city: "Madang",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Madang Airport",
    },
    EWB: {
      airportCode: "EWB",
      city: "New Bedford",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "New Bedford Regional Airport",
    },
    ZPB: {
      airportCode: "ZPB",
      city: "Sachigo Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sachigo Lake Airport",
    },
    SYU: {
      airportCode: "SYU",
      city: "Sue Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Warraber Island Airport",
    },
    IRJ: {
      airportCode: "IRJ",
      city: "La Rioja",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "La Rioja",
    },
    VLI: {
      airportCode: "VLI",
      city: "Port Vila",
      countryId: "VU",
      countryCode: "548",
      internationalAirportName: "Bauerfield International Airport",
    },
    KQA: {
      airportCode: "KQA",
      city: "Akutan",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Akutan Airport",
    },
    AFA: {
      airportCode: "AFA",
      city: "San Rafael",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "San Rafael",
    },
    IWA: {
      airportCode: "IWA",
      city: "Ivanovo",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Ivanovo Yuzhny Airport",
    },
    CEM: {
      airportCode: "CEM",
      city: "Central",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Central Airport (Alaska)",
    },
    KOE: {
      airportCode: "KOE",
      city: "Kupang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "El Tari",
    },
    CGA: {
      airportCode: "CGA",
      city: "Craig",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Craig Seaplane Base",
    },
    HVR: {
      airportCode: "HVR",
      city: "Havre",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Havre City-County Airport",
    },
    GUR: {
      airportCode: "GUR",
      city: "Alotau",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Gurney Airport",
    },
    RAB: {
      airportCode: "RAB",
      city: "Rabaul",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Rabaul Airport",
    },
    TJQ: {
      airportCode: "TJQ",
      city: "Tanjung Pandan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "H. AS Hanandjoeddin",
    },
    TFY: {
      airportCode: "TFY",
      city: "Krui",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Muhammad Taufiq Kiemas",
    },
    KRT: {
      airportCode: "KRT",
      city: "Khartoum",
      countryId: "SD",
      countryCode: "729",
      internationalAirportName: "Khartoum",
    },
    HGU: {
      airportCode: "HGU",
      city: "Mount Hagen",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Mount Hagen Airport",
    },
    CME: {
      airportCode: "CME",
      city: "Ciudad Del Carmen",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Ciudad Del Carmen Intl",
    },
    TZX: {
      airportCode: "TZX",
      city: "Trabzon",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Trabzon Airport",
    },
    YPX: {
      airportCode: "YPX",
      city: "Povungnituk",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Puvirnituq Airport",
    },
    PER: {
      airportCode: "PER",
      city: "Perth",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Perth Airport",
    },
    LPY: {
      airportCode: "LPY",
      city: "Le Puy",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Le Puy Loudes Airport",
    },
    DYG: {
      airportCode: "DYG",
      city: "Dayong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Dayong Airport",
    },
    DAD: {
      airportCode: "DAD",
      city: "Da Nang",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Da Nang International",
    },
    LCJ: {
      airportCode: "LCJ",
      city: "Lodz",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Lodz Wladyslaw Reymont Airport",
    },
    MSP: {
      airportCode: "MSP",
      city: "Minneapolis",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Minneapolis St Paul Intl",
    },
    USU: {
      airportCode: "USU",
      city: "Coron - Palawan",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Francisco B",
    },
    HUI: {
      airportCode: "HUI",
      city: "Hue",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Phu Bai International",
    },
    PQS: {
      airportCode: "PQS",
      city: "Pilot Station",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Pilot Station Airport",
    },
    GLX: {
      airportCode: "GLX",
      city: "Galela",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Gamar Malamo",
    },
    IEJ: {
      airportCode: "IEJ",
      city: "Iejima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Iejima Airport",
    },
    THO: {
      airportCode: "THO",
      city: "Thorshofn",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Thorshofn Airport",
    },
    PMV: {
      airportCode: "PMV",
      city: "Porlamar",
      countryId: "VE",
      countryCode: "862",
      internationalAirportName: "Porlamar Del Caribe Gen S Marino Intl Airport",
    },
    ATH: {
      airportCode: "ATH",
      city: "Athens",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Eleftherios Venizelos Intl",
    },
    IGD: {
      airportCode: "IGD",
      city: "Igdır",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Igdır Airport",
    },
    LOS: {
      airportCode: "LOS",
      city: "Lagos",
      countryId: "NG",
      countryCode: "566",
      internationalAirportName: "Murtala Muhammed",
    },
    KPB: {
      airportCode: "KPB",
      city: "Point Baker",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Point Baker Seaplane Base",
    },
    XWC: {
      airportCode: "XWC",
      city: "Vienna",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "XWC",
    },
    BUU: {
      airportCode: "BUU",
      city: "Muara Bungo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Muara Bungo Airport",
    },
    YYL: {
      airportCode: "YYL",
      city: "Lynn Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Lynn Lake Airport",
    },
    YHO: {
      airportCode: "YHO",
      city: "Hopedale",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Hopedale Airport",
    },
    PKU: {
      airportCode: "PKU",
      city: "Pekanbaru",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Syarif Kasim II",
    },
    BQL: {
      airportCode: "BQL",
      city: "Boulia",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Boulia Airport",
    },
    TLV: {
      airportCode: "TLV",
      city: "Tel-aviv",
      countryId: "IL",
      countryCode: "376",
      internationalAirportName: "Ben Gurion Airport",
    },
    XNN: {
      airportCode: "XNN",
      city: "Xining",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xining Caojiabao Airport",
    },
    SXZ: {
      airportCode: "SXZ",
      city: "Siirt",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Siirt Airport",
    },
    MSA: {
      airportCode: "MSA",
      city: "Mamasa",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sumarorong",
    },
    DFW: {
      airportCode: "DFW",
      city: "Dallas-fort Worth",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Dallas Fort Worth Intl",
    },
    HAM: {
      airportCode: "HAM",
      city: "Hamburg",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Hamburg",
    },
    SAN: {
      airportCode: "SAN",
      city: "San Diego",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "San Diego Intl",
    },
    RNN: {
      airportCode: "RNN",
      city: "Bornholm",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Ronne Bornholm Airport",
    },
    TUC: {
      airportCode: "TUC",
      city: "Tucuman",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Teniente Benjamin Matienzo",
    },
    RCM: {
      airportCode: "RCM",
      city: "Richmond",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Richmond Airport (Queensland)",
    },
    VAA: {
      airportCode: "VAA",
      city: "Vaasa",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Vaasa Airport",
    },
    YHZ: {
      airportCode: "YHZ",
      city: "Halifax",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Halifax Stanfield International Airport",
    },
    YIA: {
      airportCode: "YIA",
      city: "Yogyakarta/Kulon Progo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Yogyakarta International Airport",
    },
    SCO: {
      airportCode: "SCO",
      city: "Aktau",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Aktau Airport",
    },
    TJS: {
      airportCode: "TJS",
      city: "Tanjung Selor",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tanjung Harapan",
    },
    LAD: {
      airportCode: "LAD",
      city: "Luanda",
      countryId: "AO",
      countryCode: "024",
      internationalAirportName: "Quatro de Fevereiro International Airport",
    },
    HGA: {
      airportCode: "HGA",
      city: "Hargeisa",
      countryId: "SO",
      countryCode: "706",
      internationalAirportName: "Hargeisa Egal International Airport",
    },
    YXT: {
      airportCode: "YXT",
      city: "Terrace",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Northwest Regional Airport Terrace-Kitimat",
    },
    SHB: {
      airportCode: "SHB",
      city: "Nakashibetsu",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Nakashibetsu Airport",
    },
    SYO: {
      airportCode: "SYO",
      city: "Shonai",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Shonai Airport",
    },
    MNT: {
      airportCode: "MNT",
      city: "Minto",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Minto Al Wright Airport",
    },
    CUN: {
      airportCode: "CUN",
      city: "Cancun",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Cancun Intl",
    },
    YGZ: {
      airportCode: "YGZ",
      city: "Grise Fiord",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Grise Fiord Airport",
    },
    ADB: {
      airportCode: "ADB",
      city: "Izmir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Adnan Menderes",
    },
    YRG: {
      airportCode: "YRG",
      city: "Rigolet",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Rigolet Airport",
    },
    YNJ: {
      airportCode: "YNJ",
      city: "Yanji",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yanji Airport",
    },
    TRN: {
      airportCode: "TRN",
      city: "Torino",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Torino",
    },
    ORT: {
      airportCode: "ORT",
      city: "Northway",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Northway Airport",
    },
    OSD: {
      airportCode: "OSD",
      city: "Ostersund",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Are Ostersund Airport",
    },
    LTN: {
      airportCode: "LTN",
      city: "London",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "London Luton Airport",
    },
    LRE: {
      airportCode: "LRE",
      city: "Longreach",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Longreach Airport",
    },
    SGN: {
      airportCode: "SGN",
      city: "Ho Chi Minh City",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Tansonnhat Intl",
    },
    MOV: {
      airportCode: "MOV",
      city: "Moranbah",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Moranbah Airport",
    },
    WDH: {
      airportCode: "WDH",
      city: "Windhoek",
      countryId: "NA",
      countryCode: "516",
      internationalAirportName: "Hosea Kutako International Airport",
    },
    OSL: {
      airportCode: "OSL",
      city: "Oslo",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Gardermoen Airport",
    },
    KUM: {
      airportCode: "KUM",
      city: "Yakushima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Yakushima Airport",
    },
    ACF: {
      airportCode: "ACF",
      city: "Alaer",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Alaer Talimu Airport",
    },
    CXH: {
      airportCode: "CXH",
      city: "Vancouver",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Vancouver Coal Harbour Seaplane Base",
    },
    YCB: {
      airportCode: "YCB",
      city: "Cambridge Bay",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Cambridge Bay Airport",
    },
    SLY: {
      airportCode: "SLY",
      city: "Salekhard",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Salekhard Airport",
    },
    YWB: {
      airportCode: "YWB",
      city: "Kangiqsujuaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kangiqsujuaq Wakeham Bay Airport",
    },
    JBB: {
      airportCode: "JBB",
      city: "Jember",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Noto Hadinegoro",
    },
    KYP: {
      airportCode: "KYP",
      city: "Kyaukpyu",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Kyaukpyu",
    },
    BMV: {
      airportCode: "BMV",
      city: "Buon Ma Thuot",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Buon Ma Thuot",
    },
    MXZ: {
      airportCode: "MXZ",
      city: "Meixian",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Meixian Airport",
    },
    HKK: {
      airportCode: "HKK",
      city: "Hokitika",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Hokitika Airport",
    },
    ZYK: {
      airportCode: "ZYK",
      city: "Shekou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shekou Port",
    },
    UNK: {
      airportCode: "UNK",
      city: "Unalakleet",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Unalakleet Airport",
    },
    YDP: {
      airportCode: "YDP",
      city: "Nain",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Nain Airport",
    },
    BAX: {
      airportCode: "BAX",
      city: "Barnaul",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Barnaul Gherman Titov International Airport",
    },
    MSJ: {
      airportCode: "MSJ",
      city: "Misawa",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Misawa Airport",
    },
    YXC: {
      airportCode: "YXC",
      city: "Cranbrook",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Canadian Rockies International Airport",
    },
    CNQ: {
      airportCode: "CNQ",
      city: "Corrientes",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Corrientes",
    },
    ARH: {
      airportCode: "ARH",
      city: "Arkhangelsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Arkhangelsk Talagi Airport",
    },
    YKR: {
      airportCode: "YKR",
      city: "Selayar",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "H. Aroeppala",
    },
    MUC: {
      airportCode: "MUC",
      city: "Munich",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Franz Josef Strauss",
    },
    SZX: {
      airportCode: "SZX",
      city: "Shenzhen",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baoan Intl",
    },
    KAJ: {
      airportCode: "KAJ",
      city: "Kajaani",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kajaani Airport",
    },
    ORI: {
      airportCode: "ORI",
      city: "Port Lions",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Lions Airport",
    },
    MZG: {
      airportCode: "MZG",
      city: "Penghu",
      countryId: "TW",
      countryCode: "158",
      internationalAirportName: "Penghu Airport",
    },
    MKQ: {
      airportCode: "MKQ",
      city: "Merauke",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mopah",
    },
    PXA: {
      airportCode: "PXA",
      city: "Pagar Alam",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Atung Bungsu",
    },
    YKQ: {
      airportCode: "YKQ",
      city: "Waskaganish",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Waskaganish Airport",
    },
    TXN: {
      airportCode: "TXN",
      city: "Huangshan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tunxi Int'l Airport",
    },
    MCI: {
      airportCode: "MCI",
      city: "Kansas City",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kansas City International Airport",
    },
    ERL: {
      airportCode: "ERL",
      city: "Eren Hot",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Erenhot Saiwusu International Airport",
    },
    LNY: {
      airportCode: "LNY",
      city: "Lanai",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lanai Airport",
    },
    IOA: {
      airportCode: "IOA",
      city: "Ioannina",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Ioannia King Pyrros Airport",
    },
    BQW: {
      airportCode: "BQW",
      city: "Balgo Hills",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Balgo Hill Airport",
    },
    OKI: {
      airportCode: "OKI",
      city: "Oki Island",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Oki Airport",
    },
    BRQ: {
      airportCode: "BRQ",
      city: "Brno",
      countryId: "CZ",
      countryCode: "203",
      internationalAirportName: "Brno Turany Airport",
    },
    CBO: {
      airportCode: "CBO",
      city: "Cotabato",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Awang ",
    },
    LAO: {
      airportCode: "LAO",
      city: "Laoag",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Laoag Intl",
    },
    MPM: {
      airportCode: "MPM",
      city: "Maputo",
      countryId: "MZ",
      countryCode: "508",
      internationalAirportName: "Maputo International Airport",
    },
    LAS: {
      airportCode: "LAS",
      city: "Las Vegas",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Mc Carran Intl",
    },
    CTC: {
      airportCode: "CTC",
      city: "Catamarca",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Catamarca",
    },
    MGW: {
      airportCode: "MGW",
      city: "Morgantown",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Morgantown Municipal Airport",
    },
    SSJ: {
      airportCode: "SSJ",
      city: "Sandnessjoen",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Sandnessjoen Stokka Airport",
    },
    EQS: {
      airportCode: "EQS",
      city: "Esquel",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Esquel",
    },
    LVO: {
      airportCode: "LVO",
      city: "Laverton",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Laverton Airport",
    },
    WMI: {
      airportCode: "WMI",
      city: "Warsaw",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Warsaw Modlin Airport",
    },
    NZH: {
      airportCode: "NZH",
      city: "Manzhouli",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Manzhouli Xijiao Airport",
    },
    OGD: {
      airportCode: "OGD",
      city: "Ogden",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ogden-Hinkley Airport",
    },
    AHO: {
      airportCode: "AHO",
      city: "Alghero",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Alghero Fertilia Airport",
    },
    BEM: {
      airportCode: "BEM",
      city: "Beni Mellal",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Beni Mellal National Airport",
    },
    CLE: {
      airportCode: "CLE",
      city: "Cleveland",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Cleveland Hopkins Intl",
    },
    HBQ: {
      airportCode: "HBQ",
      city: "Qilian",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Haibei Qilian Airport",
    },
    CBG: {
      airportCode: "CBG",
      city: "Cambridge",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Cambridge City Airport",
    },
    MXH: {
      airportCode: "MXH",
      city: "Moro",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Moro Airport",
    },
    ETZ: {
      airportCode: "ETZ",
      city: "Metz/Nancy",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Metz-Nancy-Lorraine Airport",
    },
    WWP: {
      airportCode: "WWP",
      city: "Whale Pass",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "North Whale Seaplane Base",
    },
    BZO: {
      airportCode: "BZO",
      city: "Bolzano",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Bolzano Dolomiti Airport",
    },
    RTM: {
      airportCode: "RTM",
      city: "Rotterdam",
      countryId: "NL",
      countryCode: "528",
      internationalAirportName: "Rotterdam The Hague Airport",
    },
    KPN: {
      airportCode: "KPN",
      city: "Kipnuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kipnuk Airport",
    },
    ROR: {
      airportCode: "ROR",
      city: "Airai",
      countryId: "GU",
      countryCode: "585",
      internationalAirportName: "Roman Tmetuchl International Airport",
    },
    PEV: {
      airportCode: "PEV",
      city: "Pecs-Pogany",
      countryId: "HU",
      countryCode: "348",
      internationalAirportName: "Pecs Pogany Airport",
    },
    DWC: {
      airportCode: "DWC",
      city: "Dubai",
      countryId: "AE",
      countryCode: "784",
      internationalAirportName: "Al Maktoum International Airport",
    },
    PIS: {
      airportCode: "PIS",
      city: "Poitiers",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Poitiers-Biard Airport",
    },
    GDN: {
      airportCode: "GDN",
      city: "Gdansk",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Gdansk Lech Walesa Airport",
    },
    KRF: {
      airportCode: "KRF",
      city: "Kramfors",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Kramfors Solleftea Hoga Kusten Airport",
    },
    YAB: {
      airportCode: "YAB",
      city: "Arctic Bay",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Arctic Bay Airport",
    },
    BPN: {
      airportCode: "BPN",
      city: "Balikpapan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sepinggan",
    },
    CIT: {
      airportCode: "CIT",
      city: "Shymkent",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Shymkent International Airport",
    },
    YBL: {
      airportCode: "YBL",
      city: "Campbell River",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Campbell River Airport",
    },
    DLE: {
      airportCode: "DLE",
      city: "Dole",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Dole Tavaux Airport",
    },
    HAK: {
      airportCode: "HAK",
      city: "Haikou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Meilan",
    },
    XUZ: {
      airportCode: "XUZ",
      city: "Xuzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xuzhou Guanyin Airport",
    },
    ORH: {
      airportCode: "ORH",
      city: "Worcester",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Worcester Regional Airport",
    },
    DNZ: {
      airportCode: "DNZ",
      city: "Denizli",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Denizli Cardak Airport",
    },
    YPJ: {
      airportCode: "YPJ",
      city: "Aupaluk",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Aupaluk Airport",
    },
    FYJ: {
      airportCode: "FYJ",
      city: "Fuyuan County",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Fuyuan Dongji Airport",
    },
    MHQ: {
      airportCode: "MHQ",
      city: "Mariehamn",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Mariehamn Airport",
    },
    HTY: {
      airportCode: "HTY",
      city: "Hatay",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Hatay Airport",
    },
    PBM: {
      airportCode: "PBM",
      city: "Zanderij",
      countryId: "SR",
      countryCode: "740",
      internationalAirportName: "Johan A Pengel Int'l",
    },
    DTU: {
      airportCode: "DTU",
      city: "Wudalianchi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wudalianchi Dedu Airport",
    },
    ILO: {
      airportCode: "ILO",
      city: "Iloilo",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Iloilo",
    },
    AHU: {
      airportCode: "AHU",
      city: "Al Hoceima",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Al Hoceima Cherif Al Idrissi Airport",
    },
    AXD: {
      airportCode: "AXD",
      city: "Alexandroupolis",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Alexandroupolis Dimokritos Airport",
    },
    OLF: {
      airportCode: "OLF",
      city: "Wolf Point",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Wolf Point L.M. Clayton Airport",
    },
    KYA: {
      airportCode: "KYA",
      city: "Konya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Konya Airport",
    },
    OST: {
      airportCode: "OST",
      city: "Ostend",
      countryId: "BE",
      countryCode: "056",
      internationalAirportName: "Ostend-Bruges International Airport",
    },
    LBP: {
      airportCode: "LBP",
      city: "Long Banga",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Long Banga Airport",
    },
    IKO: {
      airportCode: "IKO",
      city: "Nikolski",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nikolski AFS",
    },
    HIN: {
      airportCode: "HIN",
      city: "Sacheon",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Sacheon Airport",
    },
    MCX: {
      airportCode: "MCX",
      city: "Makhachkala",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Makhachkala Uytash Airport",
    },
    PGK: {
      airportCode: "PGK",
      city: "Pangkal Pinang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Depati Amir",
    },
    CHC: {
      airportCode: "CHC",
      city: "Christchurch",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Christchurch Intl",
    },
    DLA: {
      airportCode: "DLA",
      city: "Douala",
      countryId: "CM",
      countryCode: "120",
      internationalAirportName: "Douala International Airport",
    },
    LXG: {
      airportCode: "LXG",
      city: "Luang Namtha",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Luang Namtha Airport",
    },
    CZN: {
      airportCode: "CZN",
      city: "Chisana",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chisana Airport",
    },
    PQC: {
      airportCode: "PQC",
      city: "Phu Quoc",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Phu Quoc",
    },
    WMX: {
      airportCode: "WMX",
      city: "Wamena",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Wamena",
    },
    ZVK: {
      airportCode: "ZVK",
      city: "Savannakhet",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Savannakhet Airport",
    },
    TRD: {
      airportCode: "TRD",
      city: "Trondheim",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Vaernes",
    },
    CEI: {
      airportCode: "CEI",
      city: "Chiang Rai",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Chiang Rai Intl Airport",
    },
    AKA: {
      airportCode: "AKA",
      city: "Ankang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ankang Fuqiang Airport",
    },
    KLW: {
      airportCode: "KLW",
      city: "Klawock",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Klawock Airport",
    },
    OKA: {
      airportCode: "OKA",
      city: "Okinawa",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Naha",
    },
    YNY: {
      airportCode: "YNY",
      city: "Yangyang (Gangwon)",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Yangyang Int'l Airport",
    },
    IBZ: {
      airportCode: "IBZ",
      city: "Ibiza",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Ibiza Airport",
    },
    JJN: {
      airportCode: "JJN",
      city: "Quanzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Quanzhou Jinjiang International Airport",
    },
    MMD: {
      airportCode: "MMD",
      city: "Minami-Daito",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Minami-Daito Airport",
    },
    YGG: {
      airportCode: "YGG",
      city: "Ganges",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Ganges Seaplane Base",
    },
    YQZ: {
      airportCode: "YQZ",
      city: "Quesnel",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Quesnel Airport",
    },
    NER: {
      airportCode: "NER",
      city: "Neryungri",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Chulman Neryungri Airport",
    },
    BJF: {
      airportCode: "BJF",
      city: "Batsfjord",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Batsfjord Airport",
    },
    LUQ: {
      airportCode: "LUQ",
      city: "San Luis",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "San Luis",
    },
    LWE: {
      airportCode: "LWE",
      city: "Lewoleba",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Wonopito Airport",
    },
    AOR: {
      airportCode: "AOR",
      city: "Alor Setar",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sultan Abdul Halim",
    },
    CRM: {
      airportCode: "CRM",
      city: "Catarman",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Catarman National Airport",
    },
    IOB: {
      airportCode: "IOB",
      city: "Innsbruck",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Innsbruck Railway Station",
    },
    KTM: {
      airportCode: "KTM",
      city: "Kathmandu",
      countryId: "NP",
      countryCode: "524",
      internationalAirportName: "Tribhuvan Int'l",
    },
    DIY: {
      airportCode: "DIY",
      city: "Diyabakir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Diyarbakir Airport",
    },
    NGB: {
      airportCode: "NGB",
      city: "Ningbo",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Lishe",
    },
    WUX: {
      airportCode: "WUX",
      city: "Wuxi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Sunan Shuofang Int'l Airport",
    },
    LSR: {
      airportCode: "LSR",
      city: "Lasondre",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Lasondre",
    },
    LIW: {
      airportCode: "LIW",
      city: "Loikaw",
      countryId: "MM",
      countryCode: "104",
      internationalAirportName: "Loikaw",
    },
    KLN: {
      airportCode: "KLN",
      city: "Larsen Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Larsen Bay Airport",
    },
    BIO: {
      airportCode: "BIO",
      city: "Bilbao",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Bilbao",
    },
    NNY: {
      airportCode: "NNY",
      city: "Nanyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Nanyang Airport",
    },
    LDH: {
      airportCode: "LDH",
      city: "Lord Howe Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Lord Howe Island Airport",
    },
    PNH: {
      airportCode: "PNH",
      city: "Phnom Penh",
      countryId: "KH",
      countryCode: "116",
      internationalAirportName: "Phnom Penh Intl",
    },
    UIO: {
      airportCode: "UIO",
      city: "Quito",
      countryId: "EC",
      countryCode: "218",
      internationalAirportName: "Mariscal Sucre International Airport",
    },
    TRG: {
      airportCode: "TRG",
      city: "Tauranga",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Tauranga Airport",
    },
    KOA: {
      airportCode: "KOA",
      city: "Kailua-Kona Hawaii",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kona Intl At Keahole",
    },
    BUR: {
      airportCode: "BUR",
      city: "Burbank",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hollywood Burbank Airport",
    },
    AUS: {
      airportCode: "AUS",
      city: "Austin",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Austin Bergstrom Intl",
    },
    STW: {
      airportCode: "STW",
      city: "Stavropol",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Stavropol Shpakovskoye Airport",
    },
    EZS: {
      airportCode: "EZS",
      city: "Elazıg",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Elazıg Airport",
    },
    LAF: {
      airportCode: "LAF",
      city: "Lafayette",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Purdue University Airport",
    },
    TIU: {
      airportCode: "TIU",
      city: "Timaru",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Richard Pearse Airport",
    },
    VDO: {
      airportCode: "VDO",
      city: "Quang Ninh",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Van Don International Airport",
    },
    GRU: {
      airportCode: "GRU",
      city: "Sao Paulo",
      countryId: "BR",
      countryCode: "076",
      internationalAirportName: "Guarulhos Gov Andre Franco Montouro",
    },
    YSO: {
      airportCode: "YSO",
      city: "Postville",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Postville Airport",
    },
    PVG: {
      airportCode: "PVG",
      city: "Shanghai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Pudong",
    },
    MEH: {
      airportCode: "MEH",
      city: "Mehamn",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Mehamn Airport",
    },
    JIU: {
      airportCode: "JIU",
      city: "Jiujiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jiujiang Lushan Airport",
    },
    ABL: {
      airportCode: "ABL",
      city: "Ambler",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ambler Airport",
    },
    AAR: {
      airportCode: "AAR",
      city: "Aarhus",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Aarhus Airport",
    },
    ONQ: {
      airportCode: "ONQ",
      city: "Zonguldak",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Zonguldak Airport",
    },
    YZP: {
      airportCode: "YZP",
      city: "Sandspit",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sandspit Airport",
    },
    BDJ: {
      airportCode: "BDJ",
      city: "Banjarmasin",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Syamsudin Noor",
    },
    CLQ: {
      airportCode: "CLQ",
      city: "Colima",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Colima",
    },
    SMK: {
      airportCode: "SMK",
      city: "Saint Michael",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "St Michael Airport",
    },
    TTU: {
      airportCode: "TTU",
      city: "Tetouan",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Tetouan Saniat R'mel Airport",
    },
    PAD: {
      airportCode: "PAD",
      city: "Paderborn",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Paderborn Lippstadt Airport",
    },
    KMJ: {
      airportCode: "KMJ",
      city: "Kumamoto",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kumamoto",
    },
    WNR: {
      airportCode: "WNR",
      city: "Windorah",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Windorah Airport",
    },
    XPL: {
      airportCode: "XPL",
      city: "Comayagua",
      countryId: "HN",
      countryCode: "340",
      internationalAirportName: "Palmerola International Airport",
    },
    ZGN: {
      airportCode: "ZGN",
      city: "Zhongshan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhongshan Port",
    },
    XAI: {
      airportCode: "XAI",
      city: "Xinyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xinyang Minggang Airport",
    },
    SMI: {
      airportCode: "SMI",
      city: "Samos",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Samos Airport",
    },
    CHG: {
      airportCode: "CHG",
      city: "Chaoyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Chaoyang Airport",
    },
    MYJ: {
      airportCode: "MYJ",
      city: "Matsuyama",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Matsuyama",
    },
    YVC: {
      airportCode: "YVC",
      city: "La Ronge",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "La Ronge Barber Field Airport",
    },
    DXB: {
      airportCode: "DXB",
      city: "Dubai",
      countryId: "AE",
      countryCode: "784",
      internationalAirportName: "Dubai Intl",
    },
    FUK: {
      airportCode: "FUK",
      city: "Fukuoka",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Fukuoka",
    },
    LUR: {
      airportCode: "LUR",
      city: "Cape Lisburne",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Cape Lisburne Airport",
    },
    GKA: {
      airportCode: "GKA",
      city: "Goroka",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Goroka Airport",
    },
    MRS: {
      airportCode: "MRS",
      city: "Marseille",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Provence",
    },
    IRC: {
      airportCode: "IRC",
      city: "Circle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Circle City Airport",
    },
    JKH: {
      airportCode: "JKH",
      city: "Chios",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Chios Island National Airport",
    },
    CWL: {
      airportCode: "CWL",
      city: "Cardiff",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Cardiff Airport",
    },
    OLP: {
      airportCode: "OLP",
      city: "Olympic Dam",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Olympic Dam Airport",
    },
    JYV: {
      airportCode: "JYV",
      city: "Jyvaskyla",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Jyvaskyla Airport",
    },
    AOK: {
      airportCode: "AOK",
      city: "Karpathos",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Karpathos Island National Airport",
    },
    JSH: {
      airportCode: "JSH",
      city: "Sitia",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Sitia Airport",
    },
    RKZ: {
      airportCode: "RKZ",
      city: "Shigatse",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shigatse Peace Airport",
    },
    YSF: {
      airportCode: "YSF",
      city: "Stony Rapids",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Stony Rapids Airport",
    },
    YPW: {
      airportCode: "YPW",
      city: "Powell River",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Powell River Airport",
    },
    BEB: {
      airportCode: "BEB",
      city: "Benbecula",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Benbecula Airport",
    },
    EDA: {
      airportCode: "EDA",
      city: "Edna Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Edna Bay Seaplane Base",
    },
    RBY: {
      airportCode: "RBY",
      city: "Ruby",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ruby Airport",
    },
    YCY: {
      airportCode: "YCY",
      city: "Clyde River",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Clyde River Airport",
    },
    CAZ: {
      airportCode: "CAZ",
      city: "Cobar",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Cobar Airport",
    },
    MTY: {
      airportCode: "MTY",
      city: "Monterrey",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Monterrey International Airport",
    },
    TNA: {
      airportCode: "TNA",
      city: "Jinan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jinan Airport",
    },
    YHK: {
      airportCode: "YHK",
      city: "Gjoa Haven",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Gjoa Haven Airport",
    },
    CMF: {
      airportCode: "CMF",
      city: "Chambery",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Chambery Savoie Airport",
    },
    MRU: {
      airportCode: "MRU",
      city: "Plaine Magnien",
      countryId: "MU",
      countryCode: "480",
      internationalAirportName: "Sir Seewoosagur Ramgoolam Intl Airport",
    },
    JOE: {
      airportCode: "JOE",
      city: "Joensuu",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Joensuu Airport",
    },
    LTO: {
      airportCode: "LTO",
      city: "Loreto",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Loreto Intl",
    },
    DRS: {
      airportCode: "DRS",
      city: "Dresden",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Dresden Airport",
    },
    BDO: {
      airportCode: "BDO",
      city: "Bandung",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Husein Sastranegara",
    },
    LRT: {
      airportCode: "LRT",
      city: "Lorient",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Lorient South Brittany Airport",
    },
    SUP: {
      airportCode: "SUP",
      city: "Sumenep",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Trunojoyo Airport",
    },
    KRR: {
      airportCode: "KRR",
      city: "Krasnodar",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Krasnodar International Airport ",
    },
    FMA: {
      airportCode: "FMA",
      city: "Formosa",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Formosa",
    },
    SDY: {
      airportCode: "SDY",
      city: "Sidney",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Sidney Richland Municipal Airport",
    },
    RDZ: {
      airportCode: "RDZ",
      city: "Rodez",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Rodez Marcillac Airport",
    },
    ULV: {
      airportCode: "ULV",
      city: "Ulyanovsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Ulyanovsk Baratayevka Airport",
    },
    AEB: {
      airportCode: "AEB",
      city: "Baise",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baise Bama Airport",
    },
    YIW: {
      airportCode: "YIW",
      city: "Yiwu",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yiwu Airport",
    },
    USN: {
      airportCode: "USN",
      city: "Ulsan",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Ulsan Airport ",
    },
    YPH: {
      airportCode: "YPH",
      city: "Inukjuak",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Inukjuak Airport",
    },
    LIN: {
      airportCode: "LIN",
      city: "Milan",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Linate Airport",
    },
    IAH: {
      airportCode: "IAH",
      city: "Houston",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "George Bush Intcntl Houston",
    },
    TLC: {
      airportCode: "TLC",
      city: "Toluca",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Licenciado Adolfo Lopez Mateos Intl",
    },
    UBP: {
      airportCode: "UBP",
      city: "Ubon Ratchathani",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Ubon Ratchathani Airport",
    },
    NLG: {
      airportCode: "NLG",
      city: "Nelson Lagoon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nelson Lagoon Airport",
    },
    ISC: {
      airportCode: "ISC",
      city: "Isles Of Scilly",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Isles of Scilly St Mary's Airport",
    },
    HYG: {
      airportCode: "HYG",
      city: "Hydaburg",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hydaburg Seaplane Base",
    },
    MMJ: {
      airportCode: "MMJ",
      city: "Matsumoto",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Matsumoto Airport",
    },
    MBT: {
      airportCode: "MBT",
      city: "Masbate",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Moises R",
    },
    RGA: {
      airportCode: "RGA",
      city: "Rio Grande",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Rio Grande",
    },
    HMS: {
      airportCode: "HMS",
      city: "Muara Teweh",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Haji Muhammad Sidik Airport",
    },
    NUL: {
      airportCode: "NUL",
      city: "Nulato",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Nulato Airport",
    },
    MWK: {
      airportCode: "MWK",
      city: "Anambas/Matak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Matak Airport",
    },
    MSY: {
      airportCode: "MSY",
      city: "New Orleans",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Louis Armstrong New Orleans Intl",
    },
    UEO: {
      airportCode: "UEO",
      city: "Kumejima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kumejima Airport",
    },
    ACH: {
      airportCode: "ACH",
      city: "Altenrhein",
      countryId: "CH",
      countryCode: "756",
      internationalAirportName: "St Gallen-Altenrhein Airport",
    },
    BCN: {
      airportCode: "BCN",
      city: "Barcelona",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Barcelona El Prat Airport",
    },
    XWA: {
      airportCode: "XWA",
      city: "Williston",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Williston Basin International Airport",
    },
    WLG: {
      airportCode: "WLG",
      city: "Wellington",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Wellington Intl",
    },
    TRE: {
      airportCode: "TRE",
      city: "Tiree, Inner Hebrides",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Tiree Airport",
    },
    BVI: {
      airportCode: "BVI",
      city: "Birdsville",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Birdsville Airport",
    },
    HRO: {
      airportCode: "HRO",
      city: "Harrison",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Boone County Airport",
    },
    BCM: {
      airportCode: "BCM",
      city: "Bacau",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Bacau International Airport",
    },
    HQL: {
      airportCode: "HQL",
      city: "Tashikuergan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tashikuergan Hongqilafu Airport",
    },
    OGZ: {
      airportCode: "OGZ",
      city: "Vladikavkaz",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Beslan Airport",
    },
    GYD: {
      airportCode: "GYD",
      city: "Baku",
      countryId: "AZ",
      countryCode: "031",
      internationalAirportName: "Heydar Aliyev Int'l Airport",
    },
    EDI: {
      airportCode: "EDI",
      city: "Edinburgh",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Edinburgh",
    },
    KTT: {
      airportCode: "KTT",
      city: "Kittila",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kittila Aiport",
    },
    BXE: {
      airportCode: "BXE",
      city: "Bone",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mappalo Ulaweng",
    },
    BFV: {
      airportCode: "BFV",
      city: "Buri Ram",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Buri Ram Airport",
    },
    VIE: {
      airportCode: "VIE",
      city: "Vienna",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Vienna Intl",
    },
    MZR: {
      airportCode: "MZR",
      city: "Mazar-I-Sharif",
      countryId: "AF",
      countryCode: "180",
      internationalAirportName: "Mazar-e Sharif Airport",
    },
    YZV: {
      airportCode: "YZV",
      city: "Sept Îles",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Sept Îles Airport",
    },
    CPH: {
      airportCode: "CPH",
      city: "Copenhagen",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Kastrup Airport",
    },
    NRA: {
      airportCode: "NRA",
      city: "Narrandera",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Narrandera Airport",
    },
    LAE: {
      airportCode: "LAE",
      city: "Nadzab",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Lae Nadzab Airport",
    },
    FRU: {
      airportCode: "FRU",
      city: "Bishkek",
      countryId: "AF",
      countryCode: "417",
      internationalAirportName: "Manas International Airport",
    },
    HLD: {
      airportCode: "HLD",
      city: "Hailar",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Hulunbuir Hailar Airport",
    },
    SOG: {
      airportCode: "SOG",
      city: "Sogndal",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Sogndal Haukasen Airport",
    },
    LKE: {
      airportCode: "LKE",
      city: "Seattle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lake Union Seaplane Base",
    },
    OHE: {
      airportCode: "OHE",
      city: "Mohe",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Mohe Gulian Airport",
    },
    HLZ: {
      airportCode: "HLZ",
      city: "Hamilton",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Hamilton Airport",
    },
    CBR: {
      airportCode: "CBR",
      city: "Canberra",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Canberra",
    },
    PGF: {
      airportCode: "PGF",
      city: "Perpignan",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Perpignan-Rivesaltes Airport",
    },
    DMD: {
      airportCode: "DMD",
      city: "Doomadgee",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Doomadgee Airport",
    },
    TSJ: {
      airportCode: "TSJ",
      city: "Tsushima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tsushima Airport",
    },
    BOM: {
      airportCode: "BOM",
      city: "Mumbai",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Chhatrapati Shivaji Int'l",
    },
    URT: {
      airportCode: "URT",
      city: "Surat Thani",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Surat Thani Airport",
    },
    AIN: {
      airportCode: "AIN",
      city: "Wainwright",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Wainwright Airport",
    },
    KBU: {
      airportCode: "KBU",
      city: "Kotabaru",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Gusti Sjamsir Alam",
    },
    MQF: {
      airportCode: "MQF",
      city: "Magnitogorsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Magnitogorsk International Airport",
    },
    YQB: {
      airportCode: "YQB",
      city: "Quebec",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Quebec Jean Lesage Intl",
    },
    ADA: {
      airportCode: "ADA",
      city: "Adana",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Adana Sakirpasa Airport",
    },
    IPH: {
      airportCode: "IPH",
      city: "Ipoh",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sultan Azlan Shah",
    },
    PKY: {
      airportCode: "PKY",
      city: "Palangkaraya",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tjilik Riwut",
    },
    SCV: {
      airportCode: "SCV",
      city: "Suceava",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Suceava Stefan cel Mare International Airport",
    },
    APJ: {
      airportCode: "APJ",
      city: "Pulan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ali Pulan Airport",
    },
    LLG: {
      airportCode: "LLG",
      city: "Silampari",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Silampari",
    },
    AEG: {
      airportCode: "AEG",
      city: "Tapanuli Selatan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Aek Godang Airport",
    },
    EVE: {
      airportCode: "EVE",
      city: "Harstad-Narvik",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Evenes Harstad Narvik Airport",
    },
    PDP: {
      airportCode: "PDP",
      city: "Punta del Este",
      countryId: "UY",
      countryCode: "858",
      internationalAirportName: "Capitan Corbeta C A Curbelo Int'l Airport",
    },
    SWA: {
      airportCode: "SWA",
      city: "Shantou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wai Sha Airport",
    },
    YUX: {
      airportCode: "YUX",
      city: "Hall Beach",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Hall Beach Airport",
    },
    MLH: {
      airportCode: "MLH",
      city: "Mulhouse, France/Basel",
      countryId: "CH",
      countryCode: "756",
      internationalAirportName: "EuroAirport French",
    },
    LYA: {
      airportCode: "LYA",
      city: "Luoyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Luoyang Beijiao Airport",
    },
    LNU: {
      airportCode: "LNU",
      city: "Malinau",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Robert Atty Bessing",
    },
    BIH: {
      airportCode: "BIH",
      city: "Bishop",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Eastern Sierra Regional Airport",
    },
    CEK: {
      airportCode: "CEK",
      city: "Chelyabinsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Chelyabinsk Balandino Airport",
    },
    FMM: {
      airportCode: "FMM",
      city: "Memmingen",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Memmingen Allgau Airport",
    },
    AMS: {
      airportCode: "AMS",
      city: "Amsterdam",
      countryId: "NL",
      countryCode: "528",
      internationalAirportName: "Schiphol",
    },
    NOZ: {
      airportCode: "NOZ",
      city: "Novokuznetsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Novokuznetsk Spichenkovo Airport",
    },
    COK: {
      airportCode: "COK",
      city: "Kochi",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Cochin Int'l",
    },
    KEF: {
      airportCode: "KEF",
      city: "Reykjavik",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Keflavik International Airport",
    },
    MLA: {
      airportCode: "MLA",
      city: "Luqa",
      countryId: "MT",
      countryCode: "470",
      internationalAirportName: "Malta International Airport",
    },
    ASU: {
      airportCode: "ASU",
      city: "Asuncion",
      countryId: "AR",
      countryCode: "600",
      internationalAirportName: "Silvio Pettirossi Intl",
    },
    OKR: {
      airportCode: "OKR",
      city: "Yorke Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Yorke Island Airport",
    },
    TST: {
      airportCode: "TST",
      city: "Trang",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Trang Airport",
    },
    DMK: {
      airportCode: "DMK",
      city: "Bangkok",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Don Mueang Intl",
    },
    LAX: {
      airportCode: "LAX",
      city: "Los Angeles",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Los Angeles Intl",
    },
    BAR: {
      airportCode: "BAR",
      city: "Qionghai",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Qionghai Bo'ao Airport",
    },
    JFK: {
      airportCode: "JFK",
      city: "New York",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "John F Kennedy Intl",
    },
    PSS: {
      airportCode: "PSS",
      city: "Posadas",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Posadas",
    },
    PDG: {
      airportCode: "PDG",
      city: "Padang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Minangkabau Intl",
    },
    MMX: {
      airportCode: "MMX",
      city: "Malmo",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Malmo Airport",
    },
    YBB: {
      airportCode: "YBB",
      city: "Pelly Bay",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kugaaruk Airport",
    },
    HAJ: {
      airportCode: "HAJ",
      city: "Hannover",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Hannover",
    },
    MXB: {
      airportCode: "MXB",
      city: "Masamba",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Andi Djemma",
    },
    HGD: {
      airportCode: "HGD",
      city: "Hughenden",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Hughenden Airport",
    },
    LCA: {
      airportCode: "LCA",
      city: "Larnaca",
      countryId: "CY",
      countryCode: "196",
      internationalAirportName: "Larnaca",
    },
    MMY: {
      airportCode: "MMY",
      city: "Miyako",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Miyako Airport",
    },
    PKB: {
      airportCode: "PKB",
      city: "Parkersburg",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Mid-Ohio Valley Regional Airport",
    },
    WGA: {
      airportCode: "WGA",
      city: "Wagga Wagga",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Wagga Wagga",
    },
    LRS: {
      airportCode: "LRS",
      city: "Leros",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Leros Municipal Airport",
    },
    MEX: {
      airportCode: "MEX",
      city: "Mexico City",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Benito Juarez Intl",
    },
    CJU: {
      airportCode: "CJU",
      city: "Jeju",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Jeju Intl Airport",
    },
    MMG: {
      airportCode: "MMG",
      city: "Mount Magnet",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mount Magnet Airport",
    },
    JNX: {
      airportCode: "JNX",
      city: "Naxos, Cyclades Islands",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Naxos Airport",
    },
    ZKE: {
      airportCode: "ZKE",
      city: "Kaschechewan",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kashechewan Airport",
    },
    BVJ: {
      airportCode: "BVJ",
      city: "Bovanenkovo",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Bovanenkovo Airport",
    },
    KGP: {
      airportCode: "KGP",
      city: "Kogalym",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kogalym International Airport",
    },
    KBL: {
      airportCode: "KBL",
      city: "Kabul",
      countryId: "AF",
      countryCode: "180",
      internationalAirportName: "Kabul International Airport",
    },
    CGN: {
      airportCode: "CGN",
      city: "Cologne",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Cologne Bonn Airport",
    },
    KYU: {
      airportCode: "KYU",
      city: "Koyukuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Koyukuk Airport",
    },
    TOG: {
      airportCode: "TOG",
      city: "Togiak Village",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Togiak Airport",
    },
    TGO: {
      airportCode: "TGO",
      city: "Tongliao",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tongliao Airport",
    },
    ERZ: {
      airportCode: "ERZ",
      city: "Erzurum",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Erzurum Airport",
    },
    KBP: {
      airportCode: "KBP",
      city: "Kiev",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Boryspil Intl",
    },
    TOD: {
      airportCode: "TOD",
      city: "Pulau Tioman",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Pulau Tioman",
    },
    TAO: {
      airportCode: "TAO",
      city: "Qingdao",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Liuting",
    },
    LFW: {
      airportCode: "LFW",
      city: "Lome",
      countryId: "TG",
      countryCode: "768",
      internationalAirportName: "Lome-Tokoin International Airport",
    },
    PLW: {
      airportCode: "PLW",
      city: "Palu",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mutiara SIS Aljufri",
    },
    INV: {
      airportCode: "INV",
      city: "Inverness",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Inverness Airport",
    },
    CTM: {
      airportCode: "CTM",
      city: "Chetumal",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Chetumal Intl",
    },
    RNB: {
      airportCode: "RNB",
      city: "Ronneby",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Ronneby Kallinge Airport",
    },
    NGQ: {
      airportCode: "NGQ",
      city: "Shi Quan He",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ngari Gunsa Airport",
    },
    BWI: {
      airportCode: "BWI",
      city: "Baltimore",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Baltimore Washington Intl",
    },
    NTN: {
      airportCode: "NTN",
      city: "Normanton",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Normanton Airport",
    },
    YFS: {
      airportCode: "YFS",
      city: "Fort Simpson",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fort Simpson Airport",
    },
    VOZ: {
      airportCode: "VOZ",
      city: "Voronezh",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Voronezh Chertovitshoye Airport",
    },
    HHR: {
      airportCode: "HHR",
      city: "Hawthorne",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hawthorne Municipal Airport",
    },
    CAI: {
      airportCode: "CAI",
      city: "Cairo",
      countryId: "EG",
      countryCode: "818",
      internationalAirportName: "Cairo Intl",
    },
    BDL: {
      airportCode: "BDL",
      city: "Windsor Locks",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Bradley International Airport",
    },
    HAN: {
      airportCode: "HAN",
      city: "Hanoi",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Noibai International Airport",
    },
    KFP: {
      airportCode: "KFP",
      city: "False Pass",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "False Pass Airport",
    },
    NYA: {
      airportCode: "NYA",
      city: "Nyagan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Nyagan Airport",
    },
    BOS: {
      airportCode: "BOS",
      city: "Boston",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "General Edward Lawrence Logan Intl",
    },
    EAS: {
      airportCode: "EAS",
      city: "San Sebastian",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "San Sebastián Airport",
    },
    ENE: {
      airportCode: "ENE",
      city: "Ende",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "H Hasan Aroeboesman",
    },
    KWJ: {
      airportCode: "KWJ",
      city: "Kwangju",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Gwangju",
    },
    SBG: {
      airportCode: "SBG",
      city: "Sabang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Maimun Saleh",
    },
    PLO: {
      airportCode: "PLO",
      city: "Port Lincoln",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Port Lincoln Airport",
    },
    YLE: {
      airportCode: "YLE",
      city: "Whati/Lac La Martre",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Whati Airport",
    },
    KTA: {
      airportCode: "KTA",
      city: "Karratha",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Karratha Airport",
    },
    BFD: {
      airportCode: "BFD",
      city: "Bradford",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Bradford Regional Airport",
    },
    SOJ: {
      airportCode: "SOJ",
      city: "Sorkjosen",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Sorkjosen Airport",
    },
    BSL: {
      airportCode: "BSL",
      city: "Basel",
      countryId: "CH",
      countryCode: "756",
      internationalAirportName: "Euro Airport",
    },
    NQN: {
      airportCode: "NQN",
      city: "Neuquen",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Presidente Peron",
    },
    WEF: {
      airportCode: "WEF",
      city: "Weifang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Weifang Airport",
    },
    DND: {
      airportCode: "DND",
      city: "Dundee",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Dundee Airport",
    },
    YVM: {
      airportCode: "YVM",
      city: "Qikiqtarkuaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Qikiqtarjuaq Airport",
    },
    BAL: {
      airportCode: "BAL",
      city: "Batman",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Batman Airport",
    },
    MRZ: {
      airportCode: "MRZ",
      city: "Moree",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Moree Airport",
    },
    PHY: {
      airportCode: "PHY",
      city: "Phetchabun",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Phetchabun Airport",
    },
    UTP: {
      airportCode: "UTP",
      city: "Pattaya",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "U Taphao Intl Airport",
    },
    XFN: {
      airportCode: "XFN",
      city: "Xiangfan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xiangfan Airport",
    },
    MCO: {
      airportCode: "MCO",
      city: "Orlando",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Orlando Intl",
    },
    LBV: {
      airportCode: "LBV",
      city: "Libreville",
      countryId: "GA",
      countryCode: "266",
      internationalAirportName: "Leon-Mba International Airport",
    },
    NTL: {
      airportCode: "NTL",
      city: "Newcastle",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Newcastle Airport",
    },
    KCM: {
      airportCode: "KCM",
      city: "Kahramanmaras",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Kahramanmaras Airport",
    },
    HEK: {
      airportCode: "HEK",
      city: "Heihe",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Heihe Aihui Airport",
    },
    FEZ: {
      airportCode: "FEZ",
      city: "Fes",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Fez Sais Airport",
    },
    TWU: {
      airportCode: "TWU",
      city: "Tawau",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Tawau Airport",
    },
    HHN: {
      airportCode: "HHN",
      city: "Hahn",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Frankfurt Hahn Airport",
    },
    SZY: {
      airportCode: "SZY",
      city: "Szymany",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Olsztyn-Mazury Airport",
    },
    WMT: {
      airportCode: "WMT",
      city: "Zunyi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zunyi Maotai Airport",
    },
    GJR: {
      airportCode: "GJR",
      city: "Gjogur",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Gjogur Airport",
    },
    YCK: {
      airportCode: "YCK",
      city: "Colville Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Colville Lake Airport",
    },
    ELD: {
      airportCode: "ELD",
      city: "El Dorado",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "South Arkansas Regional Airport",
    },
    ADF: {
      airportCode: "ADF",
      city: "Adiyaman",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Adıyaman Airport",
    },
    CGD: {
      airportCode: "CGD",
      city: "Changde",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Changde Airport",
    },
    UUA: {
      airportCode: "UUA",
      city: "Bugulma",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Bugulma Airport",
    },
    ULP: {
      airportCode: "ULP",
      city: "Quilpie",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Quilpie Airport",
    },
    PKV: {
      airportCode: "PKV",
      city: "Pskov",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Pskov Airport",
    },
    BWT: {
      airportCode: "BWT",
      city: "Burnie",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Burnie Wynyard Airport",
    },
    ABZ: {
      airportCode: "ABZ",
      city: "Aberdeen",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Aberdeen Int'l Airport",
    },
    MGQ: {
      airportCode: "MGQ",
      city: "Mogadishu",
      countryId: "SO",
      countryCode: "706",
      internationalAirportName: "Mogadishu Aden Adde International Airport",
    },
    KOW: {
      airportCode: "KOW",
      city: "Ganzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ganzhou Airport",
    },
    KAO: {
      airportCode: "KAO",
      city: "Kuusamo",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kuusamo Airport",
    },
    QBC: {
      airportCode: "QBC",
      city: "Bella Coola",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Bella Coola Airport",
    },
    SKP: {
      airportCode: "SKP",
      city: "Skopje",
      countryId: "MK",
      countryCode: "807",
      internationalAirportName: "Skopje Airport",
    },
    CCK: {
      airportCode: "CCK",
      city: "Cocos Keeling Island",
      countryId: "AU",
      countryCode: "166",
      internationalAirportName: "Cocos Keeling Island Airport",
    },
    ISE: {
      airportCode: "ISE",
      city: "Isparta",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Isparta Suleyman Demirel Airport",
    },
    VEE: {
      airportCode: "VEE",
      city: "Venetie",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Venetie Airport",
    },
    YHM: {
      airportCode: "YHM",
      city: "Hamilton",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "John C. Munro Hamilton International Airport",
    },
    APW: {
      airportCode: "APW",
      city: "Faleolo",
      countryId: "WS",
      countryCode: "882",
      internationalAirportName: "Faleolo Intl",
    },
    VDS: {
      airportCode: "VDS",
      city: "Vadso",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Vadso Airport",
    },
    URE: {
      airportCode: "URE",
      city: "Kuressaare",
      countryId: "EE",
      countryCode: "233",
      internationalAirportName: "Kuressaare Airport",
    },
    KKA: {
      airportCode: "KKA",
      city: "Koyuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Koyuk Alfred Adams Airport",
    },
    KEP: {
      airportCode: "KEP",
      city: "Mappi",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kepi",
    },
    HBA: {
      airportCode: "HBA",
      city: "Hobart",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Hobart",
    },
    DAR: {
      airportCode: "DAR",
      city: "Dar Es Salaam",
      countryId: "TZ",
      countryCode: "834",
      internationalAirportName: "Julius Nyerere International Airport",
    },
    CFN: {
      airportCode: "CFN",
      city: "Donegal",
      countryId: "IE",
      countryCode: "372",
      internationalAirportName: "Donegal Airport",
    },
    KVL: {
      airportCode: "KVL",
      city: "Kivalina",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kivalina Airport",
    },
    XKS: {
      airportCode: "XKS",
      city: "Kasabonika",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kasabonika Airport",
    },
    LAH: {
      airportCode: "LAH",
      city: "Labuha",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Labuha",
    },
    PTH: {
      airportCode: "PTH",
      city: "Port Heiden",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Heiden Airport",
    },
    ADD: {
      airportCode: "ADD",
      city: "Addis Ababa",
      countryId: "ET",
      countryCode: "231",
      internationalAirportName: "Addis Ababa Bole International Airport",
    },
    YMO: {
      airportCode: "YMO",
      city: "Moosonee",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Moosonee Airport",
    },
    FOG: {
      airportCode: "FOG",
      city: "Foggia",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Foggia Gino Lisa Airport",
    },
    CPE: {
      airportCode: "CPE",
      city: "Campeche",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Ingeniero Alberto Acuna Ongay Intl",
    },
    TOF: {
      airportCode: "TOF",
      city: "Tomsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Tomsk Bogashevo Airport",
    },
    EEK: {
      airportCode: "EEK",
      city: "Eek",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Eek Airport",
    },
    AXA: {
      airportCode: "AXA",
      city: "Anguilla",
      countryId: "AI",
      countryCode: "264",
      internationalAirportName:
        "Anguilla Clayton J. Lloyd International Airport",
    },
    CLT: {
      airportCode: "CLT",
      city: "Charlotte",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Charlotte Douglas Intl Airport",
    },
    YRA: {
      airportCode: "YRA",
      city: "Rae Lakes",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Gameti Rae Lakes Airport",
    },
    YQD: {
      airportCode: "YQD",
      city: "The Pas",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "The Pas Airport",
    },
    IRG: {
      airportCode: "IRG",
      city: "Lockhart River",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Lockhart River Airport",
    },
    CVN: {
      airportCode: "CVN",
      city: "Clovis",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Clovis Regional Airport",
    },
    LPB: {
      airportCode: "LPB",
      city: "La Paz",
      countryId: "BO",
      countryCode: "068",
      internationalAirportName: "El Alto Intl",
    },
    HVG: {
      airportCode: "HVG",
      city: "Honningsvag",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Honningsvag Valan Airport",
    },
    DEN: {
      airportCode: "DEN",
      city: "Denver",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Denver International Airport",
    },
    PKN: {
      airportCode: "PKN",
      city: "Pangkalan Bun",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Iskandar",
    },
    TRS: {
      airportCode: "TRS",
      city: "Trieste",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Trieste Ronchi dei Legionari Airport",
    },
    HET: {
      airportCode: "HET",
      city: "Hohhot",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baita Airport",
    },
    NCL: {
      airportCode: "NCL",
      city: "Newcastle",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Newcastle Int'l",
    },
    AXX: {
      airportCode: "AXX",
      city: "Angel Fire",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Angel Fire Airport",
    },
    ELV: {
      airportCode: "ELV",
      city: "Elfin Cove",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Elfin Cove Seaplane Base",
    },
    VST: {
      airportCode: "VST",
      city: "Stockholm",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Stockholm Vasteras Airport",
    },
    TLK: {
      airportCode: "TLK",
      city: "Talakan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Talakan Airport",
    },
    DPL: {
      airportCode: "DPL",
      city: "Dipolog",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Dipolog",
    },
    LGA: {
      airportCode: "LGA",
      city: "New York",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "La Guardia",
    },
    KPY: {
      airportCode: "KPY",
      city: "Port Bailey",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Bailey Seaplane Base",
    },
    VHM: {
      airportCode: "VHM",
      city: "Vilhelmina",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Vilhelmina Airport",
    },
    TKG: {
      airportCode: "TKG",
      city: "Bandar Lampung",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Radin Inten II Airport",
    },
    RIS: {
      airportCode: "RIS",
      city: "Rishiri Island",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Rishiri Airport",
    },
    SBR: {
      airportCode: "SBR",
      city: "Saibai Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Saibai Island Airport",
    },
    FRO: {
      airportCode: "FRO",
      city: "Floro",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Floro Airport",
    },
    CMW: {
      airportCode: "CMW",
      city: "Camaguey",
      countryId: "CU",
      countryCode: "192",
      internationalAirportName: "Camaguey Ignacio Agramonte Intl Airport",
    },
    KWT: {
      airportCode: "KWT",
      city: "Kwethluk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kwethluk Airport",
    },
    KCO: {
      airportCode: "KCO",
      city: "Kocaeli",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Cengiz Topel Naval Air Station",
    },
    UME: {
      airportCode: "UME",
      city: "Umea",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Umea Airport",
    },
    ESL: {
      airportCode: "ESL",
      city: "Elista",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Elista Airport",
    },
    CED: {
      airportCode: "CED",
      city: "Ceduna",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Ceduna Airport",
    },
    THD: {
      airportCode: "THD",
      city: "Thanh Hoa",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Tho Xuan Airport",
    },
    SXM: {
      airportCode: "SXM",
      city: "Philipsburg",
      countryId: "SX",
      countryCode: "530",
      internationalAirportName: "Princess Juliana Intl",
    },
    VNY: {
      airportCode: "VNY",
      city: "Los Angeles",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Van Nuys Airport",
    },
    CVG: {
      airportCode: "CVG",
      city: "Cincinnati",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Cincinnati Northern Kentucky Intl",
    },
    HVB: {
      airportCode: "HVB",
      city: "Hervey Bay",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Hervey Bay Airport",
    },
    YYH: {
      airportCode: "YYH",
      city: "Taloyoak",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Taloyoak Airport",
    },
    YXN: {
      airportCode: "YXN",
      city: "Whale Cove",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Whale Cove Airport",
    },
    TAK: {
      airportCode: "TAK",
      city: "Takamatsu",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Takamatsu",
    },
    NBX: {
      airportCode: "NBX",
      city: "Nabire",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Nabire",
    },
    YWJ: {
      airportCode: "YWJ",
      city: "Deline",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Deline Airport",
    },
    LLJ: {
      airportCode: "LLJ",
      city: "Lubuk Linggau",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Silampari Airport",
    },
    KUL: {
      airportCode: "KUL",
      city: "Kuala Lumpur",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Kuala Lumpur Intl",
    },
    CMB: {
      airportCode: "CMB",
      city: "Colombo",
      countryId: "LK",
      countryCode: "144",
      internationalAirportName: "Bandaranaike Intl Colombo Airport",
    },
    FRL: {
      airportCode: "FRL",
      city: "Forli",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Forli Luigi Ridolfi Airport",
    },
    RKV: {
      airportCode: "RKV",
      city: "Reykjavik",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Reykjavik Airport",
    },
    FLW: {
      airportCode: "FLW",
      city: "Flores Island (Azores)",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Flores Airport",
    },
    IJK: {
      airportCode: "IJK",
      city: "Izhevsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Izhevsk Airport",
    },
    OGU: {
      airportCode: "OGU",
      city: "Gulyali",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Ordu–Giresun Airport",
    },
    XCH: {
      airportCode: "XCH",
      city: "Christmas Island",
      countryId: "AU",
      countryCode: "162",
      internationalAirportName: "Christmas Island",
    },
    IGR: {
      airportCode: "IGR",
      city: "Iguazu Falls",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Cataratas Del Iguazu",
    },
    RJM: {
      airportCode: "RJM",
      city: "Raja Ampat",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Marinda Raja Ampat Airport",
    },
    HIS: {
      airportCode: "HIS",
      city: "Hayman Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Hayman Island Airport",
    },
    GLA: {
      airportCode: "GLA",
      city: "Glasgow",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Glasgow Airport",
    },
    MLO: {
      airportCode: "MLO",
      city: "Milos",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Milos Island Airport",
    },
    LEQ: {
      airportCode: "LEQ",
      city: "Lands End",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Lands End Airport",
    },
    KAE: {
      airportCode: "KAE",
      city: "Kake",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kake Seaplane Base",
    },
    KNS: {
      airportCode: "KNS",
      city: "King Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "King Island Airport",
    },
    KBR: {
      airportCode: "KBR",
      city: "Kota Bharu",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Sultan Ismail Petra",
    },
    XNB: {
      airportCode: "XNB",
      city: "Dubai",
      countryId: "AE",
      countryCode: "784",
      internationalAirportName: "Etihad Travel Mall (Bus Stop)",
    },
    KOK: {
      airportCode: "KOK",
      city: "Kokkola/Pietarsaari",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kokkola-Pietarsaari Airport",
    },
    TPQ: {
      airportCode: "TPQ",
      city: "Tepic",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Tepic",
    },
    POK: {
      airportCode: "POK",
      city: "St Polten",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "St Polten Railway Station",
    },
    ZGP: {
      airportCode: "ZGP",
      city: "Bilogai",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sugapa",
    },
    MBL: {
      airportCode: "MBL",
      city: "Manistee",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Manistee County Blacker Airport",
    },
    LOE: {
      airportCode: "LOE",
      city: "Loei",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Loei Airport",
    },
    PNP: {
      airportCode: "PNP",
      city: "Popondetta",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Girua Airport",
    },
    PLM: {
      airportCode: "PLM",
      city: "Palembang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Mahmud Badaruddin II",
    },
    BCD: {
      airportCode: "BCD",
      city: "Bacolod",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Bacolod",
    },
    LYC: {
      airportCode: "LYC",
      city: "Lycksele",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Lycksele Airport",
    },
    NTQ: {
      airportCode: "NTQ",
      city: "Wajima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Noto Airport",
    },
    ZNA: {
      airportCode: "ZNA",
      city: "Nanaimo",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Nanaimo Harbor Seaplane Base",
    },
    FIZ: {
      airportCode: "FIZ",
      city: "Fitzroy Crossing",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Fitzroy Crossing Airport",
    },
    FUJ: {
      airportCode: "FUJ",
      city: "Fukue",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Fukue Airport",
    },
    SRG: {
      airportCode: "SRG",
      city: "Semarang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Achmad Yani",
    },
    PLQ: {
      airportCode: "PLQ",
      city: "Palanga",
      countryId: "LT",
      countryCode: "440",
      internationalAirportName: "Palanga International Airport",
    },
    KAL: {
      airportCode: "KAL",
      city: "Kaltag",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kaltag Airport",
    },
    ABV: {
      airportCode: "ABV",
      city: "Abuja",
      countryId: "NG",
      countryCode: "566",
      internationalAirportName: "Nnamdi Azikiwe Intl Airport",
    },
    TTJ: {
      airportCode: "TTJ",
      city: "Tottori",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tottori Airport",
    },
    WUB: {
      airportCode: "WUB",
      city: "Buli, Maba",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Buli",
    },
    SMQ: {
      airportCode: "SMQ",
      city: "Sampit",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "H. Asan Airport",
    },
    LMU: {
      airportCode: "LMU",
      city: "Anambas/Jemaja",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Letung Airport",
    },
    QSZ: {
      airportCode: "QSZ",
      city: "Shache",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shache Ye'erqiang Airport",
    },
    DTB: {
      airportCode: "DTB",
      city: "Silangit",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Silangit",
    },
    AJR: {
      airportCode: "AJR",
      city: "Arvidsjaur",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Arvidsjaur Airport",
    },
    UCT: {
      airportCode: "UCT",
      city: "Ukhta",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Ukhta Airport",
    },
    ZGS: {
      airportCode: "ZGS",
      city: "La Romaine",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "La Romaine Airport",
    },
    HPH: {
      airportCode: "HPH",
      city: "Hai Phong",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Cat Bi International",
    },
    KUA: {
      airportCode: "KUA",
      city: "Kuantan",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Kuantan",
    },
    PGA: {
      airportCode: "PGA",
      city: "Page",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Page Municipal Airport",
    },
    TTT: {
      airportCode: "TTT",
      city: "Taitung",
      countryId: "TW",
      countryCode: "158",
      internationalAirportName: "Taitung Airport",
    },
    TWA: {
      airportCode: "TWA",
      city: "Twin Hills",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Twin Hills Airport",
    },
    SGC: {
      airportCode: "SGC",
      city: "Surgut",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Surgut Airport",
    },
    SIP: {
      airportCode: "SIP",
      city: "Simferopol",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Simferopol International Airport",
    },
    ADZ: {
      airportCode: "ADZ",
      city: "San Andres Island",
      countryId: "CO",
      countryCode: "170",
      internationalAirportName: "Gustavo Rojas Pinilla",
    },
    YKF: {
      airportCode: "YKF",
      city: "Kitchener",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Region of Waterloo International Airport",
    },
    YTE: {
      airportCode: "YTE",
      city: "Cape Dorset",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Cape Dorset Airport",
    },
    SHF: {
      airportCode: "SHF",
      city: "Shihezi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shihezi Huayuan Airport",
    },
    HNS: {
      airportCode: "HNS",
      city: "Haines",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Haines Airport",
    },
    TLA: {
      airportCode: "TLA",
      city: "Teller",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Teller Airport",
    },
    HMA: {
      airportCode: "HMA",
      city: "Khanty-Mansiysk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Khanty-Mansiysk Airport",
    },
    SBT: {
      airportCode: "SBT",
      city: "Sabetta",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Sabetta International Airport",
    },
    KDI: {
      airportCode: "KDI",
      city: "Kendari",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Haluoleo",
    },
    BTH: {
      airportCode: "BTH",
      city: "Batam",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Hang Nadim",
    },
    MFM: {
      airportCode: "MFM",
      city: "Macau",
      countryId: "MO",
      countryCode: "446",
      internationalAirportName: "Macau International Airport",
    },
    FCO: {
      airportCode: "FCO",
      city: "Rome",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Fiumicino Airport",
    },
    MZH: {
      airportCode: "MZH",
      city: "Amasya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Amasya Merzifon Airport",
    },
    MDQ: {
      airportCode: "MDQ",
      city: "Mar Del Plata",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Mar Del Plata",
    },
    WYA: {
      airportCode: "WYA",
      city: "Whyalla",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Whyalla Airport",
    },
    PMY: {
      airportCode: "PMY",
      city: "Puerto Madryn",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "El Tehuelche",
    },
    GRZ: {
      airportCode: "GRZ",
      city: "Graz",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Graz Airport",
    },
    SQG: {
      airportCode: "SQG",
      city: "Sintang",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Susilo",
    },
    ZZJ: {
      airportCode: "ZZJ",
      city: "ZZJLocal Location",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "ZZJNAME",
    },
    JHG: {
      airportCode: "JHG",
      city: "Jinghong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xishuangbanna Gasa International Airport ",
    },
    USA: {
      airportCode: "USA",
      city: "North Carolina",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Concord Reg. Airport",
    },
    YPO: {
      airportCode: "YPO",
      city: "Peawanuk",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Peawanuck Airport",
    },
    AKV: {
      airportCode: "AKV",
      city: "Akulivik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Akulivik Airport",
    },
    PEC: {
      airportCode: "PEC",
      city: "Pelican",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Pelican Seaplane Base",
    },
    VAK: {
      airportCode: "VAK",
      city: "Chevak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chevak Airport",
    },
    EXT: {
      airportCode: "EXT",
      city: "Exeter",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Exeter Airport",
    },
    KEK: {
      airportCode: "KEK",
      city: "Ekwok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ekwok Airport",
    },
    TNR: {
      airportCode: "TNR",
      city: "Antananarivo",
      countryId: "MG",
      countryCode: "450",
      internationalAirportName: "Ivato Intl",
    },
    LOP: {
      airportCode: "LOP",
      city: "Lombok",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Lombok Praya Intl",
    },
    ENA: {
      airportCode: "ENA",
      city: "Kenai",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kenai Municipal Airport",
    },
    OOL: {
      airportCode: "OOL",
      city: "Gold Coast",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Gold Coast Intl",
    },
    BAY: {
      airportCode: "BAY",
      city: "Baia Mare",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Baia Mare Airport",
    },
    BKQ: {
      airportCode: "BKQ",
      city: "Blackall",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Blackall Airport",
    },
    NDR: {
      airportCode: "NDR",
      city: "Nador",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Nador International Airport",
    },
    UBB: {
      airportCode: "UBB",
      city: "Mabuiag Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mabuiag Island Airport",
    },
    JOG: {
      airportCode: "JOG",
      city: "Yogyakarta",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Adi Sutjipto",
    },
    SOU: {
      airportCode: "SOU",
      city: "Southampton",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Southampton Airport",
    },
    HTT: {
      airportCode: "HTT",
      city: "Huatugou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Huatugou Airport",
    },
    ZCL: {
      airportCode: "ZCL",
      city: "Zacatecas",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "General Leobardo C Ruiz Intl",
    },
    YYT: {
      airportCode: "YYT",
      city: "St. John's",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "St. John's International Airport",
    },
    PNK: {
      airportCode: "PNK",
      city: "Pontianak",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Supadio",
    },
    HAC: {
      airportCode: "HAC",
      city: "Hachijojima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Hachijojima Airport",
    },
    CIK: {
      airportCode: "CIK",
      city: "Chalkyitsik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chalkyitsik Airport",
    },
    SOQ: {
      airportCode: "SOQ",
      city: "Sorong",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Domine Eduard Osok",
    },
    YUS: {
      airportCode: "YUS",
      city: "Yushu",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yushu Batang Airport",
    },
    AKB: {
      airportCode: "AKB",
      city: "Atka",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Atka Airport",
    },
    NAH: {
      airportCode: "NAH",
      city: "Naha",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Naha",
    },
    BMA: {
      airportCode: "BMA",
      city: "Stockholm",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Bromma Stockholm Airport",
    },
    YYE: {
      airportCode: "YYE",
      city: "Fort Nelson",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Northern Rockies Regional Airport",
    },
    NIM: {
      airportCode: "NIM",
      city: "Niamey",
      countryId: "NE",
      countryCode: "562",
      internationalAirportName: "Diori Hamani International Airport",
    },
    CFR: {
      airportCode: "CFR",
      city: "Caen",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Caen Carpiquet Airport",
    },
    YLX: {
      airportCode: "YLX",
      city: "Yulin",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yulin Fumian Airport",
    },
    PMI: {
      airportCode: "PMI",
      city: "Palma de Mallorca",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Son Sant Joan",
    },
    DIL: {
      airportCode: "DIL",
      city: "Dili",
      countryId: "TP",
      countryCode: "626",
      internationalAirportName: "Presidente Nicolau Lobato Intl",
    },
    KHI: {
      airportCode: "KHI",
      city: "Karachi",
      countryId: "PK",
      countryCode: "586",
      internationalAirportName: "Jinnah Intl",
    },
    PEE: {
      airportCode: "PEE",
      city: "Perm",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Perm Bolshoye Savino International Airport",
    },
    VRC: {
      airportCode: "VRC",
      city: "Virac",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Virac Airport",
    },
    JSY: {
      airportCode: "JSY",
      city: "Syros Island",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Syros Island Dimitrios Vikelas Airport",
    },
    PDX: {
      airportCode: "PDX",
      city: "Portland",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Portland International Airport",
    },
    PAS: {
      airportCode: "PAS",
      city: "Paros",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Paros Airport",
    },
    NPL: {
      airportCode: "NPL",
      city: "New Plymouth",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "New Plymouth Airport",
    },
    MXL: {
      airportCode: "MXL",
      city: "Mexicali",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "General Rodolfo Sanchez Taboada Intl",
    },
    CRA: {
      airportCode: "CRA",
      city: "Craiova",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Craiova International Airport",
    },
    YYZ: {
      airportCode: "YYZ",
      city: "Toronto",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Lester B Pearson Intl",
    },
    GNY: {
      airportCode: "GNY",
      city: "Sanlıurfa",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Sanlıurfa GAP Airport",
    },
    VKT: {
      airportCode: "VKT",
      city: "Vorkuta",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Vorkuta Airport",
    },
    RDO: {
      airportCode: "RDO",
      city: "Warsaw",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Warsaw Radom Airport",
    },
    OSW: {
      airportCode: "OSW",
      city: "Orsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Orsk Airport",
    },
    USQ: {
      airportCode: "USQ",
      city: "Usak",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Usak Airport",
    },
    ZRJ: {
      airportCode: "ZRJ",
      city: "Round Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Weagamow Lake Airport",
    },
    YTQ: {
      airportCode: "YTQ",
      city: "Tasiujuaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Tasiujaq Airport",
    },
    BZG: {
      airportCode: "BZG",
      city: "Bydgoszcz",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Bydgoszcz Ignacy Jan Paderewski Airport",
    },
    CJJ: {
      airportCode: "CJJ",
      city: "Cheongju",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Cheongju Int'l Airport",
    },
    YHU: {
      airportCode: "YHU",
      city: "Montreal",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Montreal Metropolitan Airport",
    },
    CYZ: {
      airportCode: "CYZ",
      city: "Cauayan",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Cauayan Airport",
    },
    USK: {
      airportCode: "USK",
      city: "Usinsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Usinsk Airport",
    },
    EMD: {
      airportCode: "EMD",
      city: "Emerald",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Emerald Airport",
    },
    EGX: {
      airportCode: "EGX",
      city: "Egegik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Egegik Airport",
    },
    MIG: {
      airportCode: "MIG",
      city: "Mianyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Mianyang Nanjiao Airport",
    },
    VVI: {
      airportCode: "VVI",
      city: "Santa Cruz",
      countryId: "BO",
      countryCode: "068",
      internationalAirportName: "Viru Viru International Airport",
    },
    YKG: {
      airportCode: "YKG",
      city: "Kangirsuk",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kangirsuk Airport",
    },
    URA: {
      airportCode: "URA",
      city: "Uralsk",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Oral Ak Zhol Airport",
    },
    QQQ: {
      airportCode: "QQQ",
      city: "Bangkok",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "QQQ Airport",
    },
    BUC: {
      airportCode: "BUC",
      city: "Burketown",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Burketown Airport",
    },
    SVG: {
      airportCode: "SVG",
      city: "Stavanger",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Sola",
    },
    AUH: {
      airportCode: "AUH",
      city: "Abu Dhabi",
      countryId: "AE",
      countryCode: "784",
      internationalAirportName: "Abu Dhabi Intl",
    },
    ZFD: {
      airportCode: "ZFD",
      city: "Fond Du Lac",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fond-du-Lac Airport",
    },
    MOL: {
      airportCode: "MOL",
      city: "Molde",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Molde Aro Airport",
    },
    HID: {
      airportCode: "HID",
      city: "Horn Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Horn Island Airport",
    },
    DBC: {
      airportCode: "DBC",
      city: "Baicheng",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Baicheng Chang'an Airport",
    },
    MUA: {
      airportCode: "MUA",
      city: "Munda",
      countryId: "SB",
      countryCode: "090",
      internationalAirportName: "Munda Airport",
    },
    CNN: {
      airportCode: "CNN",
      city: "Kerala",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Kannur International Airport",
    },
    ZLT: {
      airportCode: "ZLT",
      city: "La Tabatiere",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "La Tabatiere Airport",
    },
    ILD: {
      airportCode: "ILD",
      city: "Catalonia",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Lleida–Alguaire Airport",
    },
    VIL: {
      airportCode: "VIL",
      city: "Dakhla",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Dakhla Airport",
    },
    TEN: {
      airportCode: "TEN",
      city: "Tongren",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tongren",
    },
    BGO: {
      airportCode: "BGO",
      city: "Bergen",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Flesland",
    },
    FRD: {
      airportCode: "FRD",
      city: "Friday Harbor",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Friday Harbor Airport",
    },
    TCG: {
      airportCode: "TCG",
      city: "Tacheng",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Tacheng Qianquan Airport",
    },
    FKS: {
      airportCode: "FKS",
      city: "Fukushima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Fukushima Airport",
    },
    NDJ: {
      airportCode: "NDJ",
      city: "N'Djamena",
      countryId: "TD",
      countryCode: "148",
      internationalAirportName: "N'Djamena International Airport",
    },
    BUW: {
      airportCode: "BUW",
      city: "Bau-Bau, Buton",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Betoambari",
    },
    AYQ: {
      airportCode: "AYQ",
      city: "Uluru",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Ayers Rock",
    },
    YFO: {
      airportCode: "YFO",
      city: "Flin Flon",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Flin Flon Airport",
    },
    PRA: {
      airportCode: "PRA",
      city: "Parana",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "General Urquiza",
    },
    DAU: {
      airportCode: "DAU",
      city: "Daru ",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Daru Airport",
    },
    BKO: {
      airportCode: "BKO",
      city: "Bamako",
      countryId: "ML",
      countryCode: "466",
      internationalAirportName: "Bamako-Senou International Airport",
    },
    BWX: {
      airportCode: "BWX",
      city: "Banyuwangi",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Blimbingsari",
    },
    NAO: {
      airportCode: "NAO",
      city: "Nanchong",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Nanchong Airport",
    },
    YXP: {
      airportCode: "YXP",
      city: "Pangnirtung",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Pangnirtung Airport",
    },
    LRU: {
      airportCode: "LRU",
      city: "Las Cruces",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Las Cruces International Airport",
    },
    LUV: {
      airportCode: "LUV",
      city: "Langgur-Kei",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dumatubun Airport",
    },
    DLM: {
      airportCode: "DLM",
      city: "Dalaman",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Dalaman Airport",
    },
    NST: {
      airportCode: "NST",
      city: "Nakhon Si Thammarat",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Nakhon Si Thammarat Airport",
    },
    TIZ: {
      airportCode: "TIZ",
      city: "Tari",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Tari Airport",
    },
    NKT: {
      airportCode: "NKT",
      city: "Sırnak",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Sırnak Airport",
    },
    STR: {
      airportCode: "STR",
      city: "Stuttgart",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Stuttgart Airport",
    },
    TAP: {
      airportCode: "TAP",
      city: "Tapachula",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Tapachula Intl",
    },
    KPR: {
      airportCode: "KPR",
      city: "Port Williams",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Port Williams Seaplane Base",
    },
    YHR: {
      airportCode: "YHR",
      city: "Chevery",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Chevery Airport",
    },
    CCF: {
      airportCode: "CCF",
      city: "Carcassonne",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Carcassonne Airport",
    },
    KOJ: {
      airportCode: "KOJ",
      city: "Kagoshima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kagoshima",
    },
    MLX: {
      airportCode: "MLX",
      city: "Malatya",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Malatya Erhac Airport",
    },
    EZE: {
      airportCode: "EZE",
      city: "Buenos Aires",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Ministro Pistarini Intl",
    },
    KZO: {
      airportCode: "KZO",
      city: "Kyzylorda",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Kyzylorda Airport",
    },
    BPE: {
      airportCode: "BPE",
      city: "Qinhuangdao",
      countryId: "CN",
      countryCode: "104",
      internationalAirportName: "Qinhuangdao Beidaihe Airport",
    },
    CGP: {
      airportCode: "CGP",
      city: "Chittagong",
      countryId: "BD",
      countryCode: "050",
      internationalAirportName: "Shah Amanat Intl",
    },
    GDZ: {
      airportCode: "GDZ",
      city: "Gelendzik",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Gelendzhik Airport",
    },
    EBJ: {
      airportCode: "EBJ",
      city: "Esbjerg",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Esbjerg Airport",
    },
    WXN: {
      airportCode: "WXN",
      city: "Wanzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wanzhou Wuqiao Airport",
    },
    BJM: {
      airportCode: "BJM",
      city: "Bujumbura",
      countryId: "BI",
      countryCode: "108",
      internationalAirportName: "Bujumbura International Airport",
    },
    SAD: {
      airportCode: "SAD",
      city: "Safford",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Safford Regional Airport",
    },
    YYF: {
      airportCode: "YYF",
      city: "Penticton",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Penticton Regional Airport",
    },
    IGG: {
      airportCode: "IGG",
      city: "Igiugig",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Igiugig Airport",
    },
    YYD: {
      airportCode: "YYD",
      city: "Smithers",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Smithers Airport",
    },
    KKE: {
      airportCode: "KKE",
      city: "Kerikeri",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Kerikeri Airport",
    },
    YNS: {
      airportCode: "YNS",
      city: "Nemiscau",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Nemiscau Airport",
    },
    RTW: {
      airportCode: "RTW",
      city: "Saratov",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Saratov Tsentralny Airport",
    },
    RUT: {
      airportCode: "RUT",
      city: "Rutland",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Rutland Southern Vermont Regional Airport",
    },
    RMA: {
      airportCode: "RMA",
      city: "Roma",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Roma Airport",
    },
    VKO: {
      airportCode: "VKO",
      city: "Moscow",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Vnukovo International Airport",
    },
    UNN: {
      airportCode: "UNN",
      city: "Ranong",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Ranong",
    },
    MDU: {
      airportCode: "MDU",
      city: "Mendi",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Mendi Airport",
    },
    MKZ: {
      airportCode: "MKZ",
      city: "Malacca",
      countryId: "MY",
      countryCode: "458",
      internationalAirportName: "Batu Berendam Intl",
    },
    MED: {
      airportCode: "MED",
      city: "Madinah",
      countryId: "SA",
      countryCode: "682",
      internationalAirportName: "Prince Mohammad Bin Abdulaziz",
    },
    KKN: {
      airportCode: "KKN",
      city: "Kirkenes",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Kirkenes Hoybuktmoen Airport",
    },
    EGC: {
      airportCode: "EGC",
      city: "Bergerac",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Bergerac Dordogne Perigord Airport",
    },
    HNM: {
      airportCode: "HNM",
      city: "Hana",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hana Airport",
    },
    MBE: {
      airportCode: "MBE",
      city: "Monbetsu",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Monbetsu Airport",
    },
    SHS: {
      airportCode: "SHS",
      city: "Shashi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jingzhou Shashi Airport",
    },
    ORD: {
      airportCode: "ORD",
      city: "Chicago",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chicago Ohare Intl",
    },
    SNU: {
      airportCode: "SNU",
      city: "Santa Clara",
      countryId: "CU",
      countryCode: "192",
      internationalAirportName: "Santa Clara Abel Santamaria Airport",
    },
    IAA: {
      airportCode: "IAA",
      city: "Igarka",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Igarka Airport",
    },
    TSN: {
      airportCode: "TSN",
      city: "Tianjin",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Binhai",
    },
    XTG: {
      airportCode: "XTG",
      city: "Thargomindah",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Thargomindah Airport",
    },
    YOJ: {
      airportCode: "YOJ",
      city: "High Level",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "High Level Airport",
    },
    SUJ: {
      airportCode: "SUJ",
      city: "Satu Mare",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Satu Mare International Airport",
    },
    YYJ: {
      airportCode: "YYJ",
      city: "Victoria",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Victoria International Airport",
    },
    YMX: {
      airportCode: "YMX",
      city: "Montreal",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Montreal Mirabel International Airport",
    },
    XBE: {
      airportCode: "XBE",
      city: "Bearskin Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Bearskin Lake Airport",
    },
    KGL: {
      airportCode: "KGL",
      city: "Kigali",
      countryId: "RW",
      countryCode: "646",
      internationalAirportName: "Kigali International Airport",
    },
    RET: {
      airportCode: "RET",
      city: "Rost",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Rost Airport",
    },
    BJL: {
      airportCode: "BJL",
      city: "Banjul",
      countryId: "GM",
      countryCode: "270",
      internationalAirportName: "Banjul International Airport",
    },
    TBN: {
      airportCode: "TBN",
      city: "Fort Leonard Wood",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Waynesville Saint Robert Regional Airport",
    },
    HOV: {
      airportCode: "HOV",
      city: "Orsta-Volda",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Orsta-Volda Airport",
    },
    YGT: {
      airportCode: "YGT",
      city: "Igloolik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Igloolik Airport",
    },
    MJT: {
      airportCode: "MJT",
      city: "Mytilene",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Mytilene Odysseas Elytis Airport",
    },
    KJP: {
      airportCode: "KJP",
      city: "Kerama Islands",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kerama Airport",
    },
    PSJ: {
      airportCode: "PSJ",
      city: "Poso",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kasiguncu",
    },
    YSQ: {
      airportCode: "YSQ",
      city: "Songyuan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Songyuan Chaganhu Airport",
    },
    SWQ: {
      airportCode: "SWQ",
      city: "Sumbawa Besar",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Mahmud Kaharuddin/Brangbiji",
    },
    CFU: {
      airportCode: "CFU",
      city: "Corfu",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Ioannis Kapodistrias International Airport",
    },
    MME: {
      airportCode: "MME",
      city: "Teesside",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Durham Tees Valley Airport",
    },
    DMM: {
      airportCode: "DMM",
      city: "Dammam",
      countryId: "SA",
      countryCode: "682",
      internationalAirportName: "King Fahd Intl",
    },
    TUF: {
      airportCode: "TUF",
      city: "Tours",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Tours Val de Loire Airport",
    },
    XZM: {
      airportCode: "XZM",
      city: "Macau",
      countryId: "MO",
      countryCode: "446",
      internationalAirportName: "Macau Ferry Pier",
    },
    NLT: {
      airportCode: "NLT",
      city: "Xinyuan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xinyuan Nalati Airport",
    },
    TBB: {
      airportCode: "TBB",
      city: "Tuy Hoa",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Dong Tac",
    },
    ATT: {
      airportCode: "ATT",
      city: "Atmautluak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Atmautluak Airport",
    },
    DCY: {
      airportCode: "DCY",
      city: "Daocheng",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Daocheng Yading Airport",
    },
    KNG: {
      airportCode: "KNG",
      city: "Kaimana",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Utarom",
    },
    YGV: {
      airportCode: "YGV",
      city: "Havre St. Pierre",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Havre Saint-Pierre Airport",
    },
    TOY: {
      airportCode: "TOY",
      city: "Toyama",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Toyama",
    },
    BKS: {
      airportCode: "BKS",
      city: "Bengkulu",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Fatmawati Soekarno",
    },
    KIF: {
      airportCode: "KIF",
      city: "Kingfisher Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kingfisher Lake Airport",
    },
    KTS: {
      airportCode: "KTS",
      city: "Teller Mission",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Brevig Mission Airport",
    },
    PEZ: {
      airportCode: "PEZ",
      city: "Penza",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Penza Ternovka Airport",
    },
    FUG: {
      airportCode: "FUG",
      city: "Fuyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Fuyang Xiguan",
    },
    CTL: {
      airportCode: "CTL",
      city: "Charleville",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Charleville Airport",
    },
    DMB: {
      airportCode: "DMB",
      city: "Taraz",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Taraz Airport",
    },
    DTW: {
      airportCode: "DTW",
      city: "Detroit",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Detroit Metro Airport",
    },
    BXU: {
      airportCode: "BXU",
      city: "Butuan",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Butuan",
    },
    KNW: {
      airportCode: "KNW",
      city: "New Stuyahok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "New Stuyahok Airport",
    },
    KCC: {
      airportCode: "KCC",
      city: "Coffman Cove",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Coffman Cove Seaplane Base",
    },
    YYR: {
      airportCode: "YYR",
      city: "Goose Bay",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Goose Bay Airport",
    },
    LNO: {
      airportCode: "LNO",
      city: "Leonora",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Leonora Airport",
    },
    PPP: {
      airportCode: "PPP",
      city: "Proserpine",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Proserpine Whitsunday Coast",
    },
    BOD: {
      airportCode: "BOD",
      city: "Bordeaux",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Merignac",
    },
    ABM: {
      airportCode: "ABM",
      city: "Bamaga",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Northern Peninsula Airport",
    },
    PAG: {
      airportCode: "PAG",
      city: "Pagadian",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Pagadian Airport",
    },
    HCJ: {
      airportCode: "HCJ",
      city: "Hechi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Hechi Jinchengjiang Airport",
    },
    MYU: {
      airportCode: "MYU",
      city: "Mekoryuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Mekoryuk Ellis Field Airport",
    },
    GWT: {
      airportCode: "GWT",
      city: "Westerland",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Sylt Airport",
    },
    KCL: {
      airportCode: "KCL",
      city: "Chignik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chignik Lagoon Airport",
    },
    MPL: {
      airportCode: "MPL",
      city: "Montpellier",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Montpellier-Mediterranee",
    },
    PRN: {
      airportCode: "PRN",
      city: "Pristina",
      countryId: "XK",
      countryCode: "383",
      internationalAirportName: "Pristina International Airport",
    },
    MPC: {
      airportCode: "MPC",
      city: "Mukomuko",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mukomuko Airport",
    },
    ARD: {
      airportCode: "ARD",
      city: "Alor",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Mali Airport",
    },
    IFJ: {
      airportCode: "IFJ",
      city: "Isafjordur",
      countryId: "IS",
      countryCode: "352",
      internationalAirportName: "Isafjordur Airport",
    },
    BJV: {
      airportCode: "BJV",
      city: "Bodrum",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Milas–Bodrum Airport",
    },
    RPI: {
      airportCode: "RPI",
      city: "Rampi",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Onondowa",
    },
    ASJ: {
      airportCode: "ASJ",
      city: "Amami",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Amami Airport",
    },
    SJC: {
      airportCode: "SJC",
      city: "San Jose",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Norman Y Mineta San Jose Intl",
    },
    YCO: {
      airportCode: "YCO",
      city: "Kugluktuk/Coppermine",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kugluktuk Airport",
    },
    MIA: {
      airportCode: "MIA",
      city: "Miami",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Miami Intl",
    },
    MOH: {
      airportCode: "MOH",
      city: "Morowali",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Morowali Airport",
    },
    UTH: {
      airportCode: "UTH",
      city: "Udon Thani",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Udon Thani International Airport",
    },
    SHM: {
      airportCode: "SHM",
      city: "Nanki-shirahama",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Nanki Shirahama",
    },
    KYK: {
      airportCode: "KYK",
      city: "Karluk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Karluk Airport",
    },
    SGO: {
      airportCode: "SGO",
      city: "Saint George",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "St George Airport",
    },
    TBW: {
      airportCode: "TBW",
      city: "Tambov",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Tambov Donskoye Airport",
    },
    BCI: {
      airportCode: "BCI",
      city: "Barcaldine",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Barcaldine Airport",
    },
    YNA: {
      airportCode: "YNA",
      city: "Natashquan",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Natashquan Airport",
    },
    XKH: {
      airportCode: "XKH",
      city: "Phonsavan",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Xieng Khouang Airport",
    },
    ADL: {
      airportCode: "ADL",
      city: "Adelaide",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Adelaide Intl",
    },
    TJH: {
      airportCode: "TJH",
      city: "Toyooka",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tajima Airport",
    },
    SIN: {
      airportCode: "SIN",
      city: "Singapore",
      countryId: "SG",
      countryCode: "702",
      internationalAirportName: "Changi Intl",
    },
    NYO: {
      airportCode: "NYO",
      city: "Stockholm",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Stockholm Skavsta Airport",
    },
    NAN: {
      airportCode: "NAN",
      city: "Nandi",
      countryId: "FJ",
      countryCode: "242",
      internationalAirportName: "Nadi Intl",
    },
    RCU: {
      airportCode: "RCU",
      city: "Rio Cuarto",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Rio Cuarto Area De Material",
    },
    KOX: {
      airportCode: "KOX",
      city: "Mimika Barat",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kokonao",
    },
    ERH: {
      airportCode: "ERH",
      city: "Errachidia",
      countryId: "MA",
      countryCode: "504",
      internationalAirportName: "Errachidia Moulay Ali Cherif Airport",
    },
    PHL: {
      airportCode: "PHL",
      city: "Philadelphia",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Philadelphia International Airport",
    },
    BDU: {
      airportCode: "BDU",
      city: "Bardufoss",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Bardufoss Airport",
    },
    DUJ: {
      airportCode: "DUJ",
      city: "Dubois",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "DuBois Regional Airport",
    },
    LBJ: {
      airportCode: "LBJ",
      city: "Labuan Bajo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Komodo",
    },
    YWL: {
      airportCode: "YWL",
      city: "Williams Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Williams Lake Airport",
    },
    AEP: {
      airportCode: "AEP",
      city: "Buenos Aires",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Aeroparque Jorge Newbery",
    },
    LXS: {
      airportCode: "LXS",
      city: "Limnos",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Limnos Airport",
    },
    ABU: {
      airportCode: "ABU",
      city: "Atambua",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "AA Bere Tallo",
    },
    LKL: {
      airportCode: "LKL",
      city: "Lakselv",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Lakselv Banak Airport",
    },
    AUK: {
      airportCode: "AUK",
      city: "Alakanuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Alakanuk Airport",
    },
    DZH: {
      airportCode: "DZH",
      city: "Dazhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Dazhou Jinya Airport",
    },
    LIS: {
      airportCode: "LIS",
      city: "Lisbon",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Lisboa",
    },
    INC: {
      airportCode: "INC",
      city: "Yinchuan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Yinchuan",
    },
    BGI: {
      airportCode: "BGI",
      city: "Bridgetown",
      countryId: "BB",
      countryCode: "052",
      internationalAirportName: "Grantley Adams International Airport",
    },
    YYY: {
      airportCode: "YYY",
      city: "Mont Joli",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Mont-Joli Airport",
    },
    DAC: {
      airportCode: "DAC",
      city: "Dhaka",
      countryId: "BD",
      countryCode: "050",
      internationalAirportName: "Zia Intl",
    },
    MAS: {
      airportCode: "MAS",
      city: "Los Negros Island",
      countryId: "PG",
      countryCode: "598",
      internationalAirportName: "Momote Airport",
    },
    GYU: {
      airportCode: "GYU",
      city: "Guyuan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Guyuan Liupanshan Airport",
    },
    WIC: {
      airportCode: "WIC",
      city: "Wick",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Wick John O'Groats Airport",
    },
    BHB: {
      airportCode: "BHB",
      city: "Bar Harbor",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hancock County-Bar Harbor Airport",
    },
    BHE: {
      airportCode: "BHE",
      city: "Woodbourne",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Woodbourne Airport",
    },
    KLF: {
      airportCode: "KLF",
      city: "Kaluga",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kaluga Grabtsevo Airport",
    },
    IKI: {
      airportCode: "IKI",
      city: "Iki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Iki Airport",
    },
    BLQ: {
      airportCode: "BLQ",
      city: "Bologna",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Bologna",
    },
    GVA: {
      airportCode: "GVA",
      city: "Geneva",
      countryId: "CH",
      countryCode: "756",
      internationalAirportName: "Geneva Cointrin",
    },
    PSR: {
      airportCode: "PSR",
      city: "Pescara",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Pescara Abruzzo International Airport",
    },
    MKR: {
      airportCode: "MKR",
      city: "Meekatharra",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Meekatharra Airport",
    },
    HXD: {
      airportCode: "HXD",
      city: "Delingha City",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Delingha Airport",
    },
    ONJ: {
      airportCode: "ONJ",
      city: "Akita",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Odate Noshiro Airport",
    },
    XSP: {
      airportCode: "XSP",
      city: "Singapore",
      countryId: "SG",
      countryCode: "702",
      internationalAirportName: "Seletar Airport",
    },
    KKI: {
      airportCode: "KKI",
      city: "Akiachak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Akiachak Airport",
    },
    DXJ: {
      airportCode: "DXJ",
      city: "Biancheng",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xiangxi Biancheng Airport",
    },
    DGT: {
      airportCode: "DGT",
      city: "Dumaguete",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Sibulan",
    },
    WUN: {
      airportCode: "WUN",
      city: "Wiluna",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Wiluna Airport",
    },
    VCE: {
      airportCode: "VCE",
      city: "Venice",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Venice Marco Polo Airport",
    },
    GGW: {
      airportCode: "GGW",
      city: "Glasgow",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Glasgow Valley County Airport",
    },
    TYN: {
      airportCode: "TYN",
      city: "Taiyuan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Wusu Airport",
    },
    SDE: {
      airportCode: "SDE",
      city: "Santiago Del Estero",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Santiago Del Estero",
    },
    HAA: {
      airportCode: "HAA",
      city: "Hasvik",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Hasvik Airport",
    },
    SNR: {
      airportCode: "SNR",
      city: "Saint Nazaire",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Saint Nazaire Montoir Airport",
    },
    HTI: {
      airportCode: "HTI",
      city: "Hamilton Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Great Barrier R",
    },
    YUL: {
      airportCode: "YUL",
      city: "Montreal",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Pierre Elliott Trudeau Intl",
    },
    TSA: {
      airportCode: "TSA",
      city: "Taipei",
      countryId: "TW",
      countryCode: "158",
      internationalAirportName: "Sungshan",
    },
    GAM: {
      airportCode: "GAM",
      city: "Gambell",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Gambell Airport",
    },
    GSV: {
      airportCode: "GSV",
      city: "Saratov",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Saratov Gagarin International Airport",
    },
    SAI: {
      airportCode: "SAI",
      city: "Siem Reap",
      countryId: "KH",
      countryCode: "116",
      internationalAirportName: "Siem Reap Angkor International Airport",
    },
    JTY: {
      airportCode: "JTY",
      city: "Astypalaia Island",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Astypalaia Island National Airport",
    },
    EVN: {
      airportCode: "EVN",
      city: "Yerevan",
      countryId: "AM",
      countryCode: "051",
      internationalAirportName: "Zvartnots International Airport",
    },
    YBE: {
      airportCode: "YBE",
      city: "Uranium City",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Uranium City Airport",
    },
    ISA: {
      airportCode: "ISA",
      city: "Mount Isa",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Mount Isa Airport",
    },
    SLA: {
      airportCode: "SLA",
      city: "Salta",
      countryId: "AR",
      countryCode: "032",
      internationalAirportName: "Salta",
    },
    REN: {
      airportCode: "REN",
      city: "Orenburg",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Orenburg Tsentralny Airport",
    },
    OKE: {
      airportCode: "OKE",
      city: "Wadomari",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Okinoerabu Airport",
    },
    CJN: {
      airportCode: "CJN",
      city: "Pangandaran",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Cijulang Nusawiru",
    },
    ACC: {
      airportCode: "ACC",
      city: "Accra",
      countryId: "GH",
      countryCode: "288",
      internationalAirportName: "Kotoka Intl",
    },
    BTI: {
      airportCode: "BTI",
      city: "Barter Island",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Barter Island LRRS Airport",
    },
    BEU: {
      airportCode: "BEU",
      city: "Bedourie",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Bedourie Airport",
    },
    KJT: {
      airportCode: "KJT",
      city: "Majalengka",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kertajati International Airport",
    },
    KNO: {
      airportCode: "KNO",
      city: "Medan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Kuala Namu",
    },
    CCC: {
      airportCode: "CCC",
      city: "Cayo Coco",
      countryId: "CU",
      countryCode: "192",
      internationalAirportName: "Cayo Coco Jardines del Rey Airport",
    },
    YPN: {
      airportCode: "YPN",
      city: "Port-Menier",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Port-Menier Airport",
    },
    SBD: {
      airportCode: "SBD",
      city: "San Bernardino",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "San Bernardino International Airport",
    },
    KRK: {
      airportCode: "KRK",
      city: "Krakow",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Balice",
    },
    RTB: {
      airportCode: "RTB",
      city: "Roatan",
      countryId: "HN",
      countryCode: "340",
      internationalAirportName: "Juan Manuel Galvez Intl",
    },
    RRS: {
      airportCode: "RRS",
      city: "Roros",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Roros Airport",
    },
    FOA: {
      airportCode: "FOA",
      city: "Foula",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Foula Airfield",
    },
    CPD: {
      airportCode: "CPD",
      city: "Coober Pedy",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Coober Pedy Airport",
    },
    TEQ: {
      airportCode: "TEQ",
      city: "Corlu",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Tekirdag Corlu Airport",
    },
    NOC: {
      airportCode: "NOC",
      city: "Knock",
      countryId: "IE",
      countryCode: "372",
      internationalAirportName: "Knock Ireland West Airport",
    },
    KKB: {
      airportCode: "KKB",
      city: "Kitui Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Kitoi Bay Seaplane Base",
    },
    YVB: {
      airportCode: "YVB",
      city: "Bonaventure",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Bonaventure Airport",
    },
    LUZ: {
      airportCode: "LUZ",
      city: "Swidnik",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Lublin Airport",
    },
    GES: {
      airportCode: "GES",
      city: "General Santos",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "General Santos Int'l Airport",
    },
    YER: {
      airportCode: "YER",
      city: "Fort Severn",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fort Severn Airport",
    },
    RSU: {
      airportCode: "RSU",
      city: "Yeosu",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Yeosu Airport",
    },
    LIM: {
      airportCode: "LIM",
      city: "Lima",
      countryId: "PE",
      countryCode: "604",
      internationalAirportName: "Jorge Chavez Intl",
    },
    JGN: {
      airportCode: "JGN",
      city: "Jiayuguan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jiayuguan Airport",
    },
    NGS: {
      airportCode: "NGS",
      city: "Nagasaki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Nagasaki Airport",
    },
    WRE: {
      airportCode: "WRE",
      city: "Whangarei",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Whangarei Airport",
    },
    DPS: {
      airportCode: "DPS",
      city: "Bali / Denpasar",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Ngurah Rai Int'l",
    },
    WNI: {
      airportCode: "WNI",
      city: "Wakatobi",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Matahora",
    },
    TBM: {
      airportCode: "TBM",
      city: "Katingan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tumbang Samba",
    },
    IAO: {
      airportCode: "IAO",
      city: "Siargao",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Sayak Airport",
    },
    ZSB: {
      airportCode: "ZSB",
      city: "Salzburg",
      countryId: "AT",
      countryCode: "040",
      internationalAirportName: "Salzburg Central Station",
    },
    IVL: {
      airportCode: "IVL",
      city: "Ivalo",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Ivalo Airport",
    },
    DUB: {
      airportCode: "DUB",
      city: "Dublin",
      countryId: "IE",
      countryCode: "372",
      internationalAirportName: "Dublin Airport",
    },
    AGI: {
      airportCode: "AGI",
      city: "Agimuga",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Agimuga",
    },
    NLH: {
      airportCode: "NLH",
      city: "Ninglang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ninglang Luguhu Airport",
    },
    SCM: {
      airportCode: "SCM",
      city: "Scammon Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Scammon Bay Airport",
    },
    YAX: {
      airportCode: "YAX",
      city: "Angling Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Wapekeka Angling Lake Airport",
    },
    TSF: {
      airportCode: "TSF",
      city: "Venice",
      countryId: "IT",
      countryCode: "380",
      internationalAirportName: "Venice Treviso Airport",
    },
    TUP: {
      airportCode: "TUP",
      city: "Tupelo",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tupelo Regional Airport",
    },
    YIK: {
      airportCode: "YIK",
      city: "Ivujivik",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Ivujivik Airport",
    },
    SKN: {
      airportCode: "SKN",
      city: "Stokmarknes",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Stokmarknes Skagen Airport",
    },
    KTB: {
      airportCode: "KTB",
      city: "Thorne Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Thorne Bay Seaplane Base",
    },
    KHN: {
      airportCode: "KHN",
      city: "Nanchang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Changbei Intl",
    },
    TKS: {
      airportCode: "TKS",
      city: "Tokushima",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Tokushima Awaodori",
    },
    LGG: {
      airportCode: "LGG",
      city: "Liege",
      countryId: "BE",
      countryCode: "056",
      internationalAirportName: "Liege Airport",
    },
    WLE: {
      airportCode: "WLE",
      city: "Miles",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Miles Airport",
    },
    ALZ: {
      airportCode: "ALZ",
      city: "Alitak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Alitak Seaplane Base",
    },
    CTS: {
      airportCode: "CTS",
      city: "Sapporo",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "New Chitose",
    },
    GOT: {
      airportCode: "GOT",
      city: "Gothenborg",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Landvetter",
    },
    CYP: {
      airportCode: "CYP",
      city: "Calbayog City",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Calbayog Airport",
    },
    KEM: {
      airportCode: "KEM",
      city: "Kemi",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Kemi Tornio Airport",
    },
    KMO: {
      airportCode: "KMO",
      city: "Manokotak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Manokotak Airport",
    },
    NCE: {
      airportCode: "NCE",
      city: "Nice",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Cote D Azur",
    },
    PRG: {
      airportCode: "PRG",
      city: "Prague",
      countryId: "CZ",
      countryCode: "203",
      internationalAirportName: "Ruzyne",
    },
    MTT: {
      airportCode: "MTT",
      city: "Minatitlan",
      countryId: "MX",
      countryCode: "484",
      internationalAirportName: "Minatitlan",
    },
    AUU: {
      airportCode: "AUU",
      city: "Aurukun",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Aurukun Airport",
    },
    RNJ: {
      airportCode: "RNJ",
      city: "Yoron",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Yoron Airport",
    },
    PKX: {
      airportCode: "PKX",
      city: "Beijing",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Beijing Daxing International Airport",
    },
    HUS: {
      airportCode: "HUS",
      city: "Hughes",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hughes Municipal Airport",
    },
    LBA: {
      airportCode: "LBA",
      city: "Leeds",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Leeds Bradford",
    },
    KVX: {
      airportCode: "KVX",
      city: "Kirov",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Kirov Pobedilovo Airport",
    },
    AOS: {
      airportCode: "AOS",
      city: "Amook",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Amook Bay Seaplane Base",
    },
    RVK: {
      airportCode: "RVK",
      city: "Roervik",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Roervik Ryumsjoen Airport",
    },
    OSI: {
      airportCode: "OSI",
      city: "Osijek",
      countryId: "HR",
      countryCode: "191",
      internationalAirportName: "Osijek Airport",
    },
    SKX: {
      airportCode: "SKX",
      city: "Saransk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Saransk Airport",
    },
    CGQ: {
      airportCode: "CGQ",
      city: "Changchun",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Changchun Airport",
    },
    HSN: {
      airportCode: "HSN",
      city: "Zhoushan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Zhoushan Putuoshan Airport",
    },
    CUQ: {
      airportCode: "CUQ",
      city: "Coen",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Coen Airport",
    },
    LSI: {
      airportCode: "LSI",
      city: "Shetland Islands",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Sumburgh Airport",
    },
    GRV: {
      airportCode: "GRV",
      city: "Groznyy",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Grozny Airport",
    },
    SZZ: {
      airportCode: "SZZ",
      city: "Szczecin",
      countryId: "PL",
      countryCode: "616",
      internationalAirportName: "Szczecin Goleniow Solidarity Airport",
    },
    MDG: {
      airportCode: "MDG",
      city: "Mudanjiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Mudanjiang",
    },
    OAG: {
      airportCode: "OAG",
      city: "Orange",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Orange Airport",
    },
    DOH: {
      airportCode: "DOH",
      city: "Doha",
      countryId: "QA",
      countryCode: "634",
      internationalAirportName: "Doha Hamad International Airport",
    },
    VLC: {
      airportCode: "VLC",
      city: "Valencia",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Valencia Airport",
    },
    GDX: {
      airportCode: "GDX",
      city: "Magadan",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Magadan Sokol Airport",
    },
    AES: {
      airportCode: "AES",
      city: "Alesund",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Vigra",
    },
    DUS: {
      airportCode: "DUS",
      city: "Duesseldorf",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Dusseldorf Intl",
    },
    KMI: {
      airportCode: "KMI",
      city: "Miyazaki",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Miyazaki",
    },
    PES: {
      airportCode: "PES",
      city: "Petrozavodsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Petrozavodsk Besovets Airport",
    },
    KSJ: {
      airportCode: "KSJ",
      city: "Kasos Island",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kasos Island Airport",
    },
    UPG: {
      airportCode: "UPG",
      city: "Makassar",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Hasanuddin",
    },
    MLL: {
      airportCode: "MLL",
      city: "Marshall",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Marshall Don Hunter Sr. Airport",
    },
    YGX: {
      airportCode: "YGX",
      city: "Gillam",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Gillam Airport",
    },
    MLE: {
      airportCode: "MLE",
      city: "Male",
      countryId: "MV",
      countryCode: "462",
      internationalAirportName: "Male Intl",
    },
    NAV: {
      airportCode: "NAV",
      city: "Nevsehir",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Nevsehir Kapadokya Airport",
    },
    HFE: {
      airportCode: "HFE",
      city: "Hefei",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Xinqiao International Airport",
    },
    UUS: {
      airportCode: "UUS",
      city: "Yuzhno-Sakhalinsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Yuzhno-Sakhalinsk Airport",
    },
    PUF: {
      airportCode: "PUF",
      city: "Pau",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Pau Pyrenees Airport",
    },
    DCA: {
      airportCode: "DCA",
      city: "Washington",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Ronald Reagan Washington Natl",
    },
    YAT: {
      airportCode: "YAT",
      city: "Attawapiskat",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Attawapiskat Airport",
    },
    HPB: {
      airportCode: "HPB",
      city: "Hooper Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hooper Bay Airport",
    },
    VAS: {
      airportCode: "VAS",
      city: "Sivas",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Sivas Airport",
    },
    MOF: {
      airportCode: "MOF",
      city: "Maumere",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Frans Seda/Wai Oti",
    },
    AUA: {
      airportCode: "AUA",
      city: "Oranjestad",
      countryId: "AW",
      countryCode: "533",
      internationalAirportName: "Queen Beatrix International Airport",
    },
    SOF: {
      airportCode: "SOF",
      city: "Sofia",
      countryId: "BG",
      countryCode: "100",
      internationalAirportName: "Sofia Airport",
    },
    GRQ: {
      airportCode: "GRQ",
      city: "Groningen",
      countryId: "NL",
      countryCode: "528",
      internationalAirportName: "Groningen Airport Eelde",
    },
    WNP: {
      airportCode: "WNP",
      city: "Naga",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Naga Airport",
    },
    TKJ: {
      airportCode: "TKJ",
      city: "Tok",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Tok Junction Airport",
    },
    HCZ: {
      airportCode: "HCZ",
      city: "Chenzhou",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Chenzhou Beihu Airport",
    },
    SIQ: {
      airportCode: "SIQ",
      city: "Singkep",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dabo Airport",
    },
    KRB: {
      airportCode: "KRB",
      city: "Karumba",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Karumba Airport",
    },
    VTZ: {
      airportCode: "VTZ",
      city: "Visakhapatnam (Vizag)",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Visakhapatnam Int'l",
    },
    SYB: {
      airportCode: "SYB",
      city: "Seal Bay",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Seal Bay Seaplane Base",
    },
    IGT: {
      airportCode: "IGT",
      city: "Ordzhonikidzevskaya",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Magas Airport",
    },
    BRE: {
      airportCode: "BRE",
      city: "Bremen",
      countryId: "DE",
      countryCode: "276",
      internationalAirportName: "Bremen Airport",
    },
    COL: {
      airportCode: "COL",
      city: "Coll Island",
      countryId: "GB",
      countryCode: "826",
      internationalAirportName: "Coll Island Airport",
    },
    GAJ: {
      airportCode: "GAJ",
      city: "Yamagata",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Yamagata",
    },
    PTW: {
      airportCode: "PTW",
      city: "Potowaiburu",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Potowai",
    },
    PKZ: {
      airportCode: "PKZ",
      city: "Pakse",
      countryId: "LA",
      countryCode: "418",
      internationalAirportName: "Pakse International Airport",
    },
    DHX: {
      airportCode: "DHX",
      city: "Kediri",
      countryId: "ID",
      countryCode: "ID",
      internationalAirportName: "Dhoho International Airport",
    },
    SMX: {
      airportCode: "SMX",
      city: "Santa Maria",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Santa Maria Public Airport",
    },
    GMQ: {
      airportCode: "GMQ",
      city: "Golog",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Golog Maqin Airport",
    },
    CNJ: {
      airportCode: "CNJ",
      city: "Cloncurry",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Cloncurry Airport",
    },
    ERC: {
      airportCode: "ERC",
      city: "Erzincan",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Erzincan Airport",
    },
    TAE: {
      airportCode: "TAE",
      city: "Taegu",
      countryId: "KR",
      countryCode: "410",
      internationalAirportName: "Daegu International Airport",
    },
    YUT: {
      airportCode: "YUT",
      city: "Repulse Bay",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Naujaat Airport",
    },
    MCN: {
      airportCode: "MCN",
      city: "Macon",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Middle Georgia Regional Airport",
    },
    FGI: {
      airportCode: "FGI",
      city: "Apia",
      countryId: "WS",
      countryCode: "882",
      internationalAirportName: "Fagali'i Airport",
    },
    YIE: {
      airportCode: "YIE",
      city: "Arxan",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Arxan Yiershi Airport",
    },
    BJW: {
      airportCode: "BJW",
      city: "Bajawa",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Soa",
    },
    MEL: {
      airportCode: "MEL",
      city: "Melbourne",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Melbourne Intl",
    },
    KSY: {
      airportCode: "KSY",
      city: "Kars",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Kars Harakani Airport",
    },
    OTI: {
      airportCode: "OTI",
      city: "Morotai Island",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pitu",
    },
    AUR: {
      airportCode: "AUR",
      city: "Aurillac",
      countryId: "FR",
      countryCode: "250",
      internationalAirportName: "Aurillac Tronquieres Airport",
    },
    YGH: {
      airportCode: "YGH",
      city: "Fort Good Hope",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Fort Good Hope Airport",
    },
    ESB: {
      airportCode: "ESB",
      city: "Ankara",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Esenboga",
    },
    DYR: {
      airportCode: "DYR",
      city: "Anadyr",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Anadyr Ugolny Airport",
    },
    OUL: {
      airportCode: "OUL",
      city: "Oulu",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Oulu Airport",
    },
    GAL: {
      airportCode: "GAL",
      city: "Galena",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Edwarrd G Pitka Sr Airport",
    },
    IAN: {
      airportCode: "IAN",
      city: "Kiana",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Bob Baker Memorial Airport",
    },
    KKJ: {
      airportCode: "KKJ",
      city: "Kitakyushu",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kitakyushu Airport",
    },
    BLZ: {
      airportCode: "BLZ",
      city: "Blantyre",
      countryId: "MW",
      countryCode: "454",
      internationalAirportName: "Chileka International Airport",
    },
    WPL: {
      airportCode: "WPL",
      city: "Powell Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Powell Lake Seaplane Base",
    },
    KIJ: {
      airportCode: "KIJ",
      city: "Niigata",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Niigata",
    },
    MRB: {
      airportCode: "MRB",
      city: "Muara Bungo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pasir Mayang",
    },
    RXS: {
      airportCode: "RXS",
      city: "Roxas City",
      countryId: "PH",
      countryCode: "608",
      internationalAirportName: "Roxas Airport",
    },
    NNX: {
      airportCode: "NNX",
      city: "Nunukan",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Nunukan Airport",
    },
    SHE: {
      airportCode: "SHE",
      city: "Shenyang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Shenyang Taoxian Int'l Airport",
    },
    NKM: {
      airportCode: "NKM",
      city: "Nagoya",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Nagoya Airfield",
    },
    OPO: {
      airportCode: "OPO",
      city: "Porto",
      countryId: "PT",
      countryCode: "620",
      internationalAirportName: "Porto",
    },
    YUD: {
      airportCode: "YUD",
      city: "Umiujaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Umiujaq Airport",
    },
    ZEM: {
      airportCode: "ZEM",
      city: "East Main",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Eastmain River Airport",
    },
    TLI: {
      airportCode: "TLI",
      city: "Tolitoli",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Bantilan",
    },
    KLR: {
      airportCode: "KLR",
      city: "Kalmar",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Kalmar Oland Airport",
    },
    NYM: {
      airportCode: "NYM",
      city: "Nadym",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Nadym Airport",
    },
    LUX: {
      airportCode: "LUX",
      city: "Luxembourg",
      countryId: "LU",
      countryCode: "442",
      internationalAirportName: "Luxembourg Findel Airport",
    },
    YRB: {
      airportCode: "YRB",
      city: "Resolute",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Resolute Bay Airport",
    },
    RIL: {
      airportCode: "RIL",
      city: "Rifle",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Rifle Garfield County Airport",
    },
    HOU: {
      airportCode: "HOU",
      city: "Houston",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "William P Hobby",
    },
    TJG: {
      airportCode: "TJG",
      city: "Tanjung Warukin",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Warukin Airport",
    },
    OUA: {
      airportCode: "OUA",
      city: "Ouagadougou",
      countryId: "BF",
      countryCode: "854",
      internationalAirportName: "Ouagadougou Airport",
    },
    MAD: {
      airportCode: "MAD",
      city: "Madrid",
      countryId: "ES",
      countryCode: "724",
      internationalAirportName: "Barajas Airport",
    },
    MQM: {
      airportCode: "MQM",
      city: "Mardin",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Mardin Airport",
    },
    HYA: {
      airportCode: "HYA",
      city: "Hyannis",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Cape Cod Gateway Airport",
    },
    DOY: {
      airportCode: "DOY",
      city: "Dongying",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Dongying Shengli Airport",
    },
    DJB: {
      airportCode: "DJB",
      city: "Jambi",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sultan Thaha",
    },
    KVC: {
      airportCode: "KVC",
      city: "King Cove",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "King Cove Airport",
    },
    KLL: {
      airportCode: "KLL",
      city: "Levelock",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Levelock Airport",
    },
    AVV: {
      airportCode: "AVV",
      city: "Melbourne",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Avalon Airport",
    },
    GZT: {
      airportCode: "GZT",
      city: "Gaziantep",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Oguzeli Airport",
    },
    ITM: {
      airportCode: "ITM",
      city: "Osaka",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Osaka Intl",
    },
    ATK: {
      airportCode: "ATK",
      city: "Atqasuk",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Atqasuk Edward Burnell Sr Memorial Airport",
    },
    ASR: {
      airportCode: "ASR",
      city: "Kayseri",
      countryId: "TR",
      countryCode: "792",
      internationalAirportName: "Erkilet International Airport",
    },
    YVP: {
      airportCode: "YVP",
      city: "Kuujjuaq",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Kuujjuaq Airport",
    },
    WEI: {
      airportCode: "WEI",
      city: "Weipa",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Weipa Airport",
    },
    KPV: {
      airportCode: "KPV",
      city: "Perryville",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Perryville Airport",
    },
    ALH: {
      airportCode: "ALH",
      city: "Albany",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Albany Airport (Australia)",
    },
    VOG: {
      airportCode: "VOG",
      city: "Volgograd",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Volgograd International Airport",
    },
    NPE: {
      airportCode: "NPE",
      city: "Napier",
      countryId: "NZ",
      countryCode: "554",
      internationalAirportName: "Hawke's Bay Airport",
    },
    WHD: {
      airportCode: "WHD",
      city: "Hyder",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Hyder Seaplane Base",
    },
    TMH: {
      airportCode: "TMH",
      city: "Tanahmerah",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Tanahmerah Airport",
    },
    RMZ: {
      airportCode: "RMZ",
      city: "Tobolsk",
      countryId: "RU",
      countryCode: "643",
      internationalAirportName: "Tobolsk Remezov Airport",
    },
    KRP: {
      airportCode: "KRP",
      city: "Karup",
      countryId: "DK",
      countryCode: "208",
      internationalAirportName: "Karup Midtjyllands Airport",
    },
    SOC: {
      airportCode: "SOC",
      city: "Solo",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Adi Soemarmo",
    },
    AXT: {
      airportCode: "AXT",
      city: "Akita",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Akita",
    },
    WNN: {
      airportCode: "WNN",
      city: "Wunnummin Lake",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Wunnumin Lake Airport",
    },
    KCQ: {
      airportCode: "KCQ",
      city: "Chignik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Chignik Lake Airport",
    },
    YXX: {
      airportCode: "YXX",
      city: "Vancouver",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Abbotsford International Airport",
    },
    HQQ: {
      airportCode: "HQQ",
      city: "An Yang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Hong Qiqu Airport",
    },
    VDH: {
      airportCode: "VDH",
      city: "Dong Hoi",
      countryId: "VN",
      countryCode: "704",
      internationalAirportName: "Dong Hoi Airport",
    },
    SVJ: {
      airportCode: "SVJ",
      city: "Svolvaer",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Svolvaer Helle Airport",
    },
    ZRH: {
      airportCode: "ZRH",
      city: "Zurich",
      countryId: "CH",
      countryCode: "756",
      internationalAirportName: "Zurich Airport",
    },
    ODS: {
      airportCode: "ODS",
      city: "Odessa",
      countryId: "UA",
      countryCode: "804",
      internationalAirportName: "Odessa Intl",
    },
    YNP: {
      airportCode: "YNP",
      city: "Natuashish",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Natuashish Airport",
    },
    SHG: {
      airportCode: "SHG",
      city: "Shungnak",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Shungnak Airport",
    },
    HJJ: {
      airportCode: "HJJ",
      city: "Zhijiang",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Huaihua Zhijiang Airport",
    },
    SKO: {
      airportCode: "SKO",
      city: "Rantepao",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Seko",
    },
    WAA: {
      airportCode: "WAA",
      city: "Wales",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Wales Airport",
    },
    KSU: {
      airportCode: "KSU",
      city: "Kristiansund",
      countryId: "NO",
      countryCode: "578",
      internationalAirportName: "Kristiansund Kvernberget Airport",
    },
    BKK: {
      airportCode: "BKK",
      city: "Bangkok",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Suvarnabhumi Intl",
    },
    WLK: {
      airportCode: "WLK",
      city: "Selawik",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Selawik Airport",
    },
    PHX: {
      airportCode: "PHX",
      city: "Phoenix",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Phoenix Sky Harbor Intl",
    },
    JRO: {
      airportCode: "JRO",
      city: "Kilimanjaro",
      countryId: "TZ",
      countryCode: "834",
      internationalAirportName: "Kilimanjaro International Airport",
    },
    KIR: {
      airportCode: "KIR",
      city: "Kerry County",
      countryId: "IE",
      countryCode: "372",
      internationalAirportName: "Kerry Airport",
    },
    TTR: {
      airportCode: "TTR",
      city: "Tana Toraja",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Pongtiku",
    },
    RTG: {
      airportCode: "RTG",
      city: "Ruteng",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Frans Sales Lega/Satartacik",
    },
    RRZ: {
      airportCode: "RRZ",
      city: "Sibolga",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Dr. Ferdinand Lumban Tobing",
    },
    FLS: {
      airportCode: "FLS",
      city: "Flinders Island",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Flinders Island Airport",
    },
    BLR: {
      airportCode: "BLR",
      city: "Bangalore",
      countryId: "IN",
      countryCode: "356",
      internationalAirportName: "Bangalore Airport",
    },
    GZG: {
      airportCode: "GZG",
      city: "Ganzi",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Ganzi Gesaer Airport",
    },
    JNG: {
      airportCode: "JNG",
      city: "Jining",
      countryId: "CN",
      countryCode: "156",
      internationalAirportName: "Jining Qufu Airport",
    },
    YXY: {
      airportCode: "YXY",
      city: "Whitehorse",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Erik Nielsen Whitehorse International Airport",
    },
    LPT: {
      airportCode: "LPT",
      city: "Lampang",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Lampang Airport",
    },
    KSO: {
      airportCode: "KSO",
      city: "Kastoria",
      countryId: "GR",
      countryCode: "300",
      internationalAirportName: "Kastoria National Aristotelis Airport",
    },
    PQQ: {
      airportCode: "PQQ",
      city: "Port Macquarie",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Port Macquarie Airport",
    },
    TSE: {
      airportCode: "TSE",
      city: "Astana",
      countryId: "KZ",
      countryCode: "398",
      internationalAirportName: "Astana International Airport",
    },
    TMP: {
      airportCode: "TMP",
      city: "Tampere",
      countryId: "FI",
      countryCode: "246",
      internationalAirportName: "Tampere Pirkkala Airport",
    },
    RAQ: {
      airportCode: "RAQ",
      city: "Muna",
      countryId: "ID",
      countryCode: "360",
      internationalAirportName: "Sugimanuru",
    },
    TAY: {
      airportCode: "TAY",
      city: "Tartu",
      countryId: "EE",
      countryCode: "233",
      internationalAirportName: "Tartu Ulenurme Airport",
    },
    MJK: {
      airportCode: "MJK",
      city: "Monkey Mia",
      countryId: "AU",
      countryCode: "036",
      internationalAirportName: "Shark Bay Airport",
    },
    KGK: {
      airportCode: "KGK",
      city: "Koliganek",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Koliganek Airport",
    },
    GHV: {
      airportCode: "GHV",
      city: "Brasov",
      countryId: "RO",
      countryCode: "642",
      internationalAirportName: "Brasov Ghimbav Airport",
    },
    ARC: {
      airportCode: "ARC",
      city: "Arctic Village",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Arctic Village Airport",
    },
    LAL: {
      airportCode: "LAL",
      city: "Lakeland",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Lakeland Linder International Airport",
    },
    VDZ: {
      airportCode: "VDZ",
      city: "Valdez",
      countryId: "US",
      countryCode: "840",
      internationalAirportName: "Valdez Pioneer Field Airport",
    },
    YZZ: {
      airportCode: "YZZ",
      city: "Trail",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "Trail Airport",
    },
    VBY: {
      airportCode: "VBY",
      city: "Visby",
      countryId: "SE",
      countryCode: "752",
      internationalAirportName: "Visby Airport",
    },
    HKT: {
      airportCode: "HKT",
      city: "Phuket",
      countryId: "TH",
      countryCode: "764",
      internationalAirportName: "Phuket Intl",
    },
    KIX: {
      airportCode: "KIX",
      city: "Osaka",
      countryId: "JP",
      countryCode: "392",
      internationalAirportName: "Kansai",
    },
    YAY: {
      airportCode: "YAY",
      city: "Saint Anthony",
      countryId: "CA",
      countryCode: "124",
      internationalAirportName: "St Anthony Airport",
    },
  },
  areaAirportsMap: {
    MILA: "MXP|LIN",
    STO: "ARN|BMA|NYO",
    SALZ: "SZG|GRZ",
    RIO: "GIG",
    MOWA: "SVO|DME",
    XKLA: "SZB|KUL",
    OSLA: "TRF|OSL",
    WRW: "WAW|WMI",
    BUH: "OTP|BBU",
    TYOA: "HND|NRT",
    SEOA: "ICN|GMP",
    LONA: "LCY|LGW|LHR",
    SRIA: "AAP",
    ROM: "CIA|FCO",
    NEWA: "EWR|JFK|LGA",
    WASA: "IAD|DCA",
    QMI: "FLL|MIA",
    SPKA: "OKD|CTS",
    PARA: "ORY|CDG",
    ISTA: "SAW|IST",
    JKTA: "HLP|CGK",
    QSF: "SFO|SJC",
    TAIA: "TPE|TSA",
    SHAA: "SHA|PVG",
    YEA: "YEG",
    QDF: "DFW",
    YKIA: "YIA|JOG",
    DUBA: "DWC|DXB|XNB",
    QLA: "BUR|LAX",
    SAO: "GRU",
    HOUA: "IAH|HOU",
    REYA: "KEF|RKV",
    BKKA: "DMK|BKK",
    GLAA: "GLA",
    SRAA: "SRG|KJT",
    MACA: "MFM|XZM",
    YTO: "YYZ",
    BUE: "EZE|AEP",
    DTT: "DTW",
    SINA: "SIN",
    YMQ: "YUL",
    MELA: "MEL|AVV",
    OSAA: "ITM|KIX",
  },
};
